export const MasterType = {
  ORDERS: 'orders',
  W2_USER: 'w2_User',
  W2_USER_ATTRIBUTE: 'w2_UserAttribute',
  W2_MEMBER_RANK: 'w2_MemberRank',
  W2_ACCESS_LOG: 'w2_AccessLog',
  W2_PRODUCT: 'w2_Product',
  W2_PRODUCT_BRAND: 'w2_ProductBrand',
  W2_PRODUCT_CATEGORY: 'w2_ProductCategory',
  W2_PRODUCT_TAG: 'w2_ProductTag',
  W2_PRODUCT_TAG_SETTING: 'w2_ProductTagSetting',
  W2_PRODUCT_STOCK: 'w2_ProductStock',
  W2_PRODUCT_VARIATION: 'w2_ProductVariation',
  W2_PRODUCT_PRICE: 'w2_ProductPrice',
  W2_PRODUCT_LINK: 'w2_ProductLink',
  W2_CART: 'w2_Cart',
  W2_ORDER: 'w2_Order',
  W2_ORDER_ITEM: 'w2_OrderItem',
  W2_ORDER_COUPON: 'w2_OrderCoupon',
  W2_COUPON: 'w2_Coupon',
  W2_ADV_CODE: 'w2_AdvCode',
  W2_FEATURE_PAGE: 'w2_FeaturePage',
  W2_FEATURE_PAGE_CATEGORY: 'w2_FeaturePageCategory',
  W2_FEATURE_PAGE_CONTENTS: 'w2_FeaturePageContents',
  W2_PRODUCT_GROUP: 'w2_ProductGroup',
  W2_PRODUCT_GROUP_ITEM: 'w2_ProductGroupItem',
  W2_CONTENTS_TAG: 'w2_ContentsTag',
  W2_USER_POINT: 'w2_UserPoint',
  W2_USER_POINT_HISTORY: 'w2_UserPointHistory',
  W2_POINT_RULE: 'w2_PointRule',
  W2_POINT_RULE_SCHEDULE: 'w2_PointRuleSchedule',
  W2_USER_MEMBER_RANK_HISTORY: 'w2_UserMemberRankHistory',
  W2_MEMBER_RANK_RULE: 'w2_MemberRankRule',
  W2_ORDER_SHIPPING: 'w2_OrderShipping',
  W2_SHOP_SHIPPING: 'w2_ShopShipping',
  W2_SHOP_SHIPPING_ZONE: 'w2_ShopShippingZone',
  W2_SHOP_SHIPPING_SIZE_THRESHOLD: 'w2_ShopShippingSizeThreshold',
  W2_MAIL_DIST_SETTING: 'w2_MailDistSetting',
  W2_MAIL_DIST_SENT_USER: 'w2_MailDistSentUser',
  W2_MAIL_SEND_LOG: 'w2_MailSendLog',
  W2_MAIL_CLICK: 'w2_MailClick',
  W2_MAIL_CLICK_LOG: 'w2_MailClickLog',
  W2_ORDER_WORKFLOW_SCENARIO_SETTING: 'w2_OrderWorkflowScenarioSetting',
  W2_NOVELTY: 'w2_Novelty',
  W2_NOVELTY_GRANT_CONDITIONS: 'w2_NoveltyGrantConditions',
  W2_NOVELTY_GRANT_ITEM: 'w2_NoveltyGrantItem',
  W2_NOVELTY_TARGET_ITEM: 'w2_NoveltyTargetItem',
  W2_ORDER_SET_PROMOTION: 'w2_OrderSetPromotion',
  W2_ORDER_SET_PROMOTION_ITEM: 'w2_OrderSetPromotionItem',
  W2_SET_PROMOTION: 'w2_SetPromotion',
  W2_SET_PROMOTION_ITEM: 'w2_SetPromotionItem',
  W2_PRODUCT_BUNDLE: 'w2_ProductBundle',
  W2_PRODUCT_BUNDLE_ITEM: 'w2_ProductBundleItem',
  W2_PRODUCT_SET: 'w2_ProductSet',
  W2_PRODUCT_SET_ITEM: 'w2_ProductSetItem',
  W2_PRODUCT_SALE: 'w2_ProductSale',
  W2_PRODUCT_SALE_PRICE: 'w2_ProductSalePrice',
  W2_FIXED_PURCHASE: 'w2_FixedPurchase',
  W2_FIXED_PURCHASE_ITEM: 'w2_FixedPurchaseItem',
  W2_FIXED_PURCHASE_HISTORY: 'w2_FixedPurchaseHistory',
  W2_FIXED_PURCHASE_CANCEL_REASON: 'w2_FixedPurchaseCancelReason',
  W2_USER_COUPON: 'w2_UserCoupon',
  W2_USER_COUPON_HISTORY: 'w2_UserCouponHistory',
  W2_COUPON_USE_USER: 'w2_CouponUseUser',
  W2_COUPON_SCHEDULE: 'w2_CouponSchedule',
  W2_ADV_CODE_LOG: 'w2_AdvCodeLog',
  W2_ADV_CODE_MEDIA_TYPE: 'w2_AdvCodeMediaType',
  W2_USER_ACTIVITY: 'w2_UserActivity',
  W2_AB_TEST: 'w2_AbTest',
  W2_AB_TEST_ITEM: 'w2_AbTestItem',
  // CMS系（add-w2-cms-master-tables で追加）
  W2_PAGE_DESIGN: 'w2_PageDesign',
  W2_PAGE_DESIGN_GROUP: 'w2_PageDesignGroup',
  W2_PARTS_DESIGN: 'w2_PartsDesign',
  W2_PARTS_DESIGN_GROUP: 'w2_PartsDesignGroup',
  W2_FEATURE_AREA: 'w2_FeatureArea',
  W2_FEATURE_AREA_BANNER: 'w2_FeatureAreaBanner',
  W2_POPUP: 'w2_Popup',
  W2_POPUP_DISPLAY_PAGE_SETTING: 'w2_PopupDisplayPageSetting',
  W2_POPUP_REPORT: 'w2_PopupReport',
  // 拡張マスタ（add-w2-ex-product-spec で追加）。W2 標準に無い案件カスタマイズのテーブル
  W2_EX_PRODUCT_SPEC: 'w2_ExProductSpec',
  W2_EX_PRODUCT_VARIATION_SPEC: 'w2_ExProductVariationSpec'
}

export type MasterType = (typeof MasterType)[keyof typeof MasterType]

export interface W2User {
  user_id: number
  user_kbn: string
  mall_id: string
  name: string
  name1: string
  name2: string
  name_kana: string
  name_kana1: string
  name_kana2: string
  nick_name: string
  mail_addr: string
  zip: string
  zip1: string
  zip2: string
  addr: string
  addr1: string
  addr2: string
  addr3: string
  addr4: string
  addr5: string
  addr_country_iso_code: string
  addr_country_name: string
  tel1: string
  tel1_1: string
  tel1_2: string
  tel1_3: string
  tel2: string
  tel2_1: string
  tel2_2: string
  tel2_3: string
  tel3: string
  tel3_1: string
  tel3_2: string
  tel3_3: string
  fax: string
  fax_1: string
  fax_2: string
  fax_3: string
  sex: string
  birth: string
  birth_year: string
  birth_month: string
  birth_day: string
  company_name: string
  company_post_name: string
  company_exective_name: string
  advcode_first: string
  attribute1: string
  attribute2: string
  attribute3: string
  attribute4: string
  attribute5: string
  attribute6: string
  attribute7: string
  attribute8: string
  attribute9: string
  attribute10: string
  login_id: string
  password: string
  question: string
  answer: string
  remote_addr: string
  mail_flg: boolean
  user_memo: string
  del_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  member_rank_id: string
  recommend_uid: string
  date_last_loggedin: string
  user_management_level_id: string
  integrated_flg: boolean
  easy_register_flg: boolean
  fixed_purchase_member_flg: boolean
  access_country_iso_code: string
  disp_language_code: string
  disp_language_locale_id: string
  disp_currency_code: string
  disp_currency_locale_id: string
  last_birthday_point_add_year: string
  last_birthday_coupon_publish_year: string
  order_count_order_realtime: number
  order_count_old: number
  referral_code: string
  referred_user_id: number
  real_shop_id: string
  order_count_realshop_realtime: number
  date_withdrawal: string
}

export interface W2UserAttribute {
  user_id: number
  first_order_date: string
  second_order_date: string
  last_order_date: string
  enrollment_days: number
  away_days: number
  order_amount_order_all: number
  order_amount_order_fp: number
  order_count_order_all: number
  order_count_order_fp: number
  order_amount_ship_all: number
  order_amount_ship_fp: number
  order_count_ship_all: number
  order_count_ship_fp: number
  date_created: string
  date_changed: string
  last_changed: string
  cpm_cluster_attribute1: string
  cpm_cluster_attribute2: string
  cpm_cluster_id: string
  cpm_cluster_attribute1_before: string
  cpm_cluster_attribute2_before: string
  cpm_cluster_id_before: string
  cpm_cluster_changed_date: string
}

export interface W2MemberRank {
  member_rank_id: string
  member_rank_order: number
  member_rank_name: string
  order_discount_type: string
  order_discount_value: number
  order_discount_threshold_price: number
  point_add_type: string
  point_add_value: number
  shipping_discount_type: string
  shipping_discount_value: number
  default_member_rank_setting_flg: boolean
  valid_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  member_rank_memo: string
  fixed_purchase_discount_rate: number
}

export interface W2AccessLog {
  log_no: number
  access_date: string
  access_time: string
  client_ip: string
  server_name: string
  server_ip: string
  server_port: number
  protocol_status: string
  user_agent: string
  url_domain: string
  url_page: string
  url_param: string
  dept_id: string
  account_id: string
  access_user_id: number
  session_id: string
  real_user_id: number
  access_interval: number
  first_login_flg: boolean
  referrer_domain: string
  referrer_page: string
  referrer_param: string
  search_engine: string
  search_words: string
  action_kbn: string
  s1: string
  s2: string
  s3: string
  s4: string
  s5: string
  s6: string
  s7: string
  s8: string
  s9: string
  s10: string
  s11: string
  s12: string
  s13: string
  s14: string
  s15: string
  s16: string
  s17: string
  s18: string
  s19: string
  s20: string
  p1: string
  p2: string
  p3: string
  p4: string
  p5: string
  p6: string
  p7: string
  p8: string
  p9: string
  p10: string
  p11: string
  p12: string
  p13: string
  p14: string
  p15: string
  p16: string
  p17: string
  p18: string
  p19: string
  p20: string
  user_agent_kbn: string
}

export interface W2Product {
  shop_id: number
  supplier_id: number
  product_id: number
  cooperation_id1: string
  cooperation_id2: string
  cooperation_id3: string
  cooperation_id4: string
  cooperation_id5: string
  cooperation_id6: string
  cooperation_id7: string
  cooperation_id8: string
  cooperation_id9: string
  cooperation_id10: string
  mall_ex_product_id: string
  maker_id: string
  maker_name: string
  name: string
  name_kana: string
  name2: string
  name2_kana: string
  catchcopy: string
  outline_kbn: string
  outline: string
  desc_detail_kbn1: string
  desc_detail1: string
  desc_detail_kbn2: string
  desc_detail2: string
  desc_detail_kbn3: string
  desc_detail3: string
  desc_detail_kbn4: string
  desc_detail4: string
  return_exchange_message: string
  note: string
  display_price: number
  display_special_price: number
  tax_included_flg: boolean
  tax_rate: number
  tax_round_type: string
  price_pretax: number
  price_shipping: number
  shipping_type: string
  shipping_size_kbn: string
  price_cost: number
  point_kbn1: string
  point1: number
  point_kbn2: string
  point2: number
  point_kbn3: string
  point3: number
  campaign_from: string
  campaign_to: string
  campaign_point_kbn: string
  campaign_point: number
  display_from: string
  display_to: string
  sell_from: string
  sell_to: string
  before_sale_display_kbn: string
  after_sale_display_kbn: string
  max_sell_quantity: number
  stock_management_kbn: string
  stock_disp_kbn: string
  stock_message_id: string
  url: string
  inquire_email: string
  inquire_tel: string
  display_kbn: string
  category_id1: number
  category_id2: number
  category_id3: number
  category_id4: number
  category_id5: number
  related_product_id_cs1: string
  related_product_id_cs2: string
  related_product_id_cs3: string
  related_product_id_cs4: string
  related_product_id_cs5: string
  related_product_id_us1: string
  related_product_id_us2: string
  related_product_id_us3: string
  related_product_id_us4: string
  related_product_id_us5: string
  image_head: string
  icon_flg1: boolean
  icon_term_end1: string
  icon_flg2: boolean
  icon_term_end2: string
  icon_flg3: boolean
  icon_term_end3: string
  icon_flg4: boolean
  icon_term_end4: string
  icon_flg5: boolean
  icon_term_end5: string
  icon_flg6: boolean
  icon_term_end6: string
  icon_flg7: boolean
  icon_term_end7: string
  icon_flg8: boolean
  icon_term_end8: string
  icon_flg9: boolean
  icon_term_end9: string
  icon_flg10: boolean
  icon_term_end10: string
  use_variation_flg: boolean
  reservation_flg: boolean
  fixed_purchase_flg: boolean
  mall_cooperated_flg: boolean
  valid_flg: boolean
  del_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  search_keyword: string
  member_rank_discount_flg: boolean
  display_member_rank: string
  buyable_member_rank: string
  google_shopping_flg: boolean
  product_option_settings: string
  arrival_mail_valid_flg: boolean
  release_mail_valid_flg: boolean
  resale_mail_valid_flg: boolean
  select_variation_kbn: string
  brand_id1: number
  brand_id2: number
  brand_id3: number
  brand_id4: number
  brand_id5: number
  use_recommend_flg: boolean
  gift_flg: boolean
  age_limit_flg: boolean
  plural_shipping_price_free_flg: boolean
  digital_contents_flg: boolean
  download_url: string
  display_sell_flg: boolean
  display_priority: number
  limited_payment_ids: string
  fixed_purchase_firsttime_price: number
  fixed_purchase_price: number
  bundle_item_display_type: string
  product_type: string
  limited_fixed_purchase_kbn1_setting: string
  limited_fixed_purchase_kbn3_setting: string
  recommend_product_id: string
  fixed_purchase_product_order_limit_flg: boolean
  andmall_reservation_flg: boolean
  product_color_id: string
  display_only_fixed_purchase_member_flg: boolean
  sell_only_fixed_purchase_member_flg: boolean
  product_weight_gram: number
  tax_category_id: string
  product_order_limit_flg_fp: boolean
  fixed_purchase_cancelable_count: number
  fixed_purchase_limited_user_level_ids: string
  fixed_purchase_next_shipping_product_id: string
  fixed_purchase_next_shipping_variation_id: string
  fixed_purchase_next_shipping_item_quantity: number
  fixed_purchase_limited_skipped_count: number
  next_shipping_item_fixed_purchase_kbn: string
  next_shipping_item_fixed_purchase_setting: string
  product_size_factor: number
  add_cart_url_limit_flg: boolean
  limited_fixed_purchase_kbn4_setting: string
  medicine_classification: string
  pos_cooperation_id: string
  temperature_zones: string
  slug: string
}

export interface W2ProductBrand {
  brand_id: number
  brand_name: string
  brand_title: string
  additional_design_tag: string
  seo_keyword: string
  default_flg: boolean
  valid_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductCategory {
  shop_id: number
  category_id: number
  parent_category_id: number
  name: string
  url: string
  valid_flg: boolean
  del_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  permitted_brand_ids: string
  use_recommend_flg: boolean
  member_rank_id: string
  lower_member_can_display_tree_flg: boolean
  name_kana: string
  display_order: number
  child_category_sort_kbn: string
  only_fixed_purchase_member_flg: boolean
  canonical_text: string
  slug: string
}

export interface W2ProductTag {
  product_id: number
  date_created: string
  date_changed: string
  last_changed: string
}

// 商品タグ設定マスター（add-w2-product-tag-setting で追加）
// **W2ProductTag の列名の定義**。ここで作った tag_id が w2_ProductTag の列名になる
// バックエンドは全列を Text で保持するため、日時も含めて文字列で受け取る
export interface W2ProductTagSetting {
  tag_no: string
  tag_id: string
  tag_name: string
  tag_discription: string
  tag_valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductStock {
  shop_id: number
  product_id: number
  variation_id: string
  stock: number
  stock_alert: number
  realstock: number
  realstock_b: number
  realstock_c: number
  realstock_reserved: number
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductVariation {
  shop_id: string
  product_id: string
  variation_id: string
  variation_cooperation_id1: string
  variation_cooperation_id2: string
  variation_cooperation_id3: string
  variation_cooperation_id4: string
  variation_cooperation_id5: string
  mall_variation_id1: string
  mall_variation_id2: string
  mall_variation_type: string
  variation_name1: string
  variation_name2: string
  variation_name3: string
  price: string
  special_price: string
  variation_image_head: string
  shipping_type: string
  shipping_size_kbn: string
  display_order: string
  variation_mall_cooperated_flg: string
  valid_flg: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  variation_download_url: string
  variation_fixed_purchase_firsttime_price: string
  variation_fixed_purchase_price: string
  variation_cooperation_id6: string
  variation_cooperation_id7: string
  variation_cooperation_id8: string
  variation_cooperation_id9: string
  variation_cooperation_id10: string
  variation_color_id: string
  variation_andmall_reservation_flg: string
  variation_weight_gram: string
  variation_add_cart_url_limit_flg: string
  variation_pos_cooperation_id: string
}

export interface W2ProductPrice {
  shop_id: string
  product_id: string
  variation_id: string
  member_rank_id: string
  member_rank_price: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2Cart {
  cart_id: number
  cart_item_no: number
  user_id: number
  shop_id: number
  supplier_id: number
  product_id: number
  variation_id: string
  product_count: number
  product_set_id: number
  product_set_no: number
  product_set_count: number
  cart_div_type1: string
  cart_div_type2: string
  cart_div_type3: string
  kbn1: string
  kbn2: string
  kbn3: string
  productsale_id: string
  fixed_purchase_flg: boolean
  del_flg: boolean
  date_created: string
  date_changed: string
  product_option_texts: string
  gift_order_flg: boolean
  novelty_id: string
  recommend_id: string
}

export interface W2Order {
  order_id: number
  order_id_org: number
  order_group_id: number
  order_no: string
  user_id: number
  shop_id: number
  supplier_id: number
  order_kbn: string
  mall_id: string
  order_payment_kbn: string
  order_status: string
  order_date: string
  order_recognition_date: string
  order_stockreserved_status: string
  order_stockreserved_date: string
  order_shipping_date: string
  order_shipped_status: string
  order_shipped_date: string
  order_delivering_date: string
  order_cancel_date: string
  order_return_date: string
  order_payment_status: string
  order_payment_date: string
  demand_status: string
  demand_date: string
  order_return_exchange_status: string
  order_repayment_status: string
  order_item_count: number
  order_product_count: number
  order_price_subtotal: number
  order_price_tax: number
  order_price_shipping: number
  order_price_exchange: number
  order_price_regulation: number
  order_price_repayment: number
  order_price_total: number
  order_point_use: number
  order_point_use_yen: number
  order_point_add: number
  order_coupon_use: number
  card_kbn: string
  card_tran_id: string
  shipping_id: number
  fixed_purchase_id: number
  advcode_first: string
  advcode_new: string
  return_exchange_kbn: string
  del_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  member_rank_id: string
  gift_flg: boolean
  external_payment_status: string
  payment_order_id: string
  external_order_id: string
  settlement_currency: string
  real_shop_id: string
  staff_id: string
}

export interface W2OrderItem {
  order_id: number
  order_item_no: number
  order_shipping_no: number
  shop_id: number
  product_id: number
  variation_id: string
  supplier_id: string
  product_name: string
  product_name_kana: string
  product_price: number
  product_price_org: number
  product_point: number
  product_tax_included_flg: boolean
  product_tax_rate: number
  product_tax_round_type: string
  product_price_pretax: number
  product_price_ship: number
  product_price_cost: number
  product_point_kbn: string
  item_realstock_reserved: number
  item_realstock_shipped: number
  item_quantity: number
  item_quantity_single: number
  item_price: number
  item_price_single: number
  product_set_id: number
  product_set_no: number
  product_set_count: number
  item_return_exchange_kbn: string
  item_memo: string
  item_point: number
  item_cancel_flg: boolean
  item_cancel_date: string
  item_return_flg: boolean
  item_return_date: string
  del_flg: boolean
  date_created: string
  date_changed: string
  product_option_texts: string
  brand_id: number
  download_url: string
  productsale_id: string
  cooperation_id1: string
  cooperation_id2: string
  cooperation_id3: string
  cooperation_id4: string
  cooperation_id5: string
  cooperation_id6: string
  cooperation_id7: string
  cooperation_id8: string
  cooperation_id9: string
  cooperation_id10: string
  stock_returned_flg: boolean
  novelty_id: string
  recommend_id: string
  fixed_purchase_product_flg: boolean
  product_bundle_id: string
  bundle_item_display_type: string
  order_history_display_type: string
  limited_payment_ids: string
  plural_shipping_price_free_flg: boolean
  shipping_size_kbn: string
  column_for_mall_order: string
  gift_wrapping_id: string
  gift_message: string
  item_price_tax: number
  fixed_purchase_discount_value: string
  fixed_purchase_discount_type: string
  fixed_purchase_item_order_count: number
  fixed_purchase_item_shipped_count: number
  item_discounted_price: number
  temperature_zones: string
}

export interface W2OrderCoupon {
  order_id: number
  order_coupon_no: number
  dept_id: string
  coupon_id: number
  coupon_no: number
  coupon_code: string
  coupon_name: string
  coupon_disp_name: string
  coupon_type: string
  coupon_discount_price: number
  coupon_discount_rate: number
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2Coupon {
  dept_id: string
  coupon_id: number
  coupon_code: string
  coupon_name: string
  coupon_disp_name: string
  coupon_discription: string
  coupon_type: string
  coupon_count: number
  publish_date_bgn: string
  publish_date_end: string
  discount_price: number
  discount_rate: number
  expire_day: number
  expire_date_bgn: string
  expire_date_end: string
  product_kbn: string
  exceptional_product: string
  exceptional_icon: string
  usable_price: number
  use_together_flg: boolean
  valid_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  disp_flg: boolean
  coupon_disp_discription: string
  exceptional_brand_ids: string
  exceptional_product_category_ids: string
  free_shipping_flg: boolean
  applicable_product: string
  applicable_brand_ids: string
  applicable_product_category_ids: string
  applicable_icon: string
  applicable_condition_operator: string
}

export interface W2AdvCode {
  advcode_no: number
  dept_id: string
  advertisement_code: string
  media_name: string
  valid_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
  advertisement_date: string
  media_cost: number
  memo: string
  publication_date_from: string
  publication_date_to: string
  advcode_media_type_id: string
  member_rank_id_granted_at_account_registration: string
  user_management_level_id_granted_at_account_registration: string
}

export interface W2FeaturePage {
  feature_page_id: number
  management_title: string
  page_type: string
  category_id: number
  permitted_brand_ids: string
  file_name: string
  file_dir_path: string
  page_sort_number: number
  use_type: string
  publish: boolean
  condition_publish_date_from: string
  condition_publish_date_to: string
  condition_member_only_type: string
  condition_member_rank_id: string
  condition_target_list_type: string
  condition_target_list_ids: string
  date_created: string
  date_changed: string
  last_changed: string
  metadata_desc: string
  html_page_title: string
  sitemap_include: boolean
  sitemap_changefreq: string
  sitemap_priority: number
}

export interface W2FeaturePageCategory {
  shop_id: number
  category_id: number
  parent_category_id: number
  category_name: string
  category_outline: string
  display_order: number
  valid_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2FeaturePageContents {
  feature_page_id: number
  contents_kbn: string
  contents_type: string
  contents_sort_number: number
  page_title: string
  alt_text: string
  product_group_id: number
  product_list_title: string
  display_number: number
  pagination_flg: boolean
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductGroup {
  product_group_id: number
  product_group_name: string
  begin_date: string
  end_date: string
  valid_flg: boolean
  product_group_page_contents_kbn: string
  product_group_page_contents: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductGroupItem {
  product_group_id: number
  item_no: number
  item_type: string
  shop_id: number
  master_id: string
  date_created: string
  last_changed: string
}

export interface W2ContentsTag {
  contents_tag_id: number
  contents_tag_name: string
  date_created: string
  date_changed: string
}

export interface W2ProductLink {
  shop_id: number
  product_id: number
  image_url: string
  product_url: string
}

// === 拡張マスタ（add-w2-ex-product-spec で追加） ===
// 商品追加情報（W2: kpp_ProductSpec）。1 商品×スペック種別ごとに値を 1 行で持つ縦持ち
// バックエンドは全列を Text で保持するため、日時も含めて文字列で受け取る
export interface W2ExProductSpec {
  shop_id: string
  product_id: string
  spec_no: string
  spec_type: string
  spec_value: string
  date_created: string
  date_changed: string
  last_changed: string
}

// 商品バリエーション追加情報（W2: kpp_ProductVariationSpec）。1 バリエーション×スペック種別ごとに 1 行
export interface W2ExProductVariationSpec {
  shop_id: string
  product_id: string
  variation_id: string
  spec_no: string
  spec_type: string
  spec_value: string
  date_created: string
  date_changed: string
  last_changed: string
}

// === 施策系マスタ（add-w2-marketing-master-tables） ===
export interface W2UserPoint {
  user_id: string
  point_kbn: string
  point_kbn_no: string
  dept_id: string
  point_rule_id: string
  point_rule_kbn: string
  point_type: string
  point_inc_kbn: string
  point: string
  point_exp: string
  history_no: string
  kbn1: string
  kbn2: string
  kbn3: string
  kbn4: string
  kbn5: string
  date_created: string
  date_changed: string
  last_changed: string
  effective_date: string
}

export interface W2UserPointHistory {
  user_id: string
  history_no: string
  tgt_year: string
  tgt_month: string
  tgt_day: string
  dept_id: string
  point_rule_id: string
  point_rule_kbn: string
  point_kbn: string
  point_type: string
  point_inc_kbn: string
  point_inc: string
  point_exp_extend: string
  user_point_exp: string
  kbn1: string
  kbn2: string
  kbn3: string
  kbn4: string
  kbn5: string
  memo: string
  date_created: string
  last_changed: string
  effective_date: string
  restored_flg: string
  history_group_no: string
}

export interface W2PointRule {
  dept_id: string
  point_rule_id: string
  point_rule_name: string
  point_rule_kbn: string
  point_kbn: string
  use_temp_flg: string
  point_inc_kbn: string
  inc_type: string
  inc_num: string
  inc_rate: string
  point_exp_extend: string
  exp_bgn: string
  exp_end: string
  campaign_term_kbn: string
  campaign_term_value: string
  priority: string
  valid_flg: string
  kbn1: string
  kbn2: string
  kbn3: string
  kbn4: string
  kbn5: string
  date_created: string
  date_changed: string
  last_changed: string
  point_rule_disp_name: string
  fixed_purchase_inc_type: string
  fixed_purchase_inc_num: string
  fixed_purchase_inc_rate: string
  effective_offset: string
  effective_offset_type: string
  term: string
  term_type: string
  period_begin: string
  period_end: string
  allow_duplicate_apply_flg: string
}

export interface W2PointRuleSchedule {
  point_rule_schedule_id: string
  point_rule_schedule_name: string
  status: string
  last_count: string
  last_exec_date: string
  target_id: string
  target_extract_flg: string
  point_rule_id: string
  mail_id: string
  exec_timing: string
  schedule_kbn: string
  schedule_day_of_week: string
  schedule_year: string
  schedule_month: string
  schedule_day: string
  schedule_hour: string
  schedule_minute: string
  schedule_second: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2UserMemberRankHistory {
  history_no: string
  user_id: string
  before_rank_id: string
  after_rank_id: string
  mail_id: string
  changed_by: string
  date_created: string
}

export interface W2MemberRankRule {
  member_rank_rule_id: string
  member_rank_rule_name: string
  status: string
  last_count: string
  last_exec_date: string
  target_extract_type: string
  target_extract_start: string
  target_extract_end: string
  target_extract_days_ago: string
  target_extract_total_price_from: string
  target_extract_total_price_to: string
  target_extract_total_count_from: string
  target_extract_total_count_to: string
  target_extract_old_rank_flg: string
  rank_change_type: string
  rank_change_rank_id: string
  mail_id: string
  exec_timing: string
  schedule_kbn: string
  schedule_day_of_week: string
  schedule_year: string
  schedule_month: string
  schedule_day: string
  schedule_hour: string
  schedule_minute: string
  schedule_second: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  target_id: string
  target_extract_flg: string
  target_id2: string
  target_extract_flg2: string
  target_id3: string
  target_extract_flg3: string
  target_id4: string
  target_extract_flg4: string
  target_id5: string
  target_extract_flg5: string
}

export interface W2OrderShipping {
  order_id: string
  order_shipping_no: string
  shipping_name: string
  shipping_name_kana: string
  shipping_zip: string
  shipping_addr1: string
  shipping_addr2: string
  shipping_addr3: string
  shipping_addr4: string
  shipping_tel1: string
  shipping_tel2: string
  shipping_tel3: string
  shipping_fax: string
  shipping_company: string
  shipping_date: string
  shipping_time: string
  shipping_check_no: string
  del_flg: string
  date_created: string
  date_changed: string
  shipping_name1: string
  shipping_name2: string
  shipping_name_kana1: string
  shipping_name_kana2: string
  sender_name: string
  sender_name1: string
  sender_name2: string
  sender_name_kana: string
  sender_name_kana1: string
  sender_name_kana2: string
  sender_zip: string
  sender_addr1: string
  sender_addr2: string
  sender_addr3: string
  sender_addr4: string
  sender_tel1: string
  wrapping_paper_type: string
  wrapping_paper_name: string
  wrapping_bag_type: string
  shipping_company_name: string
  shipping_company_post_name: string
  sender_company_name: string
  sender_company_post_name: string
  private_shipping_flg: string
  another_shipping_flg: string
  shipping_method: string
  delivery_company_id: string
  shipping_country_iso_code: string
  shipping_country_name: string
  shipping_addr5: string
  sender_country_iso_code: string
  sender_country_name: string
  sender_addr5: string
  scheduled_shipping_date: string
  external_shipping_cooperation_id: string
  shipping_receiving_store_flg: string
  shipping_receiving_store_id: string
  shipping_external_deliverty_status: string
  shipping_status: string
  shipping_status_update_date: string
  shipping_receiving_mail_date: string
  shipping_receiving_store_type: string
  shipping_status_code: string
  shipping_office_name: string
  shipping_handy_time: string
  shipping_current_status: string
  shipping_status_detail: string
  shipping_temperature_zone: string
  order_shipping_id: string
  order_shipping_status: string
  order_shipping_arranged_date: string
  order_shipping_completed_date: string
  wrapping_paper_flg: string
  wrapping_paper_title: string
  wrapping_paper_name_style: string
  wrapping_paper_placement: string
}

export interface W2ShopShipping {
  shop_id: string
  shipping_id: string
  shop_shipping_name: string
  payment_relation_id: string
  shipping_price_kbn: string
  shipping_date_set_flg: string
  shipping_date_set_begin: string
  shipping_date_set_end: string
  shipping_time_set_flg: string
  shipping_time_id1: string
  shipping_time_message1: string
  shipping_time_id2: string
  shipping_time_message2: string
  shipping_time_id3: string
  shipping_time_message3: string
  shipping_time_id4: string
  shipping_time_message4: string
  shipping_time_id5: string
  shipping_time_message5: string
  shipping_time_id6: string
  shipping_time_message6: string
  shipping_time_id7: string
  shipping_time_message7: string
  shipping_time_id8: string
  shipping_time_message8: string
  shipping_time_id9: string
  shipping_time_message9: string
  shipping_time_id10: string
  shipping_time_message10: string
  shipping_free_price_flg: string
  shipping_free_price: string
  announce_free_shipping_flg: string
  calculation_plural_kbn: string
  plural_shipping_price: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  fixed_purchase_flg: string
  fixed_purchase_kbn1_flg: string
  fixed_purchase_kbn1_setting: string
  fixed_purchase_kbn2_flg: string
  fixed_purchase_kbn2_setting: string
  fixed_purchase_kbn3_flg: string
  fixed_purchase_kbn3_setting: string
  fixed_purchase_order_entry_timing: string
  fixed_purchase_cancel_deadline: string
  wrapping_paper_flg: string
  wrapping_paper_types: string
  wrapping_bag_flg: string
  wrapping_bag_types: string
  payment_selection_flg: string
  permitted_payment_ids: string
  fixed_purchase_shipping_days_required: string
  fixed_purchase_minimum_shipping_span: string
  fixed_purchase_free_shipping_flg: string
  business_days_for_shipping: string
  next_shipping_max_change_days: string
  fixed_purchase_shipping_notdisplay_flg: string
  fixed_purchase_kbn4_flg: string
  fixed_purchase_kbn4_setting1: string
  fixed_purchase_kbn4_setting2: string
  fixed_purchase_kbn1_setting2: string
  shipping_date_required_flg: string
  wrapping_papers: string
  wrapping_bags: string
}

export interface W2ShopShippingZone {
  shop_id: string
  shipping_id: string
  delivery_company_id: string
  shipping_zone_no: string
  shipping_zone_name: string
  zip: string
  size_xxs_shipping_price: string
  size_xs_shipping_price: string
  size_s_shipping_price: string
  size_m_shipping_price: string
  size_l_shipping_price: string
  size_xl_shipping_price: string
  size_xxl_shipping_price: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  size_mail_shipping_price: string
  conditional_shipping_price_threshold: string
  conditional_shipping_price: string
  unavailable_shipping_area_flg: string
  shipping_temperature_zone: string
}

export interface W2ShopShippingSizeThreshold {
  shop_id: string
  shipping_id: string
  delivery_company_id: string
  size_xxs_threshold: string
  size_xs_threshold: string
  size_s_threshold: string
  size_m_threshold: string
  size_l_threshold: string
  size_xl_threshold: string
  size_xxl_threshold: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2MailDistSetting {
  dept_id: string
  maildist_id: string
  maildist_name: string
  status: string
  last_count: string
  last_errorexcept_count: string
  last_dist_date: string
  target_id: string
  target_extract_flg: string
  target_id2: string
  target_extract_flg2: string
  target_id3: string
  target_extract_flg3: string
  target_id4: string
  target_extract_flg4: string
  target_id5: string
  target_extract_flg5: string
  except_error_point: string
  mailtext_id: string
  exec_timing: string
  schedule_kbn: string
  schedule_day_of_week: string
  schedule_year: string
  schedule_month: string
  schedule_day: string
  schedule_hour: string
  schedule_minute: string
  schedule_second: string
  valid_flg: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2MailDistSentUser {
  maildist_id: string
  user_id: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2MailSendLog {
  log_no: string
  user_id: string
  dept_id: string
  mailtext_id: string
  mailtext_name: string
  maildist_id: string
  maildist_name: string
  shop_id: string
  mail_id: string
  mail_name: string
  mail_from_name: string
  mail_from: string
  mail_to: string
  mail_cc: string
  mail_bcc: string
  mail_subject: string
  mail_body: string
  mail_body_html: string
  error_message: string
  date_send_mail: string
  date_created: string
  read_flg: string
  date_read_mail: string
  mail_addr_kbn: string
}

export interface W2MailClick {
  dept_id: string
  mailtext_id: string
  maildist_id: string
  action_no: string
  mailclick_id: string
  mailclick_url: string
  mailclick_key: string
  valid_flg: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  mail_body_type: string
}

export interface W2MailClickLog {
  log_no: string
  dept_id: string
  mailtext_id: string
  maildist_id: string
  action_no: string
  mailclick_id: string
  user_id: string
  date_created: string
}

export interface W2OrderWorkflowScenarioSetting {
  scenario_setting_id: string
  scenario_name: string
  exec_timing: string
  schedule_kbn: string
  schedule_day_of_week: string
  schedule_year: string
  schedule_month: string
  schedule_day: string
  schedule_hour: string
  schedule_minute: string
  schedule_second: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2Novelty {
  shop_id: string
  novelty_id: string
  novelty_disp_name: string
  novelty_name: string
  discription: string
  date_begin: string
  date_end: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2NoveltyGrantConditions {
  shop_id: string
  novelty_id: string
  condition_no: string
  user_rank_id: string
  amount_begin: string
  amount_end: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2NoveltyGrantItem {
  shop_id: string
  novelty_id: string
  condition_no: string
  product_id: string
  sort_no: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2NoveltyTargetItem {
  shop_id: string
  novelty_id: string
  novelty_target_item_no: string
  novelty_target_item_type: string
  novelty_target_item_value: string
  novelty_target_item_type_sort_no: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2OrderSetPromotion {
  order_id: string
  order_setpromotion_no: string
  setpromotion_id: string
  setpromotion_name: string
  setpromotion_disp_name: string
  promotion_type: string
  discount_amount: string
}

export interface W2OrderSetPromotionItem {
  order_id: string
  order_setpromotion_no: string
  order_setpromotion_item_no: string
  order_item_no: string
  order_item_quantity: string
}

export interface W2SetPromotion {
  setpromotion_id: string
  setpromotion_name: string
  setpromotion_disp_name: string
  promotion_type: string
  product_discount_kbn: string
  product_discount_setting: string
  multiple_apply_flg: string
  apply_order: string
  description_kbn: string
  description: string
  begin_date: string
  end_date: string
  target_member_rank: string
  target_target_ids: string
  url: string
  display_order: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2SetPromotionItem {
  setpromotion_id: string
  setpromotion_item_no: string
  setpromotion_item_kbn: string
  setpromotion_items: string
  setpromotion_item_quantity: string
  and_over_quantity_flg: string
}

export interface W2ProductBundle {
  product_bundle_id: string
  product_bundle_name: string
  target_order_type: string
  description: string
  start_datetime: string
  end_datetime: string
  target_product_kbn: string
  target_product_ids: string
  target_order_fixed_purchase_count_from: string
  target_order_fixed_purchase_count_to: string
  usable_times_kbn: string
  apply_type: string
  valid_flg: string
  multiple_apply_flg: string
  apply_order: string
  date_created: string
  date_changed: string
  last_changed: string
  usable_times: string
  target_product_category_ids: string
  except_product_ids: string
  except_product_category_ids: string
  target_id: string
  target_id_except_flg: string
  target_order_price_subtotal_min: string
  target_product_count_min: string
  target_advcodes_first: string
  target_advcodes_new: string
  target_payment_ids: string
}

export interface W2ProductBundleItem {
  product_bundle_id: string
  product_bundle_item_no: string
  grant_product_id: string
  grant_product_variation_id: string
  grant_product_count: string
  date_created: string
  last_changed: string
}

export interface W2ProductSet {
  shop_id: string
  product_set_id: string
  product_set_name: string
  parent_min: string
  parent_max: string
  child_min: string
  child_max: string
  priority: string
  description_kbn: string
  description: string
  max_sell_quantity: string
  shipping_size_kbn: string
  editable_flg: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2ProductSetItem {
  shop_id: string
  product_set_id: string
  product_id: string
  variation_id: string
  setitem_price: string
  count_min: string
  count_max: string
  family_flg: string
  display_order: string
  date_created: string
  last_changed: string
}

export interface W2ProductSale {
  shop_id: string
  productsale_id: string
  productsale_kbn: string
  productsale_name: string
  closedmarket_password: string
  date_bgn: string
  date_end: string
  valid_flg: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  promotion_stackable_flag: string
}

export interface W2ProductSalePrice {
  shop_id: string
  productsale_id: string
  product_id: string
  variation_id: string
  sale_price: string
  display_order: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2FixedPurchase {
  fixed_purchase_id: string
  fixed_purchase_kbn: string
  fixed_purchase_setting1: string
  base_tel_no: string
  fixed_purchase_status: string
  payment_status: string
  last_order_date: string
  order_count: string
  user_id: string
  shop_id: string
  supplier_id: string
  order_kbn: string
  order_payment_kbn: string
  fixed_purchase_date_bgn: string
  card_kbn: string
  valid_flg: string
  del_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  credit_branch_no: string
  next_shipping_date: string
  next_next_shipping_date: string
  fixed_purchase_management_memo: string
  card_installments_code: string
  extend_status1: string
  extend_status2: string
  extend_status3: string
  extend_status4: string
  extend_status5: string
  extend_status6: string
  extend_status7: string
  extend_status8: string
  extend_status9: string
  extend_status10: string
  extend_status11: string
  extend_status12: string
  extend_status13: string
  extend_status14: string
  extend_status15: string
  extend_status16: string
  extend_status17: string
  extend_status18: string
  extend_status19: string
  extend_status20: string
  extend_status21: string
  extend_status22: string
  extend_status23: string
  extend_status24: string
  extend_status25: string
  extend_status26: string
  extend_status27: string
  extend_status28: string
  extend_status29: string
  extend_status30: string
  cancel_reason_id: string
  cancel_memo: string
  shipped_count: string
  extend_status31: string
  extend_status32: string
  extend_status33: string
  extend_status34: string
  extend_status35: string
  extend_status36: string
  extend_status37: string
  extend_status38: string
  extend_status39: string
  extend_status40: string
  combined_org_fixedpurchase_ids: string
  access_country_iso_code: string
  disp_language_code: string
  disp_language_locale_id: string
  disp_currency_code: string
  disp_currency_locale_id: string
  external_payment_agreement_id: string
  resume_date: string
  suspend_reason: string
  shipping_memo: string
  extend_status_date1: string
  extend_status_date2: string
  extend_status_date3: string
  extend_status_date4: string
  extend_status_date5: string
  extend_status_date6: string
  extend_status_date7: string
  extend_status_date8: string
  extend_status_date9: string
  extend_status_date10: string
  extend_status_date11: string
  extend_status_date12: string
  extend_status_date13: string
  extend_status_date14: string
  extend_status_date15: string
  extend_status_date16: string
  extend_status_date17: string
  extend_status_date18: string
  extend_status_date19: string
  extend_status_date20: string
  extend_status_date21: string
  extend_status_date22: string
  extend_status_date23: string
  extend_status_date24: string
  extend_status_date25: string
  extend_status_date26: string
  extend_status_date27: string
  extend_status_date28: string
  extend_status_date29: string
  extend_status_date30: string
  extend_status_date31: string
  extend_status_date32: string
  extend_status_date33: string
  extend_status_date34: string
  extend_status_date35: string
  extend_status_date36: string
  extend_status_date37: string
  extend_status_date38: string
  extend_status_date39: string
  extend_status_date40: string
  cancel_date: string
  restart_date: string
  memo: string
  next_shipping_use_coupon_id: string
  next_shipping_use_coupon_no: string
  receipt_flg: string
  receipt_address: string
  receipt_proviso: string
  skipped_count: string
  extend_status41: string
  extend_status42: string
  extend_status43: string
  extend_status44: string
  extend_status45: string
  extend_status46: string
  extend_status47: string
  extend_status48: string
  extend_status49: string
  extend_status50: string
  extend_status_date41: string
  extend_status_date42: string
  extend_status_date43: string
  extend_status_date44: string
  extend_status_date45: string
  extend_status_date46: string
  extend_status_date47: string
  extend_status_date48: string
  extend_status_date49: string
  extend_status_date50: string
  attribute1: string
  attribute2: string
  attribute3: string
  attribute4: string
  attribute5: string
  attribute6: string
  attribute7: string
  attribute8: string
  attribute9: string
  attribute10: string
  use_all_point_flg: string
  next_use_point_amount: string
}

export interface W2FixedPurchaseItem {
  fixed_purchase_id: string
  fixed_purchase_item_no: string
  fixed_purchase_shipping_no: string
  shop_id: string
  product_id: string
  variation_id: string
  supplier_id: string
  item_quantity: string
  item_quantity_single: string
  product_set_id: string
  product_set_no: string
  product_set_count: string
  date_created: string
  date_changed: string
  product_option_texts: string
  item_order_count: string
  item_shipped_count: string
  next_time_delivery_status: string
  conditional_item_quantity: string
  composite_type: string
}

export interface W2FixedPurchaseHistory {
  fixed_purchase_id: string
  fixed_purchase_history_no: string
  fixed_purchase_history_kbn: string
  base_tel_no: string
  user_id: string
  order_id: string
  date_created: string
  last_changed: string
  update_order_count: string
  update_shipped_count: string
  update_order_count_result: string
  update_shipped_count_result: string
  external_payment_cooperation_log: string
}

export interface W2FixedPurchaseCancelReason {
  cancel_reason_id: string
  cancel_reason_name: string
  display_order: string
  display_kbn: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2UserCoupon {
  user_id: string
  dept_id: string
  coupon_id: string
  coupon_no: string
  order_id: string
  use_flg: string
  date_created: string
  date_changed: string
  last_changed: string
  user_coupon_count: string
  cooperation_id: string
  cooperation_type: string
  temp_coupon_flg: string
  source_popup_id: string
}

export interface W2UserCouponHistory {
  user_id: string
  history_no: string
  dept_id: string
  coupon_id: string
  coupon_code: string
  order_id: string
  history_kbn: string
  action_kbn: string
  coupon_inc: string
  coupon_price: string
  memo: string
  date_created: string
  last_changed: string
  user_coupon_count: string
  fixed_purchase_id: string
}

export interface W2CouponUseUser {
  coupon_id: string
  coupon_use_user: string
  order_id: string
  date_created: string
  last_changed: string
  fixed_purchase_id: string
  branch_no: string
}

export interface W2CouponSchedule {
  coupon_schedule_id: string
  coupon_schedule_name: string
  status: string
  last_count: string
  last_exec_date: string
  target_id: string
  target_extract_flg: string
  coupon_id: string
  publish_quantity: string
  mail_id: string
  exec_timing: string
  schedule_kbn: string
  schedule_day_of_week: string
  schedule_year: string
  schedule_month: string
  schedule_day: string
  schedule_hour: string
  schedule_minute: string
  schedule_second: string
  valid_flg: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2AdvCodeLog {
  advcodelog_no: string
  access_date: string
  access_time: string
  advertisement_code: string
  access_user_id: string
}

export interface W2AdvCodeMediaType {
  advcode_media_type_id: string
  advcode_media_type_name: string
  display_order: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2UserActivity {
  user_id: string
  master_kbn: string
  master_id: string
  date: string
  tgt_year: string
  tgt_month: string
  tgt_day: string
}

export interface W2AbTest {
  ab_test_id: string
  ab_test_title: string
  public_status: string
  public_start_datetime: string
  public_end_datetime: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2AbTestItem {
  ab_test_id: string
  item_no: string
  page_id: string
  distribution_rate: string
}

export interface W2PageDesign {
  page_id: string
  management_title: string
  page_type: string
  file_name: string
  pc_file_dir_path: string
  group_id: string
  page_sort_number: number
  use_type: string
  publish: string
  condition_publish_date_from: string
  condition_publish_date_to: string
  condition_member_only_type: string
  condition_member_rank_id: string
  condition_target_list_type: string
  condition_target_list_ids: string
  date_created: string
  date_changed: string
  last_changed: string
  metadata_desc: string
  file_time_stamp: string
  sitemap_include: string
  sitemap_changefreq: string
  sitemap_priority: number
}

export interface W2PageDesignGroup {
  group_id: string
  group_name: string
  group_sort_number: number
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2PartsDesign {
  parts_id: string
  management_title: string
  parts_type: string
  file_name: string
  pc_file_dir_path: string
  group_id: string
  parts_sort_number: number
  use_type: string
  publish: string
  condition_publish_date_from: string
  condition_publish_date_to: string
  condition_member_only_type: string
  condition_member_rank_id: string
  condition_target_list_type: string
  condition_target_list_ids: string
  date_created: string
  date_changed: string
  last_changed: string
  area_id: string
  file_time_stamp: string
  vue_component_id: string
}

export interface W2PartsDesignGroup {
  group_id: string
  group_name: string
  group_sort_number: number
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2FeatureArea {
  area_id: string
  area_name: string
  area_type_id: string
  internal_memo: string
  side_max_count: string
  side_turn: string
  slider_count: string
  slider_scroll_count: string
  slider_scroll_auto: string
  slider_scroll_interval: string
  slider_arrow: string
  slider_dot: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2FeatureAreaBanner {
  area_id: string
  banner_no: string
  file_name: string
  file_dir_path: string
  alt_text: string
  text: string
  link_url: string
  window_type: string
  publish: string
  condition_publish_date_from: string
  condition_publish_date_to: string
  condition_member_only_type: string
  condition_member_rank_id: string
  condition_target_list_type: string
  condition_target_list_ids: string
  date_created: string
}

export interface W2Popup {
  popup_id: string
  popup_name: string
  popup_type: string
  public_status: string
  public_start_datetime: string
  public_end_datetime: string
  condition_member_only_type: string
  condition_member_rank_id: string
  condition_target_list_type: string
  condition_target_list_ids: string
  condition_advertisement_codes: string
  condition_available_device: string
  display_trigger_setting_type: string
  display_trigger_setting_value: string
  display_priority: number
  design_setting: string
  contents_setting: string
  date_created: string
  date_changed: string
  last_changed: string
}

export interface W2PopupDisplayPageSetting {
  popup_id: string
  type: string
  data_no: string
  target_page: string
  product_id: string
  category_id: string
  page_id: string
  brand_id: string
  target_url: string
}

export interface W2PopupReport {
  data_no: string
  date: string
  tgt_year: string
  tgt_month: string
  tgt_day: string
  report_type: string
  access_kbn: string
  popup_id: string
  count: number
}

export type W2MasterDataRecord =
  | W2User
  | W2UserAttribute
  | W2MemberRank
  | W2AccessLog
  | W2Product
  | W2ProductBrand
  | W2ProductCategory
  | W2ProductTag
  | W2ProductTagSetting
  | W2ProductStock
  | W2ProductVariation
  | W2ProductPrice
  | W2Cart
  | W2Order
  | W2OrderItem
  | W2OrderCoupon
  | W2Coupon
  | W2AdvCode
  | W2FeaturePage
  | W2FeaturePageCategory
  | W2FeaturePageContents
  | W2ProductGroup
  | W2ProductGroupItem
  | W2ContentsTag
  | W2ProductLink
  | W2ExProductSpec
  | W2ExProductVariationSpec
  | W2UserPoint
  | W2UserPointHistory
  | W2PointRule
  | W2PointRuleSchedule
  | W2UserMemberRankHistory
  | W2MemberRankRule
  | W2OrderShipping
  | W2ShopShipping
  | W2ShopShippingZone
  | W2ShopShippingSizeThreshold
  | W2MailDistSetting
  | W2MailDistSentUser
  | W2MailSendLog
  | W2MailClick
  | W2MailClickLog
  | W2OrderWorkflowScenarioSetting
  | W2Novelty
  | W2NoveltyGrantConditions
  | W2NoveltyGrantItem
  | W2NoveltyTargetItem
  | W2OrderSetPromotion
  | W2OrderSetPromotionItem
  | W2SetPromotion
  | W2SetPromotionItem
  | W2ProductBundle
  | W2ProductBundleItem
  | W2ProductSet
  | W2ProductSetItem
  | W2ProductSale
  | W2ProductSalePrice
  | W2FixedPurchase
  | W2FixedPurchaseItem
  | W2FixedPurchaseHistory
  | W2FixedPurchaseCancelReason
  | W2UserCoupon
  | W2UserCouponHistory
  | W2CouponUseUser
  | W2CouponSchedule
  | W2AdvCodeLog
  | W2AdvCodeMediaType
  | W2UserActivity
  | W2AbTest
  | W2AbTestItem
  | W2PageDesign
  | W2PageDesignGroup
  | W2PartsDesign
  | W2PartsDesignGroup
  | W2FeatureArea
  | W2FeatureAreaBanner
  | W2Popup
  | W2PopupDisplayPageSetting
  | W2PopupReport

export interface W2MasterData {
  id: number
  site_id: number
  master_type: MasterType
  row_key: string
  data: W2MasterDataRecord
  created_at: string
  updated_at: string
}

export interface W2MasterCreateRequest {
  data: W2MasterDataRecord
}

export interface W2MasterBulkRequest {
  items: W2MasterDataRecord[]
}

type KeysOfUnion<T> = T extends T ? keyof T : never

// W2マスタテーブルごとの設定定義
export const W2_MASTER_CONFIGS: Record<
  MasterType,
  {
    masterType: MasterType
    title: string
    columns: { key: KeysOfUnion<W2MasterDataRecord>; label: string; sortable?: boolean }[]
    pkColumns: string[]
    csvHeaders: string[]
    requiredCsv: string[]
    detailSections?: {
      title: string
      fields: { key: string; label: string }[]
    }[]
    // not used
    searchColumns: string[]
  }
> = {
  [MasterType.W2_USER]: {
    masterType: MasterType.W2_USER,
    title: 'W2ユーザーマスタ',
    columns: [
      { key: 'user_id', label: 'ユーザーID', sortable: true },
      { key: 'user_kbn', label: '顧客区分' },
      { key: 'name', label: '氏名', sortable: true },
      { key: 'mail_addr', label: 'メールアドレス' },
      { key: 'tel1', label: '電話番号1' },
      { key: 'sex', label: '性別' },
      { key: 'member_rank_id', label: '会員ランクID' },
      { key: 'login_id', label: 'ログインID' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'user_id',
      'name',
      'name_kana',
      'mail_addr',
      'tel1',
      'login_id',
      'member_rank_id'
    ],
    pkColumns: ['user_id'],
    csvHeaders: [
      'user_id',
      'user_kbn',
      'mall_id',
      'name',
      'name1',
      'name2',
      'name_kana',
      'name_kana1',
      'name_kana2',
      'nick_name',
      'mail_addr',
      'zip',
      'zip1',
      'zip2',
      'addr',
      'addr1',
      'addr2',
      'addr3',
      'addr4',
      'addr5',
      'tel1',
      'tel1_1',
      'tel1_2',
      'tel1_3',
      'tel2',
      'tel2_1',
      'tel2_2',
      'tel2_3',
      'tel3',
      'tel3_1',
      'tel3_2',
      'tel3_3',
      'fax',
      'fax_1',
      'fax_2',
      'fax_3',
      'sex',
      'birth',
      'birth_year',
      'birth_month',
      'birth_day',
      'company_name',
      'company_post_name',
      'company_exective_name',
      'advcode_first',
      'attribute1',
      'attribute2',
      'attribute3',
      'attribute4',
      'attribute5',
      'attribute6',
      'attribute7',
      'attribute8',
      'attribute9',
      'attribute10',
      'login_id',
      'password',
      'question',
      'answer',
      'remote_addr',
      'mail_flg',
      'user_memo',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'member_rank_id',
      'recommend_uid',
      'date_last_loggedin',
      'user_management_level_id',
      'integrated_flg',
      'easy_register_flg',
      'fixed_purchase_member_flg',
      'access_country_iso_code',
      'disp_language_code',
      'disp_language_locale_id',
      'disp_currency_code',
      'disp_currency_locale_id',
      'last_birthday_point_add_year',
      'addr_country_iso_code',
      'addr_country_name',
      'last_birthday_coupon_publish_year',
      'order_count_order_realtime',
      'order_count_old',
      'referral_code',
      'referred_user_id',
      'real_shop_id',
      'order_count_realshop_realtime',
      'date_withdrawal'
    ],
    requiredCsv: ['user_id'],
    // 詳細オーバーレイ用セクション定義
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'user_id', label: 'ユーザーID' },
          { key: 'user_kbn', label: '顧客区分' },
          { key: 'mall_id', label: 'モールID' },
          { key: 'login_id', label: 'ログインID' },
          { key: 'password', label: 'パスワード' },
          { key: 'user_management_level_id', label: 'ユーザー管理レベルID' },
          { key: 'member_rank_id', label: '会員ランクID' },
          { key: 'del_flg', label: '削除フラグ' },
          { key: 'integrated_flg', label: 'ユーザー統合フラグ' },
          { key: 'easy_register_flg', label: 'かんたん会員フラグ' },
          { key: 'fixed_purchase_member_flg', label: '定期会員フラグ' }
        ]
      },
      {
        title: '氏名・個人情報',
        fields: [
          { key: 'name', label: '氏名' },
          { key: 'name1', label: '氏名1（姓）' },
          { key: 'name2', label: '氏名2（名）' },
          { key: 'name_kana', label: '氏名かな' },
          { key: 'name_kana1', label: '氏名かな1' },
          { key: 'name_kana2', label: '氏名かな2' },
          { key: 'nick_name', label: 'ニックネーム' },
          { key: 'sex', label: '性別' },
          { key: 'birth', label: '生年月日' },
          { key: 'birth_year', label: '生年月日（年）' },
          { key: 'birth_month', label: '生年月日（月）' },
          { key: 'birth_day', label: '生年月日（日）' }
        ]
      },
      {
        title: '連絡先',
        fields: [
          { key: 'mail_addr', label: 'メールアドレス' },
          { key: 'mail_flg', label: 'メール配信フラグ' },
          { key: 'tel1', label: '電話番号1' },
          { key: 'tel1_1', label: '電話番号1-1' },
          { key: 'tel1_2', label: '電話番号1-2' },
          { key: 'tel1_3', label: '電話番号1-3' },
          { key: 'tel2', label: '電話番号2' },
          { key: 'tel2_1', label: '電話番号2-1' },
          { key: 'tel2_2', label: '電話番号2-2' },
          { key: 'tel2_3', label: '電話番号2-3' },
          { key: 'tel3', label: '電話番号3' },
          { key: 'tel3_1', label: '電話番号3-1' },
          { key: 'tel3_2', label: '電話番号3-2' },
          { key: 'tel3_3', label: '電話番号3-3' },
          { key: 'fax', label: 'FAX' },
          { key: 'fax_1', label: 'FAX1' },
          { key: 'fax_2', label: 'FAX2' },
          { key: 'fax_3', label: 'FAX3' }
        ]
      },
      {
        title: '住所',
        fields: [
          { key: 'zip', label: '郵便番号' },
          { key: 'zip1', label: '郵便番号1' },
          { key: 'zip2', label: '郵便番号2' },
          { key: 'addr', label: '住所' },
          { key: 'addr1', label: '住所1' },
          { key: 'addr2', label: '住所2' },
          { key: 'addr3', label: '住所3' },
          { key: 'addr4', label: '住所4' },
          { key: 'addr5', label: '住所5' },
          { key: 'addr_country_iso_code', label: '住所国ISOコード' },
          { key: 'addr_country_name', label: '住所国名' }
        ]
      },
      {
        title: '企業情報',
        fields: [
          { key: 'company_name', label: '企業名' },
          { key: 'company_post_name', label: '部署名' },
          { key: 'company_exective_name', label: '役職名' }
        ]
      },
      {
        title: '属性',
        fields: [
          { key: 'attribute1', label: '属性1' },
          { key: 'attribute2', label: '属性2' },
          { key: 'attribute3', label: '属性3' },
          { key: 'attribute4', label: '属性4' },
          { key: 'attribute5', label: '属性5' },
          { key: 'attribute6', label: '属性6' },
          { key: 'attribute7', label: '属性7' },
          { key: 'attribute8', label: '属性8' },
          { key: 'attribute9', label: '属性9' },
          { key: 'attribute10', label: '属性10' }
        ]
      },
      {
        title: '購入情報',
        fields: [
          { key: 'order_count_order_realtime', label: 'リアルタイム購入回数（注文基準）' },
          { key: 'order_count_old', label: '過去累計購入回数' },
          { key: 'order_count_realshop_realtime', label: 'リアルタイム購入回数（リアル店舗）' },
          { key: 'real_shop_id', label: 'リアル店舗ID' }
        ]
      },
      {
        title: '広告・紹介',
        fields: [
          { key: 'advcode_first', label: '初回広告コード' },
          { key: 'referral_code', label: '紹介コード' },
          { key: 'referred_user_id', label: '紹介元ユーザーID' },
          { key: 'recommend_uid', label: '外部レコメンド連携用ユーザID' }
        ]
      },
      {
        title: '国際化・表示設定',
        fields: [
          { key: 'access_country_iso_code', label: 'アクセス国ISOコード' },
          { key: 'disp_language_code', label: '表示言語コード' },
          { key: 'disp_language_locale_id', label: '表示言語ロケールID' },
          { key: 'disp_currency_code', label: '表示通貨コード' },
          { key: 'disp_currency_locale_id', label: '表示通貨ロケールID' }
        ]
      },
      {
        title: 'ポイント・クーポン',
        fields: [
          { key: 'last_birthday_point_add_year', label: '最終誕生日ポイント付与年' },
          { key: 'last_birthday_coupon_publish_year', label: '最終誕生日クーポン付与年' }
        ]
      },
      {
        title: 'その他',
        fields: [
          { key: 'question', label: '質問' },
          { key: 'answer', label: '回答' },
          { key: 'remote_addr', label: 'リモートIPアドレス' },
          { key: 'user_memo', label: 'ユーザメモ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' },
          { key: 'date_last_loggedin', label: '最終ログイン日時' },
          { key: 'date_withdrawal', label: '退会日' }
        ]
      }
    ]
  },
  [MasterType.W2_USER_ATTRIBUTE]: {
    masterType: 'w2_UserAttribute',
    title: 'W2ユーザー属性',
    columns: [
      { key: 'user_id', label: 'ユーザーID', sortable: true },
      { key: 'first_order_date', label: '初回購入日', sortable: true },
      { key: 'last_order_date', label: '最終購入日', sortable: true },
      { key: 'enrollment_days', label: '在籍期間(日)' },
      { key: 'away_days', label: '離脱期間(日)' },
      { key: 'order_amount_order_all', label: '累計購入金額（注文）' },
      { key: 'order_count_order_all', label: '累計購入回数（注文）' },
      { key: 'cpm_cluster_id', label: 'CPMクラスタID' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'user_id',
      'cpm_cluster_id',
      'cpm_cluster_attribute1',
      'cpm_cluster_attribute2'
    ],
    pkColumns: ['user_id'],
    csvHeaders: [
      'user_id',
      'first_order_date',
      'second_order_date',
      'last_order_date',
      'enrollment_days',
      'away_days',
      'order_amount_order_all',
      'order_amount_order_fp',
      'order_count_order_all',
      'order_count_order_fp',
      'order_amount_ship_all',
      'order_amount_ship_fp',
      'order_count_ship_all',
      'order_count_ship_fp',
      'date_created',
      'date_changed',
      'last_changed',
      'cpm_cluster_attribute1',
      'cpm_cluster_attribute2',
      'cpm_cluster_id',
      'cpm_cluster_attribute1_before',
      'cpm_cluster_attribute2_before',
      'cpm_cluster_id_before',
      'cpm_cluster_changed_date'
    ],
    requiredCsv: ['user_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [{ key: 'user_id', label: 'ユーザーID' }]
      },
      {
        title: '購入日',
        fields: [
          { key: 'first_order_date', label: '初回購入日' },
          { key: 'second_order_date', label: '2回目購入日' },
          { key: 'last_order_date', label: '最終購入日' },
          { key: 'enrollment_days', label: '在籍期間(日)' },
          { key: 'away_days', label: '離脱期間(日)' }
        ]
      },
      {
        title: '累計購入（注文基準）',
        fields: [
          { key: 'order_amount_order_all', label: '累計購入金額（全体）' },
          { key: 'order_amount_order_fp', label: '累計購入金額（定期のみ）' },
          { key: 'order_count_order_all', label: '累計購入回数（全体）' },
          { key: 'order_count_order_fp', label: '累計購入回数（定期のみ）' }
        ]
      },
      {
        title: '累計購入（出荷基準）',
        fields: [
          { key: 'order_amount_ship_all', label: '累計購入金額（全体）' },
          { key: 'order_amount_ship_fp', label: '累計購入金額（定期のみ）' },
          { key: 'order_count_ship_all', label: '累計購入回数（全体）' },
          { key: 'order_count_ship_fp', label: '累計購入回数（定期のみ）' }
        ]
      },
      {
        title: 'CPMクラスタ（現在）',
        fields: [
          { key: 'cpm_cluster_attribute1', label: 'CPMクラスタ属性1' },
          { key: 'cpm_cluster_attribute2', label: 'CPMクラスタ属性2' },
          { key: 'cpm_cluster_id', label: 'CPMクラスタID（計算列）' }
        ]
      },
      {
        title: 'CPMクラスタ（以前）',
        fields: [
          { key: 'cpm_cluster_attribute1_before', label: '以前のCPMクラスタ属性1' },
          { key: 'cpm_cluster_attribute2_before', label: '以前のCPMクラスタ属性2' },
          { key: 'cpm_cluster_id_before', label: '以前のCPMクラスタID（計算列）' },
          { key: 'cpm_cluster_changed_date', label: 'CPMクラスタ変更日' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_MEMBER_RANK]: {
    masterType: 'w2_MemberRank',
    title: 'W2会員ランクマスタ',
    columns: [
      { key: 'member_rank_id', label: 'ランクID', sortable: true },
      { key: 'member_rank_order', label: 'ランク順位', sortable: true },
      { key: 'member_rank_name', label: 'ランク名', sortable: true },
      { key: 'order_discount_type', label: '注文割引方法' },
      { key: 'order_discount_value', label: '注文割引数' },
      { key: 'point_add_type', label: 'ポイント加算方法' },
      { key: 'shipping_discount_type', label: '配送料割引方法' },
      { key: 'default_member_rank_setting_flg', label: 'デフォルト' },
      { key: 'valid_flg', label: '有効' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['member_rank_id', 'member_rank_name'],
    pkColumns: ['member_rank_id'],
    csvHeaders: [
      'member_rank_id',
      'member_rank_order',
      'member_rank_name',
      'order_discount_type',
      'order_discount_value',
      'order_discount_threshold_price',
      'point_add_type',
      'point_add_value',
      'shipping_discount_type',
      'shipping_discount_value',
      'default_member_rank_setting_flg',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'member_rank_memo',
      'fixed_purchase_discount_rate'
    ],
    requiredCsv: ['member_rank_id'],
    detailSections: [
      {
        title: 'ランク基本情報',
        fields: [
          { key: 'member_rank_id', label: 'ランクID' },
          { key: 'member_rank_order', label: 'ランク順位' },
          { key: 'member_rank_name', label: 'ランク名' },
          { key: 'default_member_rank_setting_flg', label: 'デフォルト会員ランク設定フラグ' },
          { key: 'valid_flg', label: '有効フラグ' }
        ]
      },
      {
        title: '注文割引',
        fields: [
          { key: 'order_discount_type', label: '注文割引方法' },
          { key: 'order_discount_value', label: '注文割引数' },
          { key: 'order_discount_threshold_price', label: '注文金額割引き閾値' }
        ]
      },
      {
        title: 'ポイント加算',
        fields: [
          { key: 'point_add_type', label: 'ポイント加算方法' },
          { key: 'point_add_value', label: 'ポイント加算数' }
        ]
      },
      {
        title: '配送料割引',
        fields: [
          { key: 'shipping_discount_type', label: '配送料割引方法' },
          { key: 'shipping_discount_value', label: '配送料割引数' }
        ]
      },
      {
        title: '定期購入',
        fields: [{ key: 'fixed_purchase_discount_rate', label: '定期会員割引率' }]
      },
      { title: 'その他', fields: [{ key: 'member_rank_memo', label: '会員ランクメモ' }] },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_ACCESS_LOG]: {
    masterType: MasterType.W2_ACCESS_LOG,
    title: 'W2アクセスログ',
    columns: [
      { key: 'log_no', label: 'ログNo', sortable: true },
      { key: 'access_date', label: 'アクセスユーザーID', sortable: true },
      { key: 'access_time', label: 'ユーザーID' },
      { key: 'real_user_id', label: '認知ユーザーID' },
      { key: 'url_domain', label: 'ドメイン' },
      { key: 'url_page', label: 'ページパス' },
      { key: 'action_kbn', label: 'アクション区分' },
      { key: 'client_ip', label: 'クライアントIP' },
      { key: 'user_agent_kbn', label: 'UA区分' },
      { key: 'protocol_status', label: 'ステータス' }
    ],
    searchColumns: [
      'log_no',
      'access_date',
      'access_time',
      'real_user_id',
      'url_page',
      'action_kbn',
      'session_id'
    ],
    pkColumns: ['log_no'],
    csvHeaders: [
      'log_no',
      'access_date',
      'access_time',
      'client_ip',
      'server_name',
      'server_ip',
      'server_port',
      'protocol_status',
      'user_agent',
      'url_domain',
      'url_page',
      'url_param',
      'dept_id',
      'account_id',
      'access_user_id',
      'session_id',
      'real_user_id',
      'access_interval',
      'first_login_flg',
      'referrer_domain',
      'referrer_page',
      'referrer_param',
      'search_engine',
      'search_words',
      'action_kbn',
      's1',
      's2',
      's3',
      's4',
      's5',
      's6',
      's7',
      's8',
      's9',
      's10',
      's11',
      's12',
      's13',
      's14',
      's15',
      's16',
      's17',
      's18',
      's19',
      's20',
      'p1',
      'p2',
      'p3',
      'p4',
      'p5',
      'p6',
      'p7',
      'p8',
      'p9',
      'p10',
      'p11',
      'p12',
      'p13',
      'p14',
      'p15',
      'p16',
      'p17',
      'p18',
      'p19',
      'p20',
      'user_agent_kbn'
    ],
    requiredCsv: ['log_no'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'log_no', label: 'ログNo' },
          { key: 'access_date', label: 'アクセスユーザーID' },
          { key: 'access_time', label: 'ユーザーID' },
          { key: 'real_user_id', label: '認知ユーザーID' },
          { key: 'access_user_id', label: 'アクセスユーザーID' },
          { key: 'session_id', label: 'セッションID' },
          { key: 'dept_id', label: '識別ID' },
          { key: 'account_id', label: 'アカウントID' }
        ]
      },
      {
        title: 'サーバー情報',
        fields: [
          { key: 'client_ip', label: 'クライアントIPアドレス' },
          { key: 'server_name', label: 'サーバー名' },
          { key: 'server_ip', label: 'サーバーIPアドレス' },
          { key: 'server_port', label: 'サーバーポート' },
          { key: 'protocol_status', label: 'プロトコルの状態' },
          { key: 'user_agent', label: 'ユーザーエージェント' },
          { key: 'user_agent_kbn', label: 'ユーザーエージェント区分' }
        ]
      },
      {
        title: 'アクセスURL',
        fields: [
          { key: 'url_domain', label: 'ドメイン' },
          { key: 'url_page', label: 'ページパス' },
          { key: 'url_param', label: 'パラメーター' }
        ]
      },
      {
        title: 'リファラー',
        fields: [
          { key: 'referrer_domain', label: 'リファラー・ドメイン' },
          { key: 'referrer_page', label: 'リファラー・ページパス' },
          { key: 'referrer_param', label: 'リファラー・パラメーター' },
          { key: 'search_engine', label: '検索エンジン' },
          { key: 'search_words', label: '検索ワード' }
        ]
      },
      {
        title: 'アクセス状態',
        fields: [
          { key: 'action_kbn', label: 'アクション区分' },
          { key: 'access_interval', label: 'アクセス頻度' },
          { key: 'first_login_flg', label: '初回ログインフラグ' }
        ]
      },
      {
        title: 'システム予約パラメーター',
        fields: [
          { key: 's1', label: 'S1' },
          { key: 's2', label: 'S2' },
          { key: 's3', label: 'S3' },
          { key: 's4', label: 'S4' },
          { key: 's5', label: 'S5' },
          { key: 's6', label: 'S6' },
          { key: 's7', label: 'S7' },
          { key: 's8', label: 'S8' },
          { key: 's9', label: 'S9' },
          { key: 's10', label: 'S10' },
          { key: 's11', label: 'S11' },
          { key: 's12', label: 'S12' },
          { key: 's13', label: 'S13' },
          { key: 's14', label: 'S14' },
          { key: 's15', label: 'S15' },
          { key: 's16', label: 'S16' },
          { key: 's17', label: 'S17' },
          { key: 's18', label: 'S18' },
          { key: 's19', label: 'S19' },
          { key: 's20', label: 'S20' }
        ]
      },
      {
        title: 'ユーザー定義パラメーター',
        fields: [
          { key: 'p1', label: 'P1' },
          { key: 'p2', label: 'P2' },
          { key: 'p3', label: 'P3' },
          { key: 'p4', label: 'P4' },
          { key: 'p5', label: 'P5' },
          { key: 'p6', label: 'P6' },
          { key: 'p7', label: 'P7' },
          { key: 'p8', label: 'P8' },
          { key: 'p9', label: 'P9' },
          { key: 'p10', label: 'P10' },
          { key: 'p11', label: 'P11' },
          { key: 'p12', label: 'P12' },
          { key: 'p13', label: 'P13' },
          { key: 'p14', label: 'P14' },
          { key: 'p15', label: 'P15' },
          { key: 'p16', label: 'P16' },
          { key: 'p17', label: 'P17' },
          { key: 'p18', label: 'P18' },
          { key: 'p19', label: 'P19' },
          { key: 'p20', label: 'P20' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT]: {
    masterType: MasterType.W2_PRODUCT,
    title: 'W2商品マスタ',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'name', label: '商品名', sortable: true },
      { key: 'display_price', label: '表示価格' },
      { key: 'category_id1', label: 'カテゴリID1' },
      { key: 'brand_id1', label: 'ブランドID1' },
      { key: 'fixed_purchase_flg', label: '定期購入' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'shop_id',
      'product_id',
      'name',
      'name_kana',
      'category_id1',
      'brand_id1',
      'search_keyword'
    ],
    pkColumns: ['shop_id', 'product_id'],
    csvHeaders: [
      'shop_id',
      'supplier_id',
      'product_id',
      'cooperation_id1',
      'cooperation_id2',
      'cooperation_id3',
      'cooperation_id4',
      'cooperation_id5',
      'mall_ex_product_id',
      'maker_id',
      'maker_name',
      'name',
      'name_kana',
      'name2',
      'name2_kana',
      'catchcopy',
      'outline_kbn',
      'outline',
      'desc_detail_kbn1',
      'desc_detail1',
      'desc_detail_kbn2',
      'desc_detail2',
      'desc_detail_kbn3',
      'desc_detail3',
      'desc_detail_kbn4',
      'desc_detail4',
      'return_exchange_message',
      'note',
      'display_price',
      'display_special_price',
      'tax_included_flg',
      'tax_rate',
      'tax_round_type',
      'price_pretax',
      'price_shipping',
      'shipping_type',
      'shipping_size_kbn',
      'price_cost',
      'point_kbn1',
      'point1',
      'point_kbn2',
      'point2',
      'point_kbn3',
      'point3',
      'campaign_from',
      'campaign_to',
      'campaign_point_kbn',
      'campaign_point',
      'display_from',
      'display_to',
      'sell_from',
      'sell_to',
      'before_sale_display_kbn',
      'after_sale_display_kbn',
      'max_sell_quantity',
      'stock_management_kbn',
      'stock_disp_kbn',
      'stock_message_id',
      'url',
      'inquire_email',
      'inquire_tel',
      'display_kbn',
      'category_id1',
      'category_id2',
      'category_id3',
      'category_id4',
      'category_id5',
      'related_product_id_cs1',
      'related_product_id_cs2',
      'related_product_id_cs3',
      'related_product_id_cs4',
      'related_product_id_cs5',
      'related_product_id_us1',
      'related_product_id_us2',
      'related_product_id_us3',
      'related_product_id_us4',
      'related_product_id_us5',
      'image_head',
      'icon_flg1',
      'icon_term_end1',
      'icon_flg2',
      'icon_term_end2',
      'icon_flg3',
      'icon_term_end3',
      'icon_flg4',
      'icon_term_end4',
      'icon_flg5',
      'icon_term_end5',
      'icon_flg6',
      'icon_term_end6',
      'icon_flg7',
      'icon_term_end7',
      'icon_flg8',
      'icon_term_end8',
      'icon_flg9',
      'icon_term_end9',
      'icon_flg10',
      'icon_term_end10',
      'use_variation_flg',
      'reservation_flg',
      'fixed_purchase_flg',
      'mall_cooperated_flg',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'search_keyword',
      'member_rank_discount_flg',
      'display_member_rank',
      'buyable_member_rank',
      'google_shopping_flg',
      'product_option_settings',
      'arrival_mail_valid_flg',
      'release_mail_valid_flg',
      'resale_mail_valid_flg',
      'select_variation_kbn',
      'brand_id1',
      'brand_id2',
      'brand_id3',
      'brand_id4',
      'brand_id5',
      'use_recommend_flg',
      'gift_flg',
      'age_limit_flg',
      'plural_shipping_price_free_flg',
      'digital_contents_flg',
      'download_url',
      'display_sell_flg',
      'display_priority',
      'limited_payment_ids',
      'fixed_purchase_firsttime_price',
      'fixed_purchase_price',
      'bundle_item_display_type',
      'product_type',
      'limited_fixed_purchase_kbn1_setting',
      'limited_fixed_purchase_kbn3_setting',
      'recommend_product_id',
      'cooperation_id6',
      'cooperation_id7',
      'cooperation_id8',
      'cooperation_id9',
      'cooperation_id10',
      'fixed_purchase_product_order_limit_flg',
      'andmall_reservation_flg',
      'product_color_id',
      'display_only_fixed_purchase_member_flg',
      'sell_only_fixed_purchase_member_flg',
      'product_weight_gram',
      'tax_category_id',
      'product_order_limit_flg_fp',
      'fixed_purchase_cancelable_count',
      'fixed_purchase_limited_user_level_ids',
      'fixed_purchase_next_shipping_product_id',
      'fixed_purchase_next_shipping_variation_id',
      'fixed_purchase_next_shipping_item_quantity',
      'fixed_purchase_limited_skipped_count',
      'next_shipping_item_fixed_purchase_kbn',
      'next_shipping_item_fixed_purchase_setting',
      'product_size_factor',
      'add_cart_url_limit_flg',
      'limited_fixed_purchase_kbn4_setting',
      'medicine_classification',
      'pos_cooperation_id',
      'temperature_zones',
      'slug'
    ],
    requiredCsv: ['shop_id', 'product_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'product_id', label: '商品ID' },
          { key: 'supplier_id', label: 'サプライヤID' },
          { key: 'maker_id', label: 'メーカーID' },
          { key: 'maker_name', label: 'メーカー名' },
          { key: 'mall_ex_product_id', label: 'モール拡張商品ID' },
          { key: 'recommend_product_id', label: 'レコメンド連携用商品ID' },
          { key: 'pos_cooperation_id', label: 'POS連携ID' },
          { key: 'slug', label: 'スラッグ' }
        ]
      },
      {
        title: '連携ID',
        fields: [
          { key: 'cooperation_id1', label: '商品連携ID1' },
          { key: 'cooperation_id2', label: '商品連携ID2' },
          { key: 'cooperation_id3', label: '商品連携ID3' },
          { key: 'cooperation_id4', label: '商品連携ID4' },
          { key: 'cooperation_id5', label: '商品連携ID5' },
          { key: 'cooperation_id6', label: '商品連携ID6' },
          { key: 'cooperation_id7', label: '商品連携ID7' },
          { key: 'cooperation_id8', label: '商品連携ID8' },
          { key: 'cooperation_id9', label: '商品連携ID9' },
          { key: 'cooperation_id10', label: '商品連携ID10' }
        ]
      },
      {
        title: '商品名・説明',
        fields: [
          { key: 'name', label: '商品名' },
          { key: 'name_kana', label: '商品名かな' },
          { key: 'name2', label: '商品名2' },
          { key: 'name2_kana', label: '商品名2かな' },
          { key: 'catchcopy', label: 'キャッチコピー' },
          { key: 'search_keyword', label: '検索キーワード' },
          { key: 'outline_kbn', label: '商品概要HTML区分' },
          { key: 'outline', label: '商品概要' },
          { key: 'desc_detail_kbn1', label: '商品詳細1 HTML区分' },
          { key: 'desc_detail1', label: '商品詳細1' },
          { key: 'desc_detail_kbn2', label: '商品詳細2 HTML区分' },
          { key: 'desc_detail2', label: '商品詳細2' },
          { key: 'desc_detail_kbn3', label: '商品詳細3 HTML区分' },
          { key: 'desc_detail3', label: '商品詳細3' },
          { key: 'desc_detail_kbn4', label: '商品詳細4 HTML区分' },
          { key: 'desc_detail4', label: '商品詳細4' },
          { key: 'return_exchange_message', label: '返品交換文言' },
          { key: 'note', label: '備考' }
        ]
      },
      {
        title: '価格・税',
        fields: [
          { key: 'display_price', label: '商品表示価格' },
          { key: 'display_special_price', label: '商品表示特別価格' },
          { key: 'tax_included_flg', label: '税込フラグ' },
          { key: 'tax_rate', label: '税率(%)' },
          { key: 'tax_round_type', label: '税計算方法' },
          { key: 'price_pretax', label: '税込販売価格' },
          { key: 'price_cost', label: '商品原価' },
          { key: 'tax_category_id', label: '税率カテゴリID' }
        ]
      },
      {
        title: '配送',
        fields: [
          { key: 'price_shipping', label: '配送料' },
          { key: 'shipping_type', label: '配送料種別' },
          { key: 'shipping_size_kbn', label: '配送サイズ区分' },
          { key: 'plural_shipping_price_free_flg', label: '配送料金複数個無料フラグ' },
          { key: 'product_weight_gram', label: '商品重量(g)' },
          { key: 'product_size_factor', label: '商品サイズ係数' },
          { key: 'temperature_zones', label: '配送可能温度帯' }
        ]
      },
      {
        title: 'ポイント',
        fields: [
          { key: 'point_kbn1', label: '付与ポイント区分1' },
          { key: 'point1', label: '付与ポイント1' },
          { key: 'point_kbn2', label: '付与ポイント区分2（定期用）' },
          { key: 'point2', label: '付与ポイント2（定期用）' },
          { key: 'point_kbn3', label: '付与ポイント区分3' },
          { key: 'point3', label: '付与ポイント3' },
          { key: 'campaign_from', label: 'キャンペーン期間(FROM)' },
          { key: 'campaign_to', label: 'キャンペーン期間(TO)' },
          { key: 'campaign_point_kbn', label: 'キャンペーン付与ポイント区分' },
          { key: 'campaign_point', label: 'キャンペーン付与ポイント' }
        ]
      },
      {
        title: '期間・表示',
        fields: [
          { key: 'display_from', label: '表示期間(FROM)' },
          { key: 'display_to', label: '表示期間(TO)' },
          { key: 'sell_from', label: '販売期間(FROM)' },
          { key: 'sell_to', label: '販売期間(TO)' },
          { key: 'before_sale_display_kbn', label: '販売期間前表示フラグ' },
          { key: 'after_sale_display_kbn', label: '販売期間後表示フラグ' },
          { key: 'display_sell_flg', label: '販売期間表示フラグ' },
          { key: 'display_kbn', label: '検索時表示区分' },
          { key: 'display_priority', label: '表示優先順' }
        ]
      },
      {
        title: '在庫管理',
        fields: [
          { key: 'max_sell_quantity', label: '販売可能数' },
          { key: 'stock_management_kbn', label: '在庫管理方法' },
          { key: 'stock_disp_kbn', label: '在庫表示区分' },
          { key: 'stock_message_id', label: '商品在庫文言ID' }
        ]
      },
      {
        title: 'カテゴリ',
        fields: [
          { key: 'category_id1', label: 'カテゴリID1' },
          { key: 'category_id2', label: 'カテゴリID2' },
          { key: 'category_id3', label: 'カテゴリID3' },
          { key: 'category_id4', label: 'カテゴリID4' },
          { key: 'category_id5', label: 'カテゴリID5' }
        ]
      },
      {
        title: 'ブランド',
        fields: [
          { key: 'brand_id1', label: 'ブランドID1' },
          { key: 'brand_id2', label: 'ブランドID2' },
          { key: 'brand_id3', label: 'ブランドID3' },
          { key: 'brand_id4', label: 'ブランドID4' },
          { key: 'brand_id5', label: 'ブランドID5' }
        ]
      },
      {
        title: '関連商品（クロスセル）',
        fields: [
          { key: 'related_product_id_cs1', label: '関連商品ID1' },
          { key: 'related_product_id_cs2', label: '関連商品ID2' },
          { key: 'related_product_id_cs3', label: '関連商品ID3' },
          { key: 'related_product_id_cs4', label: '関連商品ID4' },
          { key: 'related_product_id_cs5', label: '関連商品ID5' }
        ]
      },
      {
        title: '関連商品（アップセル）',
        fields: [
          { key: 'related_product_id_us1', label: '関連商品ID1' },
          { key: 'related_product_id_us2', label: '関連商品ID2' },
          { key: 'related_product_id_us3', label: '関連商品ID3' },
          { key: 'related_product_id_us4', label: '関連商品ID4' },
          { key: 'related_product_id_us5', label: '関連商品ID5' }
        ]
      },
      {
        title: '画像・アイコン',
        fields: [
          { key: 'image_head', label: '商品画像名ヘッダ' },
          { key: 'icon_flg1', label: 'アイコンフラグ1' },
          { key: 'icon_term_end1', label: 'アイコン有効期限1' },
          { key: 'icon_flg2', label: 'アイコンフラグ2' },
          { key: 'icon_term_end2', label: 'アイコン有効期限2' },
          { key: 'icon_flg3', label: 'アイコンフラグ3' },
          { key: 'icon_term_end3', label: 'アイコン有効期限3' },
          { key: 'icon_flg4', label: 'アイコンフラグ4' },
          { key: 'icon_term_end4', label: 'アイコン有効期限4' },
          { key: 'icon_flg5', label: 'アイコンフラグ5' },
          { key: 'icon_term_end5', label: 'アイコン有効期限5' },
          { key: 'icon_flg6', label: 'アイコンフラグ6' },
          { key: 'icon_term_end6', label: 'アイコン有効期限6' },
          { key: 'icon_flg7', label: 'アイコンフラグ7' },
          { key: 'icon_term_end7', label: 'アイコン有効期限7' },
          { key: 'icon_flg8', label: 'アイコンフラグ8' },
          { key: 'icon_term_end8', label: 'アイコン有効期限8' },
          { key: 'icon_flg9', label: 'アイコンフラグ9' },
          { key: 'icon_term_end9', label: 'アイコン有効期限9' },
          { key: 'icon_flg10', label: 'アイコンフラグ10' },
          { key: 'icon_term_end10', label: 'アイコン有効期限10' },
          { key: 'product_color_id', label: '商品カラーID' }
        ]
      },
      {
        title: 'URL・問い合わせ',
        fields: [
          { key: 'url', label: '紹介URL' },
          { key: 'inquire_email', label: '問い合わせ用メールアドレス' },
          { key: 'inquire_tel', label: '問い合わせ用電話番号' },
          { key: 'download_url', label: 'ダウンロードURL' }
        ]
      },
      {
        title: '会員ランク・制限',
        fields: [
          { key: 'member_rank_discount_flg', label: '会員ランク割引対象フラグ' },
          { key: 'display_member_rank', label: '閲覧可能会員ランク' },
          { key: 'buyable_member_rank', label: '購入可能会員ランク' },
          { key: 'age_limit_flg', label: '年齢制限フラグ' },
          { key: 'limited_payment_ids', label: '決済利用不可' },
          { key: 'add_cart_url_limit_flg', label: 'カート投入URL制限フラグ' }
        ]
      },
      {
        title: '各種フラグ',
        fields: [
          { key: 'use_variation_flg', label: '複数バリエーション使用フラグ' },
          { key: 'reservation_flg', label: '予約商品フラグ' },
          { key: 'mall_cooperated_flg', label: 'モール連携済フラグ' },
          { key: 'valid_flg', label: '有効フラグ' },
          { key: 'del_flg', label: '削除フラグ' },
          { key: 'google_shopping_flg', label: 'Googleショッピング連携フラグ' },
          { key: 'use_recommend_flg', label: '外部レコメンド利用フラグ' },
          { key: 'gift_flg', label: 'ギフト購入フラグ' },
          { key: 'digital_contents_flg', label: 'デジタルコンテンツ商品フラグ' },
          { key: 'arrival_mail_valid_flg', label: '再入荷通知メール有効フラグ' },
          { key: 'release_mail_valid_flg', label: '販売開始通知メール有効フラグ' },
          { key: 'resale_mail_valid_flg', label: '再販売通知メール有効フラグ' },
          { key: 'andmall_reservation_flg', label: '&mallの予約商品フラグ' },
          { key: 'medicine_classification', label: '医薬品分類項目' }
        ]
      },
      {
        title: 'バリエーション・付帯情報',
        fields: [
          { key: 'select_variation_kbn', label: 'PC用商品詳細バリエーション選択方法' },
          { key: 'product_option_settings', label: '商品付帯情報設定' },
          { key: 'bundle_item_display_type', label: '同梱商品明細表示フラグ' },
          { key: 'product_type', label: '商品区分' }
        ]
      },
      {
        title: '定期購入',
        fields: [
          { key: 'fixed_purchase_flg', label: '定期購入フラグ' },
          { key: 'fixed_purchase_firsttime_price', label: '定期初回購入価格' },
          { key: 'fixed_purchase_price', label: '定期購入価格' },
          {
            key: 'fixed_purchase_product_order_limit_flg',
            label: '定期購入初回購入チェックフラグ'
          },
          { key: 'product_order_limit_flg_fp', label: '通常購入初回購入チェックフラグ' },
          { key: 'fixed_purchase_cancelable_count', label: '定期解約可能回数' },
          { key: 'fixed_purchase_limited_user_level_ids', label: '定期購入制限ユーザレベル' },
          { key: 'fixed_purchase_next_shipping_product_id', label: '定期2回目以降配送商品ID' },
          {
            key: 'fixed_purchase_next_shipping_variation_id',
            label: '定期2回目以降配送バリエーションID'
          },
          { key: 'fixed_purchase_next_shipping_item_quantity', label: '定期2回目以降配送注文個数' },
          { key: 'fixed_purchase_limited_skipped_count', label: '定期購入スキップ制限回数' },
          { key: 'next_shipping_item_fixed_purchase_kbn', label: '定期2回目以降配送 定期購入区分' },
          {
            key: 'next_shipping_item_fixed_purchase_setting',
            label: '定期2回目以降配送 定期購入設定'
          },
          { key: 'limited_fixed_purchase_kbn1_setting', label: '利用不可定期購入配送周期月' },
          { key: 'limited_fixed_purchase_kbn3_setting', label: '利用不可定期購入配送周期日' },
          { key: 'limited_fixed_purchase_kbn4_setting', label: '利用不可定期購入配送周期週' },
          { key: 'display_only_fixed_purchase_member_flg', label: '定期会員限定フラグ（閲覧）' },
          { key: 'sell_only_fixed_purchase_member_flg', label: '定期会員限定フラグ（販売）' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_BRAND]: {
    masterType: MasterType.W2_PRODUCT_BRAND,
    title: 'W2商品ブランド',
    columns: [
      { key: 'brand_id', label: 'ブランドID', sortable: true },
      { key: 'brand_name', label: 'ブランド名', sortable: true },
      { key: 'brand_title', label: 'ブランドタイトル' },
      { key: 'default_flg', label: 'デフォルト設定' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['brand_id', 'brand_name', 'brand_title', 'seo_keyword'],
    pkColumns: ['brand_id'],
    csvHeaders: [
      'brand_id',
      'brand_name',
      'brand_title',
      'additional_design_tag',
      'seo_keyword',
      'default_flg',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['brand_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'brand_id', label: 'ブランドID' },
          { key: 'brand_name', label: 'ブランド名' },
          { key: 'brand_title', label: 'ブランドタイトル（SEO表示用）' },
          { key: 'seo_keyword', label: 'SEOキーワード' },
          { key: 'additional_design_tag', label: '追加デザインタグ' },
          { key: 'default_flg', label: 'デフォルト設定フラグ' },
          { key: 'valid_flg', label: '有効フラグ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_CATEGORY]: {
    masterType: MasterType.W2_PRODUCT_CATEGORY,
    title: 'W2商品カテゴリ',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'category_id', label: 'カテゴリID', sortable: true },
      { key: 'parent_category_id', label: '親カテゴリID' },
      { key: 'name', label: 'カテゴリ名', sortable: true },
      { key: 'display_order', label: '表示順' },
      { key: 'use_recommend_flg', label: 'レコメンド' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'shop_id',
      'category_id',
      'category_name',
      'name_kana',
      'parent_category_id',
      'slug'
    ],
    pkColumns: ['shop_id', 'category_id'],
    csvHeaders: [
      'shop_id',
      'category_id',
      'parent_category_id',
      'name',
      'url',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'permitted_brand_ids',
      'use_recommend_flg',
      'member_rank_id',
      'lower_member_can_display_tree_flg',
      'name_kana',
      'display_order',
      'child_category_sort_kbn',
      'only_fixed_purchase_member_flg',
      'canonical_text',
      'slug'
    ],
    requiredCsv: ['shop_id', 'category_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'category_id', label: 'カテゴリID' },
          { key: 'parent_category_id', label: '親カテゴリID' },
          { key: 'name', label: 'カテゴリ名' },
          { key: 'name_kana', label: 'カテゴリカナ名' },
          { key: 'url', label: 'カテゴリページURL' },
          { key: 'slug', label: 'スラッグ' },
          { key: 'canonical_text', label: 'カノニカルタグ用テキスト' }
        ]
      },
      {
        title: '表示・並び順',
        fields: [
          { key: 'display_order', label: '表示順' },
          { key: 'child_category_sort_kbn', label: '子カテゴリの並び順' },
          { key: 'valid_flg', label: '有効フラグ' },
          { key: 'del_flg', label: '削除フラグ' }
        ]
      },
      {
        title: '制限・連携',
        fields: [
          { key: 'permitted_brand_ids', label: '許可ブランドID' },
          { key: 'use_recommend_flg', label: '外部レコメンド利用フラグ' },
          { key: 'member_rank_id', label: '閲覧可能会員ランクID' },
          {
            key: 'lower_member_can_display_tree_flg',
            label: '会員ランク表示制御：カテゴリツリー表示フラグ'
          },
          { key: 'only_fixed_purchase_member_flg', label: '定期会員限定フラグ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_TAG]: {
    masterType: MasterType.W2_PRODUCT_TAG,
    title: 'W2商品タグ',
    columns: [
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'date_created', label: '作成日', sortable: true },
      { key: 'date_changed', label: '更新日', sortable: true },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['product_id'],
    pkColumns: ['product_id'],
    csvHeaders: ['product_id', 'date_created', 'date_changed', 'last_changed'],
    requiredCsv: ['product_id'],
    detailSections: []
  },
  [MasterType.W2_PRODUCT_TAG_SETTING]: {
    masterType: MasterType.W2_PRODUCT_TAG_SETTING,
    title: '商品タグ設定',
    columns: [
      { key: 'tag_no', label: 'タグNo', sortable: true },
      { key: 'tag_id', label: 'タグID', sortable: true },
      { key: 'tag_name', label: 'タイトル', sortable: true },
      { key: 'tag_discription', label: '説明' },
      { key: 'tag_valid_flg', label: '有効フラグ', sortable: true },
      { key: 'date_created', label: '作成日', sortable: true },
      { key: 'date_changed', label: '更新日', sortable: true }
    ],
    searchColumns: ['tag_no', 'tag_id', 'tag_name'],
    pkColumns: ['tag_no'],
    csvHeaders: [
      'tag_no',
      'tag_id',
      'tag_name',
      'tag_discription',
      'tag_valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['tag_no']
  },
  [MasterType.W2_PRODUCT_STOCK]: {
    masterType: MasterType.W2_PRODUCT_STOCK,
    title: 'W2商品在庫',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: 'バリエーションID' },
      { key: 'stock', label: '在庫数', sortable: true },
      { key: 'stock_alert', label: '安全基準' },
      { key: 'realstock', label: '実在庫A' },
      { key: 'realstock_b', label: '実在庫B' },
      { key: 'realstock_c', label: '実在庫C' },
      { key: 'realstock_reserved', label: '引当済' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['shop_id', 'product_id', 'variation_id'],
    pkColumns: ['shop_id', 'product_id', 'variation_id'],
    csvHeaders: [
      'shop_id',
      'product_id',
      'variation_id',
      'stock',
      'stock_alert',
      'realstock',
      'realstock_b',
      'realstock_c',
      'realstock_reserved',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_id', 'variation_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'product_id', label: '商品ID' },
          { key: 'variation_id', label: '商品バリエーションID' }
        ]
      },
      {
        title: '在庫数',
        fields: [
          { key: 'stock', label: '商品在庫数' },
          { key: 'stock_alert', label: '商品在庫安全基準' },
          { key: 'realstock', label: '実在庫数A' },
          { key: 'realstock_b', label: '実在庫数B' },
          { key: 'realstock_c', label: '実在庫数C' },
          { key: 'realstock_reserved', label: '引当済実在庫数' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_VARIATION]: {
    masterType: MasterType.W2_PRODUCT_VARIATION,
    title: 'W2商品バリエーション',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: 'バリエーションID' },
      { key: 'variation_name1', label: 'バリエーション名1' },
      { key: 'variation_name2', label: 'バリエーション名2' },
      { key: 'variation_name3', label: 'バリエーション名3' },
      { key: 'price', label: '販売価格', sortable: true },
      { key: 'special_price', label: '特別価格' },
      { key: 'display_order', label: '表示順', sortable: true },
      { key: 'valid_flg', label: '有効フラグ' }
    ],
    searchColumns: ['shop_id', 'product_id', 'variation_id'],
    pkColumns: ['shop_id', 'product_id', 'variation_id'],
    csvHeaders: [
      'shop_id',
      'product_id',
      'variation_id',
      'variation_cooperation_id1',
      'variation_cooperation_id2',
      'variation_cooperation_id3',
      'variation_cooperation_id4',
      'variation_cooperation_id5',
      'mall_variation_id1',
      'mall_variation_id2',
      'mall_variation_type',
      'variation_name1',
      'variation_name2',
      'variation_name3',
      'price',
      'special_price',
      'variation_image_head',
      'shipping_type',
      'shipping_size_kbn',
      'display_order',
      'variation_mall_cooperated_flg',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'variation_download_url',
      'variation_fixed_purchase_firsttime_price',
      'variation_fixed_purchase_price',
      'variation_cooperation_id6',
      'variation_cooperation_id7',
      'variation_cooperation_id8',
      'variation_cooperation_id9',
      'variation_cooperation_id10',
      'variation_color_id',
      'variation_andmall_reservation_flg',
      'variation_weight_gram',
      'variation_add_cart_url_limit_flg',
      'variation_pos_cooperation_id'
    ],
    requiredCsv: ['shop_id', 'product_id', 'variation_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'product_id', label: '商品ID' },
          { key: 'variation_id', label: '商品バリエーションID' },
          { key: 'variation_name1', label: 'バリエーション名1' },
          { key: 'variation_name2', label: 'バリエーション名2' },
          { key: 'variation_name3', label: 'バリエーション名3' },
          { key: 'variation_color_id', label: '商品カラーID' }
        ]
      },
      {
        title: '価格',
        fields: [
          { key: 'price', label: '販売価格' },
          { key: 'special_price', label: '特別価格' },
          { key: 'variation_fixed_purchase_firsttime_price', label: '定期初回購入価格' },
          { key: 'variation_fixed_purchase_price', label: '定期購入価格' }
        ]
      },
      {
        title: '配送・表示',
        fields: [
          { key: 'shipping_type', label: '配送料種別' },
          { key: 'shipping_size_kbn', label: '配送サイズ区分' },
          { key: 'variation_weight_gram', label: '商品バリエーション重量（g）' },
          { key: 'variation_image_head', label: 'バリエーション画像名ヘッダ' },
          { key: 'display_order', label: '表示順' },
          { key: 'valid_flg', label: '有効フラグ' },
          { key: 'del_flg', label: '削除フラグ' },
          { key: 'variation_add_cart_url_limit_flg', label: 'カート投入URL制限フラグ' },
          { key: 'variation_download_url', label: 'ダウンロードURL' }
        ]
      },
      {
        title: '外部連携ID',
        fields: [
          { key: 'variation_cooperation_id1', label: '連携ID1' },
          { key: 'variation_cooperation_id2', label: '連携ID2' },
          { key: 'variation_cooperation_id3', label: '連携ID3' },
          { key: 'variation_cooperation_id4', label: '連携ID4' },
          { key: 'variation_cooperation_id5', label: '連携ID5' },
          { key: 'variation_cooperation_id6', label: '連携ID6' },
          { key: 'variation_cooperation_id7', label: '連携ID7' },
          { key: 'variation_cooperation_id8', label: '連携ID8' },
          { key: 'variation_cooperation_id9', label: '連携ID9' },
          { key: 'variation_cooperation_id10', label: '連携ID10' },
          { key: 'mall_variation_id1', label: 'モールバリエーションID1' },
          { key: 'mall_variation_id2', label: 'モールバリエーションID2' },
          { key: 'mall_variation_type', label: 'モールバリエーション種別' },
          { key: 'variation_mall_cooperated_flg', label: 'モール連携済フラグ' },
          { key: 'variation_andmall_reservation_flg', label: '&mallの予約商品フラグ' },
          { key: 'variation_pos_cooperation_id', label: 'POS連携ID' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_PRICE]: {
    masterType: MasterType.W2_PRODUCT_PRICE,
    title: 'W2商品価格',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: 'バリエーションID' },
      { key: 'member_rank_id', label: '会員ランクID' },
      { key: 'member_rank_price', label: '会員価格', sortable: true },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['shop_id', 'product_id', 'variation_id', 'member_rank_id'],
    pkColumns: ['shop_id', 'product_id', 'variation_id', 'member_rank_id'],
    csvHeaders: [
      'shop_id',
      'product_id',
      'variation_id',
      'member_rank_id',
      'member_rank_price',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_id', 'variation_id', 'member_rank_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'product_id', label: '商品ID' },
          { key: 'variation_id', label: '商品バリエーションID' },
          { key: 'member_rank_id', label: '会員ランクID' }
        ]
      },
      {
        title: '価格',
        fields: [{ key: 'member_rank_price', label: '会員価格' }]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_CART]: {
    masterType: MasterType.W2_CART,
    title: 'W2カート',
    columns: [
      { key: 'cart_id', label: 'カートID', sortable: true },
      { key: 'cart_item_no', label: '枝番' },
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: 'バリエーションID' },
      { key: 'product_count', label: '商品注文数' },
      { key: 'fixed_purchase_flg', label: '定期購入' },
      { key: 'del_flg', label: '削除' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['cart_id', 'user_id', 'product_id', 'variation_id'],
    pkColumns: ['cart_id', 'cart_item_no'],
    csvHeaders: [
      'cart_id',
      'cart_item_no',
      'user_id',
      'shop_id',
      'supplier_id',
      'product_id',
      'variation_id',
      'product_count',
      'product_set_id',
      'product_set_no',
      'product_set_count',
      'cart_div_type1',
      'cart_div_type2',
      'cart_div_type3',
      'kbn1',
      'kbn2',
      'kbn3',
      'productsale_id',
      'fixed_purchase_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'product_option_texts',
      'gift_order_flg',
      'novelty_id',
      'recommend_id'
    ],
    requiredCsv: ['cart_id', 'cart_item_no'],
    detailSections: [
      {
        title: 'カート基本情報',
        fields: [
          { key: 'cart_id', label: 'カートID' },
          { key: 'cart_item_no', label: '枝番' },
          { key: 'user_id', label: 'ユーザID' },
          { key: 'shop_id', label: '店舗ID' },
          { key: 'supplier_id', label: 'サプライヤID' }
        ]
      },
      {
        title: '商品情報',
        fields: [
          { key: 'product_id', label: '商品ID' },
          { key: 'variation_id', label: '商品バリエーションID' },
          { key: 'product_count', label: '商品注文数' },
          { key: 'product_option_texts', label: '商品付帯情報選択値' },
          { key: 'productsale_id', label: '商品セールID' }
        ]
      },
      {
        title: 'セット商品',
        fields: [
          { key: 'product_set_id', label: '商品セットID' },
          { key: 'product_set_no', label: '商品セット枝番' },
          { key: 'product_set_count', label: '商品セット注文数' }
        ]
      },
      {
        title: 'カート分割・区分',
        fields: [
          { key: 'cart_div_type1', label: 'カート分割基準1（配送種別）' },
          { key: 'cart_div_type2', label: 'カート分割基準2（デジタルコンテンツ）' },
          { key: 'cart_div_type3', label: 'カート分割基準3' },
          { key: 'kbn1', label: '区分1' },
          { key: 'kbn2', label: '区分2' },
          { key: 'kbn3', label: '区分3' }
        ]
      },
      {
        title: 'フラグ',
        fields: [
          { key: 'fixed_purchase_flg', label: '定期購入フラグ' },
          { key: 'gift_order_flg', label: 'ギフト購入フラグ' },
          { key: 'del_flg', label: '削除フラグ' }
        ]
      },
      {
        title: 'その他',
        fields: [
          { key: 'novelty_id', label: 'ノベルティID' },
          { key: 'recommend_id', label: 'レコメンドID' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' }
        ]
      }
    ]
  },
  [MasterType.W2_ORDER]: {
    masterType: MasterType.W2_ORDER,
    title: 'W2受注マスタ',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_id_org', label: '元注文ID' },
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'order_kbn', label: '注文区分' },
      { key: 'order_status', label: '注文ステータス', sortable: true },
      { key: 'order_date', label: '注文日時', sortable: true },
      { key: 'order_price_total', label: '支払金額合計' },
      { key: 'order_payment_status', label: '入金ステータス' },
      { key: 'del_flg', label: '削除' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['order_id', 'order_id_org', 'user_id', 'order_status', 'fixed_purchase_id'],
    pkColumns: ['order_id'],
    csvHeaders: [
      'order_id',
      'order_id_org',
      'order_group_id',
      'order_no',
      'user_id',
      'shop_id',
      'supplier_id',
      'order_kbn',
      'mall_id',
      'order_payment_kbn',
      'order_status',
      'order_date',
      'order_recognition_date',
      'order_stockreserved_status',
      'order_stockreserved_date',
      'order_shipping_date',
      'order_shipped_status',
      'order_shipped_date',
      'order_delivering_date',
      'order_cancel_date',
      'order_return_date',
      'order_payment_status',
      'order_payment_date',
      'demand_status',
      'demand_date',
      'order_return_exchange_status',
      'order_repayment_status',
      'order_item_count',
      'order_product_count',
      'order_price_subtotal',
      'order_price_tax',
      'order_price_shipping',
      'order_price_exchange',
      'order_price_regulation',
      'order_price_repayment',
      'order_price_total',
      'order_point_use',
      'order_point_use_yen',
      'order_point_add',
      'order_coupon_use',
      'card_kbn',
      'card_tran_id',
      'shipping_id',
      'fixed_purchase_id',
      'advcode_first',
      'advcode_new',
      'return_exchange_kbn',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'member_rank_id',
      'gift_flg',
      'external_payment_status',
      'payment_order_id',
      'external_order_id',
      'settlement_currency',
      'real_shop_id',
      'staff_id'
    ],
    requiredCsv: ['order_id'],
    detailSections: [
      {
        title: '注文基本情報',
        fields: [
          { key: 'order_id', label: '注文ID' },
          { key: 'order_id_org', label: '元注文ID' },
          { key: 'order_group_id', label: '注文グループID' },
          { key: 'order_no', label: '注文番号' },
          { key: 'user_id', label: 'ユーザID' },
          { key: 'shop_id', label: '店舗ID' },
          { key: 'supplier_id', label: 'サプライヤID' },
          { key: 'order_kbn', label: '注文区分' },
          { key: 'mall_id', label: 'モールID' },
          { key: 'order_payment_kbn', label: '支払区分' }
        ]
      },
      {
        title: 'ステータス・日時',
        fields: [
          { key: 'order_status', label: '注文ステータス' },
          { key: 'order_date', label: '注文日時' },
          { key: 'order_recognition_date', label: '受注承認日時' },
          { key: 'order_stockreserved_status', label: '在庫引当ステータス' },
          { key: 'order_stockreserved_date', label: '在庫引当日時' },
          { key: 'order_shipping_date', label: '出荷手配日時' },
          { key: 'order_shipped_status', label: '出荷ステータス' },
          { key: 'order_shipped_date', label: '出荷完了日時' },
          { key: 'order_delivering_date', label: '配送完了日時' },
          { key: 'order_cancel_date', label: 'キャンセル日時' },
          { key: 'order_return_date', label: '返品日時' }
        ]
      },
      {
        title: '入金・督促',
        fields: [
          { key: 'order_payment_status', label: '入金ステータス' },
          { key: 'order_payment_date', label: '入金確認日時' },
          { key: 'demand_status', label: '督促ステータス' },
          { key: 'demand_date', label: '督促日時' }
        ]
      },
      {
        title: '返品交換・返金',
        fields: [
          { key: 'order_return_exchange_status', label: '返品交換ステータス' },
          { key: 'return_exchange_kbn', label: '返品交換区分' },
          { key: 'return_exchange_reason_kbn', label: '返品交換都合区分' },
          { key: 'order_return_exchange_receipt_date', label: '返品交換受付日時' },
          { key: 'order_return_exchange_arrival_date', label: '返品交換商品到着日時' },
          { key: 'order_return_exchange_complete_date', label: '返品交換完了日時' },
          { key: 'order_repayment_status', label: '返金ステータス' },
          { key: 'order_repayment_date', label: '返金日時' },
          { key: 'order_price_repayment', label: '返金金額' },
          { key: 'shipped_changed_kbn', label: '出荷後変更区分' },
          { key: 'return_exchange_reason_memo', label: '返品交換理由メモ' }
        ]
      },
      {
        title: '金額',
        fields: [
          { key: 'order_item_count', label: '注文アイテム数' },
          { key: 'order_product_count', label: '注文商品数' },
          { key: 'order_price_subtotal', label: '小計' },
          { key: 'order_price_pack', label: '荷造金額' },
          { key: 'order_price_tax', label: '税金合計' },
          { key: 'order_price_shipping', label: '配送料' },
          { key: 'order_price_exchange', label: '代引手数料' },
          { key: 'order_price_regulation', label: '調整金額' },
          { key: 'order_price_total', label: '支払金額合計' },
          { key: 'order_discount_set_price', label: 'セット値引金額' },
          { key: 'last_billed_amount', label: '最終請求金額' },
          { key: 'member_rank_discount_price', label: '会員ランク割引額' },
          { key: 'member_rank_discount_price_shipping', label: '会員ランク送料割引額' }
        ]
      },
      {
        title: 'ポイント・クーポン',
        fields: [
          { key: 'order_point_use', label: '利用ポイント数' },
          { key: 'order_point_use_yen', label: 'ポイント利用額' },
          { key: 'order_point_add', label: '付与ポイント' },
          { key: 'order_point_rate', label: 'ポイント調整率' },
          { key: 'order_coupon_use', label: 'クーポン割引額' },
          { key: 'order_coupon_use_shipping', label: 'クーポン送料割引額' },
          { key: 'last_order_point_use', label: '最終利用ポイント数' },
          { key: 'last_order_point_use_yen', label: '最終ポイント利用額' }
        ]
      },
      {
        title: '決済情報',
        fields: [
          { key: 'card_kbn', label: '決済カード区分' },
          { key: 'card_instruments', label: '決済カード支払回数文言' },
          { key: 'card_tran_id', label: '決済カード取引ID' },
          { key: 'card_tran_pass', label: '決済カード取引PASS' },
          { key: 'card_installments_code', label: 'カード支払い回数コード' },
          { key: 'card_3dsecure_tran_id', label: '3DセキュアトランザクションID' },
          { key: 'credit_branch_no', label: 'クレジットカード枝番' },
          { key: 'payment_order_id', label: '決済注文ID' },
          { key: 'online_payment_status', label: 'オンライン決済ステータス' },
          { key: 'external_payment_status', label: '外部決済ステータス' },
          { key: 'external_payment_type', label: '外部決済タイプ' },
          { key: 'external_payment_error_message', label: '外部決済エラーメッセージ' },
          { key: 'external_payment_auth_date', label: '外部決済与信日時' },
          { key: 'settlement_currency', label: '決済通貨' },
          { key: 'settlement_rate', label: '決済レート' },
          { key: 'settlement_amount', label: '決済金額' }
        ]
      },
      {
        title: '定期購入',
        fields: [
          { key: 'fixed_purchase_id', label: '定期購入ID' },
          { key: 'fixed_purchase_order_count', label: '定期購入回数(注文時点)' },
          { key: 'fixed_purchase_shipped_count', label: '定期購入回数(出荷時点)' },
          { key: 'fixed_purchase_discount_price', label: '定期購入割引額' },
          { key: 'fixed_purchase_member_discount_amount', label: '定期会員割引額' }
        ]
      },
      {
        title: '配送',
        fields: [
          { key: 'shipping_id', label: '配送種別ID' },
          { key: 'shipping_memo', label: '配送メモ' },
          { key: 'shipping_tax_rate', label: '配送料税率' },
          { key: 'delivery_tran_id', label: '物流取引ID' },
          { key: 'online_delivery_status', label: 'オンライン物流ステータス' },
          { key: 'Logi_cooperation_status', label: '物流連携ステータス' },
          { key: 'invoice_bundle_flg', label: '請求書同梱フラグ' }
        ]
      },
      {
        title: '広告・アフィリエイト',
        fields: [
          { key: 'advcode_first', label: '初回広告コード' },
          { key: 'advcode_new', label: '最新広告コード' },
          { key: 'affiliate_session_name1', label: 'アフィリエイトセッション変数名1' },
          { key: 'affiliate_session_value1', label: 'アフィリエイトセッション値1' },
          { key: 'affiliate_session_name2', label: 'アフィリエイトセッション変数名2' },
          { key: 'affiliate_session_value2', label: 'アフィリエイトセッション値2' },
          { key: 'inflow_contents_id', label: '流入コンテンツID' },
          { key: 'inflow_contents_type', label: '流入コンテンツタイプ' }
        ]
      },
      {
        title: '拡張項目',
        fields: [
          { key: 'attribute1', label: '注文拡張項目1' },
          { key: 'attribute2', label: '注文拡張項目2' },
          { key: 'attribute3', label: '注文拡張項目3' },
          { key: 'attribute4', label: '注文拡張項目4' },
          { key: 'attribute5', label: '注文拡張項目5' },
          { key: 'attribute6', label: '注文拡張項目6' },
          { key: 'attribute7', label: '注文拡張項目7' },
          { key: 'attribute8', label: '注文拡張項目8' },
          { key: 'attribute9', label: '注文拡張項目9' },
          { key: 'attribute10', label: '注文拡張項目10' }
        ]
      },
      {
        title: 'メモ',
        fields: [
          { key: 'memo', label: 'メモ' },
          { key: 'payment_memo', label: '決済連携メモ' },
          { key: 'management_memo', label: '管理メモ' },
          { key: 'relation_memo', label: '外部連携メモ' },
          { key: 'regulation_memo', label: '調整金額メモ' },
          { key: 'repayment_memo', label: '返金メモ' },
          { key: 'shipping_memo', label: '配送メモ' }
        ]
      },
      {
        title: '外部連携',
        fields: [
          { key: 'external_order_id', label: '外部連携受注ID' },
          { key: 'external_import_status', label: '外部連携取込ステータス' },
          { key: 'combined_org_order_ids', label: '注文同梱元注文ID' },
          { key: 'last_auth_flg', label: '最終与信フラグ' },
          { key: 'mall_link_status', label: 'モール連携ステータス' },
          { key: 'external_payment_cooperation_log', label: '外部連携決済ログ' }
        ]
      },
      {
        title: 'その他',
        fields: [
          { key: 'remote_addr', label: 'リモートIPアドレス' },
          { key: 'user_agent', label: 'ユーザーエージェント' },
          { key: 'gift_flg', label: 'ギフト購入フラグ' },
          { key: 'digital_contents_flg', label: 'デジタルコンテンツ購入フラグ' },
          { key: 'member_rank_id', label: '注文時会員ランク' },
          { key: 'order_count_order', label: '購入回数（注文基準）' },
          { key: 'receipt_flg', label: '領収書希望フラグ' },
          { key: 'receipt_output_flg', label: '領収書出力フラグ' },
          { key: 'receipt_address', label: '宛名' },
          { key: 'receipt_proviso', label: '但し書き' },
          { key: 'medical_questionnaire_data', label: '問診票入力データ' },
          { key: 'real_shop_id', label: 'リアル店舗ID' },
          { key: 'staff_id', label: 'スタッフID' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'del_flg', label: '削除フラグ' },
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_ORDER_ITEM]: {
    masterType: MasterType.W2_ORDER_ITEM,
    title: 'W2受注明細',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_item_no', label: '枝番' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'product_name', label: '商品名', sortable: true },
      { key: 'product_price', label: '商品単価' },
      { key: 'item_quantity', label: '注文数' },
      { key: 'item_price', label: '明細金額' },
      { key: 'item_cancel_flg', label: 'キャンセル' },
      { key: 'del_flg', label: '削除' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['order_id', 'product_id', 'product_name', 'brand_id', 'variation_id'],
    pkColumns: ['order_id', 'order_item_no'],
    csvHeaders: [
      'order_id',
      'order_item_no',
      'order_shipping_no',
      'shop_id',
      'product_id',
      'variation_id',
      'supplier_id',
      'product_name',
      'product_name_kana',
      'product_price',
      'product_price_org',
      'product_point',
      'product_tax_included_flg',
      'product_tax_rate',
      'product_tax_round_type',
      'product_price_pretax',
      'product_price_ship',
      'product_price_cost',
      'product_point_kbn',
      'item_realstock_reserved',
      'item_realstock_shipped',
      'item_quantity',
      'item_quantity_single',
      'item_price',
      'item_price_single',
      'product_set_id',
      'product_set_no',
      'product_set_count',
      'item_return_exchange_kbn',
      'item_memo',
      'item_point',
      'item_cancel_flg',
      'item_cancel_date',
      'item_return_flg',
      'item_return_date',
      'del_flg',
      'date_created',
      'date_changed',
      'product_option_texts',
      'brand_id',
      'download_url',
      'productsale_id',
      'cooperation_id1',
      'cooperation_id2',
      'cooperation_id3',
      'cooperation_id4',
      'cooperation_id5',
      'stock_returned_flg',
      'novelty_id',
      'recommend_id',
      'fixed_purchase_product_flg',
      'product_bundle_id',
      'bundle_item_display_type',
      'order_history_display_type',
      'limited_payment_ids',
      'plural_shipping_price_free_flg',
      'shipping_size_kbn',
      'column_for_mall_order',
      'cooperation_id6',
      'cooperation_id7',
      'cooperation_id8',
      'cooperation_id9',
      'cooperation_id10',
      'gift_wrapping_id',
      'gift_message',
      'item_price_tax',
      'fixed_purchase_discount_value',
      'fixed_purchase_discount_type',
      'fixed_purchase_item_order_count',
      'fixed_purchase_item_shipped_count',
      'item_discounted_price',
      'temperature_zones'
    ],
    requiredCsv: ['order_id', 'order_item_no'],
    detailSections: [
      {
        title: '注文基本情報',
        fields: [
          { key: 'order_id', label: '注文ID' },
          { key: 'order_item_no', label: '注文商品枝番' },
          { key: 'order_shipping_no', label: '配送先枝番' },
          { key: 'shop_id', label: '店舗ID' },
          { key: 'supplier_id', label: 'サプライヤID' }
        ]
      },
      {
        title: '商品情報',
        fields: [
          { key: 'product_id', label: '商品ID' },
          { key: 'variation_id', label: '商品バリエーションID' },
          { key: 'product_name', label: '商品名' },
          { key: 'product_name_kana', label: '商品名かな' },
          { key: 'brand_id', label: 'ブランドID' }
        ]
      },
      {
        title: '価格・税',
        fields: [
          { key: 'product_price', label: '商品単価' },
          { key: 'product_price_org', label: '商品単価（値引き前）' },
          { key: 'product_tax_included_flg', label: '税込フラグ' },
          { key: 'product_tax_rate', label: '税率(%)' },
          { key: 'product_tax_round_type', label: '税計算方法' },
          { key: 'product_price_pretax', label: '税込販売価格' },
          { key: 'product_price_ship', label: '配送料' },
          { key: 'product_price_cost', label: '商品原価' }
        ]
      },
      {
        title: '数量・金額',
        fields: [
          { key: 'item_quantity', label: '注文数' },
          { key: 'item_quantity_single', label: '注文数（セット未考慮）' },
          { key: 'item_price', label: '明細金額（小計）' },
          { key: 'item_price_single', label: '明細金額（セット未考慮）' },
          { key: 'item_price_tax', label: '明細金額（税金額）' },
          { key: 'item_discounted_price', label: '明細金額（割引後価格）' }
        ]
      },
      {
        title: 'ポイント',
        fields: [
          { key: 'product_point', label: '商品ポイント' },
          { key: 'product_point_kbn', label: '付与ポイント区分' },
          { key: 'item_point', label: '明細ポイント' }
        ]
      },
      {
        title: 'セット商品',
        fields: [
          { key: 'product_set_id', label: '商品セットID' },
          { key: 'product_set_no', label: '商品セット枝番' },
          { key: 'product_set_count', label: '商品セット注文数' }
        ]
      },
      {
        title: '在庫・配送',
        fields: [
          { key: 'item_realstock_reserved', label: '実在庫引当済み商品数' },
          { key: 'item_realstock_shipped', label: '実在庫出荷済み商品数' },
          { key: 'stock_returned_flg', label: '在庫戻し済みフラグ' },
          { key: 'shipping_size_kbn', label: '配送サイズ区分' },
          { key: 'plural_shipping_price_free_flg', label: '配送料金複数個無料フラグ' },
          { key: 'temperature_zones', label: '配送可能温度帯' }
        ]
      },
      {
        title: 'キャンセル・返品',
        fields: [
          { key: 'item_return_exchange_kbn', label: '返品交換区分' },
          { key: 'item_cancel_flg', label: 'キャンセルフラグ' },
          { key: 'item_cancel_date', label: 'キャンセル日時' },
          { key: 'item_return_flg', label: '返品フラグ' },
          { key: 'item_return_date', label: '返品日時' },
          { key: 'del_flg', label: '削除フラグ' }
        ]
      },
      {
        title: '定期購入',
        fields: [
          { key: 'fixed_purchase_product_flg', label: '定期購入フラグ' },
          { key: 'fixed_purchase_discount_value', label: '定期購入値引' },
          { key: 'fixed_purchase_discount_type', label: '定期購入値引タイプ' },
          { key: 'fixed_purchase_item_order_count', label: '定期商品購入回数(注文時点)' },
          { key: 'fixed_purchase_item_shipped_count', label: '定期商品購入回数(出荷時点)' }
        ]
      },
      {
        title: '連携ID',
        fields: [
          { key: 'cooperation_id1', label: '商品連携ID1' },
          { key: 'cooperation_id2', label: '商品連携ID2' },
          { key: 'cooperation_id3', label: '商品連携ID3' },
          { key: 'cooperation_id4', label: '商品連携ID4' },
          { key: 'cooperation_id5', label: '商品連携ID5' },
          { key: 'cooperation_id6', label: '商品連携ID6' },
          { key: 'cooperation_id7', label: '商品連携ID7' },
          { key: 'cooperation_id8', label: '商品連携ID8' },
          { key: 'cooperation_id9', label: '商品連携ID9' },
          { key: 'cooperation_id10', label: '商品連携ID10' }
        ]
      },
      {
        title: 'その他',
        fields: [
          { key: 'item_memo', label: '明細備考' },
          { key: 'product_option_texts', label: '商品付帯情報選択値' },
          { key: 'download_url', label: 'ダウンロードURL' },
          { key: 'productsale_id', label: '商品セールID' },
          { key: 'novelty_id', label: 'ノベルティID' },
          { key: 'recommend_id', label: 'レコメンドID' },
          { key: 'product_bundle_id', label: '商品同梱ID' },
          { key: 'bundle_item_display_type', label: '同梱商品明細表示フラグ' },
          { key: 'order_history_display_type', label: '明細表示フラグ（計算列）' },
          { key: 'limited_payment_ids', label: '決済利用不可' },
          { key: 'column_for_mall_order', label: 'モール用項目' },
          { key: 'gift_wrapping_id', label: 'ギフト包装ID' },
          { key: 'gift_message', label: 'ギフトメッセージ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' }
        ]
      }
    ]
  },
  [MasterType.W2_ORDER_COUPON]: {
    masterType: MasterType.W2_ORDER_COUPON,
    title: 'W2受注クーポン',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_coupon_no', label: '枝番' },
      { key: 'coupon_id', label: 'クーポンID', sortable: true },
      { key: 'coupon_code', label: 'クーポンコード', sortable: true },
      { key: 'coupon_name', label: '管理用クーポン名' },
      { key: 'coupon_disp_name', label: '表示用クーポン名' },
      { key: 'coupon_type', label: 'クーポン種別' },
      { key: 'coupon_discount_price', label: 'クーポン割引額' },
      { key: 'coupon_discount_rate', label: 'クーポン割引率' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['order_id', 'coupon_id', 'coupon_code', 'coupon_name'],
    pkColumns: ['order_id', 'order_coupon_no'],
    csvHeaders: [
      'order_id',
      'order_coupon_no',
      'dept_id',
      'coupon_id',
      'coupon_no',
      'coupon_code',
      'coupon_name',
      'coupon_disp_name',
      'coupon_type',
      'coupon_discount_price',
      'coupon_discount_rate',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['order_id', 'order_coupon_no'],
    detailSections: [
      {
        title: '注文情報',
        fields: [
          { key: 'order_id', label: '注文ID' },
          { key: 'order_coupon_no', label: '注文クーポン枝番' },
          { key: 'dept_id', label: '識別ID' }
        ]
      },
      {
        title: 'クーポン情報',
        fields: [
          { key: 'coupon_id', label: 'クーポンID' },
          { key: 'coupon_no', label: '枝番' },
          { key: 'coupon_code', label: 'クーポンコード' },
          { key: 'coupon_name', label: '管理用クーポン名' },
          { key: 'coupon_disp_name', label: '表示用クーポン名' },
          { key: 'coupon_type', label: 'クーポン種別' }
        ]
      },
      {
        title: '割引',
        fields: [
          { key: 'coupon_discount_price', label: 'クーポン割引額' },
          { key: 'coupon_discount_rate', label: 'クーポン割引率' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_COUPON]: {
    masterType: MasterType.W2_COUPON,
    title: 'W2クーポンマスタ',
    columns: [
      { key: 'coupon_id', label: 'クーポンID', sortable: true },
      { key: 'coupon_code', label: 'クーポンコード', sortable: true },
      { key: 'coupon_name', label: '管理用クーポン名', sortable: true },
      { key: 'coupon_disp_name', label: '表示用クーポン名' },
      { key: 'coupon_type', label: 'クーポン種別' },
      { key: 'discount_price', label: '割引額' },
      { key: 'discount_rate', label: '割引率' },
      { key: 'valid_flg', label: '有効' },
      { key: 'free_shipping_flg', label: '配送料無料' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['coupon_id', 'coupon_code', 'coupon_name', 'coupon_type', 'dept_id'],
    pkColumns: ['dept_id', 'coupon_id'],
    csvHeaders: [
      'dept_id',
      'coupon_id',
      'coupon_code',
      'coupon_name',
      'coupon_disp_name',
      'coupon_discription',
      'coupon_type',
      'coupon_count',
      'publish_date_bgn',
      'publish_date_end',
      'discount_price',
      'discount_rate',
      'expire_day',
      'expire_date_bgn',
      'expire_date_end',
      'product_kbn',
      'exceptional_product',
      'exceptional_icon',
      'usable_price',
      'use_together_flg',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'disp_flg',
      'coupon_disp_discription',
      'exceptional_brand_ids',
      'exceptional_product_category_ids',
      'free_shipping_flg',
      'applicable_product',
      'applicable_brand_ids',
      'applicable_product_category_ids',
      'applicable_icon',
      'applicable_condition_operator'
    ],
    requiredCsv: ['dept_id', 'coupon_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'dept_id', label: '識別ID' },
          { key: 'coupon_id', label: 'クーポンID' },
          { key: 'coupon_code', label: 'クーポンコード' },
          { key: 'coupon_name', label: '管理用クーポン名' },
          { key: 'coupon_disp_name', label: '表示用クーポン名' },
          { key: 'coupon_discription', label: 'クーポン説明文' },
          { key: 'coupon_type', label: 'クーポン種別' },
          { key: 'coupon_count', label: 'クーポン利用可能回数' }
        ]
      },
      {
        title: '割引・金額',
        fields: [
          { key: 'discount_price', label: 'クーポン商品割引額' },
          { key: 'discount_rate', label: 'クーポン商品割引率' },
          { key: 'usable_price', label: 'クーポン利用最低購入金額' },
          { key: 'use_together_flg', label: 'クーポン併用フラグ' },
          { key: 'free_shipping_flg', label: 'クーポン配送料無料フラグ' }
        ]
      },
      {
        title: '期間',
        fields: [
          { key: 'publish_date_bgn', label: 'クーポン発行期間(開始)' },
          { key: 'publish_date_end', label: 'クーポン発行期間(終了)' },
          { key: 'expire_day', label: 'クーポン有効期限(日)' },
          { key: 'expire_date_bgn', label: 'クーポン有効期間(開始)' },
          { key: 'expire_date_end', label: 'クーポン有効期間(終了)' }
        ]
      },
      {
        title: '対象商品',
        fields: [
          { key: 'product_kbn', label: 'クーポン対象商品区分' },
          { key: 'applicable_product', label: '対象商品' },
          { key: 'applicable_brand_ids', label: '対象ブランドID' },
          { key: 'applicable_product_category_ids', label: '対象商品カテゴリID' },
          { key: 'applicable_icon', label: '対象商品アイコン' },
          { key: 'applicable_condition_operator', label: '対象条件結合方法' }
        ]
      },
      {
        title: '例外商品',
        fields: [
          { key: 'exceptional_product', label: '例外商品' },
          { key: 'exceptional_icon', label: '例外商品アイコン' },
          { key: 'exceptional_brand_ids', label: '例外ブランドID' },
          { key: 'exceptional_product_category_ids', label: '例外商品カテゴリID' }
        ]
      },
      {
        title: '表示',
        fields: [
          { key: 'valid_flg', label: '有効フラグ' },
          { key: 'disp_flg', label: 'フロント表示フラグ' },
          { key: 'coupon_disp_discription', label: 'フロント表示用クーポン説明文' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_ADV_CODE]: {
    masterType: MasterType.W2_ADV_CODE,
    title: 'W2広告コードマスタ',
    columns: [
      { key: 'advcode_no', label: '広告コードNo', sortable: true },
      { key: 'dept_id', label: '識別ID' },
      { key: 'advertisement_code', label: '広告コード', sortable: true },
      { key: 'media_name', label: '媒体名', sortable: true },
      { key: 'advcode_media_type_id', label: '広告媒体区分' },
      { key: 'valid_flg', label: '有効' },
      { key: 'advertisement_date', label: '出稿日', sortable: true },
      { key: 'media_cost', label: '媒体費' },
      { key: 'publication_date_from', label: '掲載期間From' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'advcode_no',
      'advertisement_code',
      'media_name',
      'dept_id',
      'advcode_media_type_id'
    ],
    pkColumns: ['advcode_no'],
    csvHeaders: [
      'advcode_no',
      'dept_id',
      'advertisement_code',
      'media_name',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'advertisement_date',
      'media_cost',
      'memo',
      'publication_date_from',
      'publication_date_to',
      'advcode_media_type_id',
      'member_rank_id_granted_at_account_registration',
      'user_management_level_id_granted_at_account_registration'
    ],
    requiredCsv: ['advcode_no'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'advcode_no', label: '広告コードNo' },
          { key: 'dept_id', label: '識別ID' },
          { key: 'advertisement_code', label: '広告コード' },
          { key: 'media_name', label: '媒体名' },
          { key: 'advcode_media_type_id', label: '広告媒体区分' },
          { key: 'valid_flg', label: '有効フラグ' }
        ]
      },
      {
        title: '出稿・掲載',
        fields: [
          { key: 'advertisement_date', label: '出稿日' },
          { key: 'media_cost', label: '媒体費' },
          { key: 'publication_date_from', label: '掲載期間(From)' },
          { key: 'publication_date_to', label: '掲載期間(To)' }
        ]
      },
      {
        title: '会員登録時紐づけ',
        fields: [
          {
            key: 'member_rank_id_granted_at_account_registration',
            label: '会員登録時紐づけ会員ランクID'
          },
          {
            key: 'user_management_level_id_granted_at_account_registration',
            label: '会員登録時紐づけユーザー管理レベルID'
          }
        ]
      },
      { title: 'その他', fields: [{ key: 'memo', label: '備考' }] },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_FEATURE_PAGE]: {
    masterType: MasterType.W2_FEATURE_PAGE,
    title: 'W2特集ページ',
    columns: [
      { key: 'feature_page_id', label: '特集ページID', sortable: true },
      { key: 'management_title', label: '管理タイトル', sortable: true },
      { key: 'page_type', label: 'ページタイプ' },
      { key: 'category_id', label: 'カテゴリID' },
      { key: 'publish', label: '公開状態' },
      { key: 'page_sort_number', label: '表示順' },
      { key: 'use_type', label: '利用状態' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: [
      'feature_page_id',
      'management_title',
      'category_id',
      'file_name',
      'html_page_title'
    ],
    pkColumns: ['feature_page_id'],
    csvHeaders: [
      'feature_page_id',
      'management_title',
      'page_type',
      'category_id',
      'permitted_brand_ids',
      'file_name',
      'file_dir_path',
      'page_sort_number',
      'use_type',
      'publish',
      'condition_publish_date_from',
      'condition_publish_date_to',
      'condition_member_only_type',
      'condition_member_rank_id',
      'condition_target_list_type',
      'condition_target_list_ids',
      'date_created',
      'date_changed',
      'last_changed',
      'metadata_desc',
      'html_page_title',
      'sitemap_include',
      'sitemap_changefreq',
      'sitemap_priority'
    ],
    requiredCsv: ['feature_page_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'feature_page_id', label: '特集ページID' },
          { key: 'management_title', label: '管理用タイトル' },
          { key: 'page_type', label: 'ページタイプ' },
          { key: 'category_id', label: '特集ページカテゴリID' },
          { key: 'permitted_brand_ids', label: '許可ブランドID' },
          { key: 'file_name', label: 'ファイル名' },
          { key: 'file_dir_path', label: 'ディレクトリパス' },
          { key: 'page_sort_number', label: 'ページ順序' },
          { key: 'use_type', label: 'ページの利用状態' }
        ]
      },
      {
        title: '公開設定',
        fields: [
          { key: 'publish', label: '公開状態' },
          { key: 'condition_publish_date_from', label: '公開開始日' },
          { key: 'condition_publish_date_to', label: '公開終了日' },
          { key: 'condition_member_only_type', label: '会員限定コンテンツ' },
          { key: 'condition_member_rank_id', label: '一部会員公開用会員ランク' },
          { key: 'condition_target_list_type', label: 'ターゲットリスト検索条件' },
          { key: 'condition_target_list_ids', label: '対象ターゲットリスト' }
        ]
      },
      {
        title: 'SEO・サイトマップ',
        fields: [
          { key: 'html_page_title', label: 'HTMLページタイトル' },
          { key: 'metadata_desc', label: 'SEOディスクリプション' },
          { key: 'sitemap_include', label: 'サイトマップ出力要否' },
          { key: 'sitemap_changefreq', label: 'サイトマップ更新頻度' },
          { key: 'sitemap_priority', label: 'サイトマップ優先度' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_FEATURE_PAGE_CATEGORY]: {
    masterType: MasterType.W2_FEATURE_PAGE_CATEGORY,
    title: 'W2特集ページカテゴリ',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'category_id', label: 'カテゴリID', sortable: true },
      { key: 'parent_category_id', label: '親カテゴリID' },
      { key: 'category_name', label: 'カテゴリ名', sortable: true },
      { key: 'display_order', label: '表示順' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['shop_id', 'category_id', 'category_name', 'parent_category_id'],
    pkColumns: ['shop_id', 'category_id'],
    csvHeaders: [
      'shop_id',
      'category_id',
      'parent_category_id',
      'category_name',
      'category_outline',
      'display_order',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'category_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'shop_id', label: '店舗ID' },
          { key: 'category_id', label: 'カテゴリID' },
          { key: 'parent_category_id', label: '親カテゴリID' },
          { key: 'category_name', label: 'カテゴリ名' },
          { key: 'category_outline', label: 'カテゴリ概要' },
          { key: 'display_order', label: '表示順' },
          { key: 'valid_flg', label: '有効フラグ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_FEATURE_PAGE_CONTENTS]: {
    masterType: MasterType.W2_FEATURE_PAGE_CONTENTS,
    title: 'W2特集ページコンテンツ',
    columns: [
      { key: 'feature_page_id', label: '特集ページID', sortable: true },
      { key: 'contents_kbn', label: 'コンテンツ区分' },
      { key: 'contents_type', label: 'コンテンツタイプ' },
      { key: 'contents_sort_number', label: '表示順' },
      { key: 'page_title', label: 'ページタイトル', sortable: true },
      { key: 'product_group_id', label: '商品グループID' },
      { key: 'display_number', label: '表示件数' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['feature_page_id', 'page_title', 'product_group_id', 'product_list_title'],
    pkColumns: ['feature_page_id', 'contents_kbn', 'contents_type', 'contents_sort_number'],
    csvHeaders: [
      'feature_page_id',
      'contents_kbn',
      'contents_type',
      'contents_sort_number',
      'page_title',
      'alt_text',
      'product_group_id',
      'product_list_title',
      'display_number',
      'pagination_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['feature_page_id', 'contents_kbn', 'contents_type', 'contents_sort_number'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'feature_page_id', label: '特集ページID' },
          { key: 'contents_kbn', label: 'コンテンツ区分' },
          { key: 'contents_type', label: 'コンテンツタイプ' },
          { key: 'contents_sort_number', label: 'コンテンツ表示順序' }
        ]
      },
      {
        title: 'コンテンツ設定',
        fields: [
          { key: 'page_title', label: 'ページタイトル（PAGE_TITLE用）' },
          { key: 'alt_text', label: '代替テキスト（HEADER_BANNER用）' },
          { key: 'product_group_id', label: '商品グループID（PRODUCT_LIST用）' },
          { key: 'product_list_title', label: '商品一覧タイトル（PRODUCT_LIST用）' },
          { key: 'display_number', label: '表示件数（PRODUCT_LIST用）' },
          { key: 'pagination_flg', label: 'ページ送りフラグ' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_GROUP]: {
    masterType: MasterType.W2_PRODUCT_GROUP,
    title: 'W2商品グループ',
    columns: [
      { key: 'product_group_id', label: '商品グループID', sortable: true },
      { key: 'product_group_name', label: '商品グループ名', sortable: true },
      { key: 'begin_date', label: '開始日時', sortable: true },
      { key: 'end_date', label: '終了日時' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'product_group_page_contents_kbn', label: 'HTML区分' },
      { key: 'date_created', label: '作成日', sortable: true }
    ],
    searchColumns: ['product_group_id', 'product_group_name'],
    pkColumns: ['product_group_id'],
    csvHeaders: [
      'product_group_id',
      'product_group_name',
      'begin_date',
      'end_date',
      'valid_flg',
      'product_group_page_contents_kbn',
      'product_group_page_contents',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['product_group_id'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'product_group_id', label: '商品グループID' },
          { key: 'product_group_name', label: '商品グループ名' },
          { key: 'begin_date', label: '開始日時' },
          { key: 'end_date', label: '終了日時（NULL:未設定＝有効期間有効）' },
          { key: 'valid_flg', label: '有効フラグ' }
        ]
      },
      {
        title: 'ページ表示内容',
        fields: [
          { key: 'product_group_page_contents_kbn', label: '表示内容HTML区分' },
          { key: 'product_group_page_contents', label: '表示内容' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'date_changed', label: '更新日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_PRODUCT_GROUP_ITEM]: {
    masterType: MasterType.W2_PRODUCT_GROUP_ITEM,
    title: 'W2商品グループ明細',
    columns: [
      { key: 'product_group_id', label: '商品グループID', sortable: true },
      { key: 'item_no', label: '枝番', sortable: true },
      { key: 'item_type', label: 'アイテムタイプ' },
      { key: 'shop_id', label: '店舗ID' },
      { key: 'master_id', label: 'マスターID', sortable: true },
      { key: 'date_created', label: '作成日', sortable: true },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['product_group_id', 'item_type', 'shop_id', 'master_id'],
    pkColumns: ['product_group_id', 'item_no'],
    csvHeaders: [
      'product_group_id',
      'item_no',
      'item_type',
      'shop_id',
      'master_id',
      'date_created',
      'last_changed'
    ],
    requiredCsv: ['product_group_id', 'item_no'],
    detailSections: [
      {
        title: '基本情報',
        fields: [
          { key: 'product_group_id', label: '商品特集グループID' },
          { key: 'item_no', label: '商品グループアイテム枝番' },
          { key: 'item_type', label: 'アイテムタイプ' },
          { key: 'shop_id', label: '店舗ID' },
          { key: 'master_id', label: 'マスターID（商品ID指定時：商品ID）' }
        ]
      },
      {
        title: 'システム情報',
        fields: [
          { key: 'date_created', label: '作成日' },
          { key: 'last_changed', label: '最終更新者' }
        ]
      }
    ]
  },
  [MasterType.W2_CONTENTS_TAG]: {
    masterType: MasterType.W2_CONTENTS_TAG,
    title: 'W2コンテンツタグ',
    columns: [
      { key: 'contents_tag_id', label: 'コンテンツタグID', sortable: true },
      { key: 'contents_tag_name', label: 'コンテンツタグ名', sortable: true },
      { key: 'date_created', label: '作成日', sortable: true },
      { key: 'date_changed', label: '更新日', sortable: true }
    ],
    searchColumns: ['contents_tag_id', 'contents_tag_name'],
    pkColumns: ['contents_tag_id'],
    csvHeaders: ['contents_tag_id', 'contents_tag_name', 'date_created', 'date_changed'],
    requiredCsv: ['contents_tag_id'],
    detailSections: []
  },
  [MasterType.W2_PRODUCT_LINK]: {
    masterType: MasterType.W2_PRODUCT_LINK,
    title: 'W2商品リンクマスタ',
    columns: [
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'image_url', label: '商品画像URL' },
      { key: 'product_url', label: '商品ページURL' }
    ],
    searchColumns: ['product_id', 'image_url', 'product_url'],
    pkColumns: ['shop_id', 'product_id'],
    csvHeaders: ['shop_id', 'product_id', 'image_url', 'product_url'],
    requiredCsv: ['shop_id', 'product_id']
  },
  // 拡張マスタ（add-w2-ex-product-spec で追加）
  [MasterType.W2_EX_PRODUCT_SPEC]: {
    masterType: MasterType.W2_EX_PRODUCT_SPEC,
    title: '商品追加情報',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'spec_no', label: '枝番', sortable: true },
      { key: 'spec_type', label: 'スペック種別', sortable: true },
      { key: 'spec_value', label: '値' },
      { key: 'date_created', label: '登録日', sortable: true },
      { key: 'date_changed', label: '更新日', sortable: true },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['product_id', 'spec_type', 'spec_value'],
    pkColumns: ['shop_id', 'product_id', 'spec_no', 'spec_type'],
    csvHeaders: [
      'shop_id',
      'product_id',
      'spec_no',
      'spec_type',
      'spec_value',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_id', 'spec_no', 'spec_type', 'spec_value']
  },
  [MasterType.W2_EX_PRODUCT_VARIATION_SPEC]: {
    masterType: MasterType.W2_EX_PRODUCT_VARIATION_SPEC,
    title: '商品バリエーション追加情報',
    columns: [
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: 'バリエーションID', sortable: true },
      { key: 'spec_no', label: '枝番', sortable: true },
      { key: 'spec_type', label: 'スペック種別', sortable: true },
      { key: 'spec_value', label: '値' },
      { key: 'date_created', label: '登録日', sortable: true },
      { key: 'date_changed', label: '更新日', sortable: true },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['product_id', 'variation_id', 'spec_type', 'spec_value'],
    pkColumns: ['shop_id', 'product_id', 'variation_id', 'spec_no', 'spec_type'],
    csvHeaders: [
      'shop_id',
      'product_id',
      'variation_id',
      'spec_no',
      'spec_type',
      'spec_value',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_id', 'variation_id', 'spec_no', 'spec_type', 'spec_value']
  },
  [MasterType.W2_USER_POINT]: {
    masterType: MasterType.W2_USER_POINT,
    title: 'ユーザポイントマスター',
    columns: [
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'point_kbn_no', label: '枝番', sortable: true },
      { key: 'point_kbn', label: 'ポイント区分' },
      { key: 'dept_id', label: '識別ID' },
      { key: 'point_rule_id', label: 'ポイントルールID' },
      { key: 'point_rule_kbn', label: 'ポイントルール区分' },
      { key: 'point_type', label: 'ポイント種別' },
      { key: 'point_inc_kbn', label: 'ポイント加算区分' },
      { key: 'point', label: 'ポイント数' },
      { key: 'point_exp', label: '有効期限' }
    ],
    searchColumns: ['user_id', 'point_kbn_no'],
    pkColumns: ['user_id', 'point_kbn_no'],
    csvHeaders: [
      'user_id',
      'point_kbn',
      'point_kbn_no',
      'dept_id',
      'point_rule_id',
      'point_rule_kbn',
      'point_type',
      'point_inc_kbn',
      'point',
      'point_exp',
      'history_no',
      'kbn1',
      'kbn2',
      'kbn3',
      'kbn4',
      'kbn5',
      'date_created',
      'date_changed',
      'last_changed',
      'effective_date'
    ],
    requiredCsv: ['user_id', 'point_kbn_no']
  },
  [MasterType.W2_USER_POINT_HISTORY]: {
    masterType: MasterType.W2_USER_POINT_HISTORY,
    title: 'ユーザポイント履歴',
    columns: [
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'history_no', label: '枝番', sortable: true },
      { key: 'tgt_year', label: '対象年', sortable: true },
      { key: 'tgt_month', label: '対象月', sortable: true },
      { key: 'tgt_day', label: '対象日', sortable: true },
      { key: 'dept_id', label: '識別ID' },
      { key: 'point_rule_id', label: 'ポイントルールID' },
      { key: 'point_rule_kbn', label: 'ポイントルール区分' },
      { key: 'point_kbn', label: 'ポイント区分' },
      { key: 'point_type', label: 'ポイント種別' }
    ],
    searchColumns: ['tgt_year', 'tgt_month', 'tgt_day', 'user_id', 'history_no'],
    pkColumns: ['tgt_year', 'tgt_month', 'tgt_day', 'user_id', 'history_no'],
    csvHeaders: [
      'user_id',
      'history_no',
      'tgt_year',
      'tgt_month',
      'tgt_day',
      'dept_id',
      'point_rule_id',
      'point_rule_kbn',
      'point_kbn',
      'point_type',
      'point_inc_kbn',
      'point_inc',
      'point_exp_extend',
      'user_point_exp',
      'kbn1',
      'kbn2',
      'kbn3',
      'kbn4',
      'kbn5',
      'memo',
      'date_created',
      'last_changed',
      'effective_date',
      'restored_flg',
      'history_group_no'
    ],
    requiredCsv: ['tgt_year', 'tgt_month', 'tgt_day', 'user_id', 'history_no']
  },
  [MasterType.W2_POINT_RULE]: {
    masterType: MasterType.W2_POINT_RULE,
    title: 'ポイントルールマスター',
    columns: [
      { key: 'dept_id', label: '識別ID', sortable: true },
      { key: 'point_rule_id', label: 'ポイントルールID', sortable: true },
      { key: 'point_rule_name', label: 'ポイントルール名' },
      { key: 'point_rule_kbn', label: 'ポイントルール区分' },
      { key: 'point_kbn', label: '対象ポイント区分' },
      { key: 'use_temp_flg', label: '仮ポイント使用フラグ' },
      { key: 'point_inc_kbn', label: 'ポイント加算区分' },
      { key: 'inc_type', label: 'ポイント加算方法' },
      { key: 'inc_num', label: 'ポイント加算数' },
      { key: 'inc_rate', label: 'ポイント加算率' }
    ],
    searchColumns: ['dept_id', 'point_rule_id'],
    pkColumns: ['dept_id', 'point_rule_id'],
    csvHeaders: [
      'dept_id',
      'point_rule_id',
      'point_rule_name',
      'point_rule_kbn',
      'point_kbn',
      'use_temp_flg',
      'point_inc_kbn',
      'inc_type',
      'inc_num',
      'inc_rate',
      'point_exp_extend',
      'exp_bgn',
      'exp_end',
      'campaign_term_kbn',
      'campaign_term_value',
      'priority',
      'valid_flg',
      'kbn1',
      'kbn2',
      'kbn3',
      'kbn4',
      'kbn5',
      'date_created',
      'date_changed',
      'last_changed',
      'point_rule_disp_name',
      'fixed_purchase_inc_type',
      'fixed_purchase_inc_num',
      'fixed_purchase_inc_rate',
      'effective_offset',
      'effective_offset_type',
      'term',
      'term_type',
      'period_begin',
      'period_end',
      'allow_duplicate_apply_flg'
    ],
    requiredCsv: ['dept_id', 'point_rule_id']
  },
  [MasterType.W2_POINT_RULE_SCHEDULE]: {
    masterType: MasterType.W2_POINT_RULE_SCHEDULE,
    title: 'ポイントルールスケジュールテーブル',
    columns: [
      { key: 'point_rule_schedule_id', label: 'ポイントルールスケジュールID', sortable: true },
      { key: 'point_rule_schedule_name', label: 'ポイントルールスケジュール名' },
      { key: 'status', label: 'ステータス' },
      { key: 'last_count', label: '最終付与人数' },
      { key: 'last_exec_date', label: '最終付与日時' },
      { key: 'target_id', label: 'ターゲットID' },
      { key: 'target_extract_flg', label: 'ターゲット抽出フラグ' },
      { key: 'point_rule_id', label: 'ポイントルールID' },
      { key: 'mail_id', label: 'メールテンプレートID' },
      { key: 'exec_timing', label: '実行タイミング' }
    ],
    searchColumns: ['point_rule_schedule_id'],
    pkColumns: ['point_rule_schedule_id'],
    csvHeaders: [
      'point_rule_schedule_id',
      'point_rule_schedule_name',
      'status',
      'last_count',
      'last_exec_date',
      'target_id',
      'target_extract_flg',
      'point_rule_id',
      'mail_id',
      'exec_timing',
      'schedule_kbn',
      'schedule_day_of_week',
      'schedule_year',
      'schedule_month',
      'schedule_day',
      'schedule_hour',
      'schedule_minute',
      'schedule_second',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['point_rule_schedule_id']
  },
  [MasterType.W2_USER_MEMBER_RANK_HISTORY]: {
    masterType: MasterType.W2_USER_MEMBER_RANK_HISTORY,
    title: '会員ランク更新履歴',
    columns: [
      { key: 'history_no', label: '履歴No', sortable: true },
      { key: 'user_id', label: 'ユーザID' },
      { key: 'before_rank_id', label: '更新前ランクID' },
      { key: 'after_rank_id', label: '更新後ランクID' },
      { key: 'mail_id', label: 'メールテンプレートID' },
      { key: 'changed_by', label: '変更者' },
      { key: 'date_created', label: '作成日' }
    ],
    searchColumns: ['history_no'],
    pkColumns: ['history_no'],
    csvHeaders: [
      'history_no',
      'user_id',
      'before_rank_id',
      'after_rank_id',
      'mail_id',
      'changed_by',
      'date_created'
    ],
    requiredCsv: ['history_no']
  },
  [MasterType.W2_MEMBER_RANK_RULE]: {
    masterType: MasterType.W2_MEMBER_RANK_RULE,
    title: '会員ランク付与ルール',
    columns: [
      { key: 'member_rank_rule_id', label: 'ランク付与ルールID', sortable: true },
      { key: 'member_rank_rule_name', label: 'ランク付与ルール名' },
      { key: 'status', label: 'ステータス' },
      { key: 'last_count', label: '最終付与人数' },
      { key: 'last_exec_date', label: '最終付与日時' },
      { key: 'target_extract_type', label: '抽出条件集計期間指定' },
      { key: 'target_extract_start', label: '抽出条件集計期間開始日' },
      { key: 'target_extract_end', label: '抽出条件集計期間終了日' },
      { key: 'target_extract_days_ago', label: '抽出条件集計期間前日指定' },
      { key: 'target_extract_total_price_from', label: '抽出条件合計購入金額範囲(From)' }
    ],
    searchColumns: ['member_rank_rule_id'],
    pkColumns: ['member_rank_rule_id'],
    csvHeaders: [
      'member_rank_rule_id',
      'member_rank_rule_name',
      'status',
      'last_count',
      'last_exec_date',
      'target_extract_type',
      'target_extract_start',
      'target_extract_end',
      'target_extract_days_ago',
      'target_extract_total_price_from',
      'target_extract_total_price_to',
      'target_extract_total_count_from',
      'target_extract_total_count_to',
      'target_extract_old_rank_flg',
      'rank_change_type',
      'rank_change_rank_id',
      'mail_id',
      'exec_timing',
      'schedule_kbn',
      'schedule_day_of_week',
      'schedule_year',
      'schedule_month',
      'schedule_day',
      'schedule_hour',
      'schedule_minute',
      'schedule_second',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'target_id',
      'target_extract_flg',
      'target_id2',
      'target_extract_flg2',
      'target_id3',
      'target_extract_flg3',
      'target_id4',
      'target_extract_flg4',
      'target_id5',
      'target_extract_flg5'
    ],
    requiredCsv: ['member_rank_rule_id']
  },
  [MasterType.W2_ORDER_SHIPPING]: {
    masterType: MasterType.W2_ORDER_SHIPPING,
    title: '注文配送先情報',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_shipping_no', label: '配送先枝番', sortable: true },
      { key: 'shipping_name', label: '配送先氏名' },
      { key: 'shipping_name_kana', label: '配送先氏名かな' },
      { key: 'shipping_zip', label: '郵便番号' },
      { key: 'shipping_addr1', label: '住所1' },
      { key: 'shipping_addr2', label: '住所2' },
      { key: 'shipping_addr3', label: '住所3' },
      { key: 'shipping_addr4', label: '住所４' },
      { key: 'shipping_tel1', label: '電話番号1' }
    ],
    searchColumns: ['order_id', 'order_shipping_no'],
    pkColumns: ['order_id', 'order_shipping_no'],
    csvHeaders: [
      'order_id',
      'order_shipping_no',
      'shipping_name',
      'shipping_name_kana',
      'shipping_zip',
      'shipping_addr1',
      'shipping_addr2',
      'shipping_addr3',
      'shipping_addr4',
      'shipping_tel1',
      'shipping_tel2',
      'shipping_tel3',
      'shipping_fax',
      'shipping_company',
      'shipping_date',
      'shipping_time',
      'shipping_check_no',
      'del_flg',
      'date_created',
      'date_changed',
      'shipping_name1',
      'shipping_name2',
      'shipping_name_kana1',
      'shipping_name_kana2',
      'sender_name',
      'sender_name1',
      'sender_name2',
      'sender_name_kana',
      'sender_name_kana1',
      'sender_name_kana2',
      'sender_zip',
      'sender_addr1',
      'sender_addr2',
      'sender_addr3',
      'sender_addr4',
      'sender_tel1',
      'wrapping_paper_type',
      'wrapping_paper_name',
      'wrapping_bag_type',
      'shipping_company_name',
      'shipping_company_post_name',
      'sender_company_name',
      'sender_company_post_name',
      'private_shipping_flg',
      'another_shipping_flg',
      'shipping_method',
      'delivery_company_id',
      'shipping_country_iso_code',
      'shipping_country_name',
      'shipping_addr5',
      'sender_country_iso_code',
      'sender_country_name',
      'sender_addr5',
      'scheduled_shipping_date',
      'external_shipping_cooperation_id',
      'shipping_receiving_store_flg',
      'shipping_receiving_store_id',
      'shipping_external_deliverty_status',
      'shipping_status',
      'shipping_status_update_date',
      'shipping_receiving_mail_date',
      'shipping_receiving_store_type',
      'shipping_status_code',
      'shipping_office_name',
      'shipping_handy_time',
      'shipping_current_status',
      'shipping_status_detail',
      'shipping_temperature_zone',
      'order_shipping_id',
      'order_shipping_status',
      'order_shipping_arranged_date',
      'order_shipping_completed_date',
      'wrapping_paper_flg',
      'wrapping_paper_title',
      'wrapping_paper_name_style',
      'wrapping_paper_placement'
    ],
    requiredCsv: ['order_id', 'order_shipping_no']
  },
  [MasterType.W2_SHOP_SHIPPING]: {
    masterType: MasterType.W2_SHOP_SHIPPING,
    title: '店舗配送種別マスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'shipping_id', label: '配送種別ID', sortable: true },
      { key: 'shop_shipping_name', label: '配送種別名' },
      { key: 'payment_relation_id', label: '決済連携ID' },
      { key: 'shipping_price_kbn', label: '配送料設定区分' },
      { key: 'shipping_date_set_flg', label: '配送日設定可能フラグ' },
      { key: 'shipping_date_set_begin', label: '配送日設定可能範囲(開始)' },
      { key: 'shipping_date_set_end', label: '配送日設定可能範囲（終了）' },
      { key: 'shipping_time_set_flg', label: '配送希望時間帯設定可能フラグ' },
      { key: 'shipping_time_id1', label: '配送希望時間帯ID1' }
    ],
    searchColumns: ['shop_id', 'shipping_id'],
    pkColumns: ['shop_id', 'shipping_id'],
    csvHeaders: [
      'shop_id',
      'shipping_id',
      'shop_shipping_name',
      'payment_relation_id',
      'shipping_price_kbn',
      'shipping_date_set_flg',
      'shipping_date_set_begin',
      'shipping_date_set_end',
      'shipping_time_set_flg',
      'shipping_time_id1',
      'shipping_time_message1',
      'shipping_time_id2',
      'shipping_time_message2',
      'shipping_time_id3',
      'shipping_time_message3',
      'shipping_time_id4',
      'shipping_time_message4',
      'shipping_time_id5',
      'shipping_time_message5',
      'shipping_time_id6',
      'shipping_time_message6',
      'shipping_time_id7',
      'shipping_time_message7',
      'shipping_time_id8',
      'shipping_time_message8',
      'shipping_time_id9',
      'shipping_time_message9',
      'shipping_time_id10',
      'shipping_time_message10',
      'shipping_free_price_flg',
      'shipping_free_price',
      'announce_free_shipping_flg',
      'calculation_plural_kbn',
      'plural_shipping_price',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'fixed_purchase_flg',
      'fixed_purchase_kbn1_flg',
      'fixed_purchase_kbn1_setting',
      'fixed_purchase_kbn2_flg',
      'fixed_purchase_kbn2_setting',
      'fixed_purchase_kbn3_flg',
      'fixed_purchase_kbn3_setting',
      'fixed_purchase_order_entry_timing',
      'fixed_purchase_cancel_deadline',
      'wrapping_paper_flg',
      'wrapping_paper_types',
      'wrapping_bag_flg',
      'wrapping_bag_types',
      'payment_selection_flg',
      'permitted_payment_ids',
      'fixed_purchase_shipping_days_required',
      'fixed_purchase_minimum_shipping_span',
      'fixed_purchase_free_shipping_flg',
      'business_days_for_shipping',
      'next_shipping_max_change_days',
      'fixed_purchase_shipping_notdisplay_flg',
      'fixed_purchase_kbn4_flg',
      'fixed_purchase_kbn4_setting1',
      'fixed_purchase_kbn4_setting2',
      'fixed_purchase_kbn1_setting2',
      'shipping_date_required_flg',
      'wrapping_papers',
      'wrapping_bags'
    ],
    requiredCsv: ['shop_id', 'shipping_id']
  },
  [MasterType.W2_SHOP_SHIPPING_ZONE]: {
    masterType: MasterType.W2_SHOP_SHIPPING_ZONE,
    title: '店舗配送料地帯マスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'shipping_id', label: '配送料設定ID', sortable: true },
      { key: 'delivery_company_id', label: '配送会社ID', sortable: true },
      { key: 'shipping_zone_no', label: '配送料地帯区分', sortable: true },
      { key: 'shipping_temperature_zone', label: '配送温度帯', sortable: true },
      { key: 'shipping_zone_name', label: '地帯名' },
      { key: 'zip', label: '郵便番号' },
      { key: 'size_xxs_shipping_price', label: 'XXSサイズ商品配送料' },
      { key: 'size_xs_shipping_price', label: 'XSサイズ商品配送料' },
      { key: 'size_s_shipping_price', label: 'Sサイズ商品配送料' }
    ],
    searchColumns: [
      'shop_id',
      'shipping_id',
      'delivery_company_id',
      'shipping_zone_no',
      'shipping_temperature_zone'
    ],
    pkColumns: [
      'shop_id',
      'shipping_id',
      'delivery_company_id',
      'shipping_zone_no',
      'shipping_temperature_zone'
    ],
    csvHeaders: [
      'shop_id',
      'shipping_id',
      'delivery_company_id',
      'shipping_zone_no',
      'shipping_zone_name',
      'zip',
      'size_xxs_shipping_price',
      'size_xs_shipping_price',
      'size_s_shipping_price',
      'size_m_shipping_price',
      'size_l_shipping_price',
      'size_xl_shipping_price',
      'size_xxl_shipping_price',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'size_mail_shipping_price',
      'conditional_shipping_price_threshold',
      'conditional_shipping_price',
      'unavailable_shipping_area_flg',
      'shipping_temperature_zone'
    ],
    requiredCsv: [
      'shop_id',
      'shipping_id',
      'delivery_company_id',
      'shipping_zone_no',
      'shipping_temperature_zone'
    ]
  },
  [MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD]: {
    masterType: MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD,
    title: '配送サイズ別上限設定',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'shipping_id', label: '配送種別ID', sortable: true },
      { key: 'delivery_company_id', label: '配送会社ID', sortable: true },
      { key: 'size_xxs_threshold', label: 'XXS配送区分上限' },
      { key: 'size_xs_threshold', label: 'XS配送区分上限' },
      { key: 'size_s_threshold', label: 'S配送区分上限' },
      { key: 'size_m_threshold', label: 'M配送区分上限' },
      { key: 'size_l_threshold', label: 'L配送区分上限' },
      { key: 'size_xl_threshold', label: 'XL配送区分上限' },
      { key: 'size_xxl_threshold', label: 'XXL配送区分上限' }
    ],
    searchColumns: ['shop_id', 'shipping_id', 'delivery_company_id'],
    pkColumns: ['shop_id', 'shipping_id', 'delivery_company_id'],
    csvHeaders: [
      'shop_id',
      'shipping_id',
      'delivery_company_id',
      'size_xxs_threshold',
      'size_xs_threshold',
      'size_s_threshold',
      'size_m_threshold',
      'size_l_threshold',
      'size_xl_threshold',
      'size_xxl_threshold',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'shipping_id', 'delivery_company_id']
  },
  [MasterType.W2_MAIL_DIST_SETTING]: {
    masterType: MasterType.W2_MAIL_DIST_SETTING,
    title: 'メール配信設定マスター',
    columns: [
      { key: 'dept_id', label: '識別ID', sortable: true },
      { key: 'maildist_id', label: 'メール配信設定ID', sortable: true },
      { key: 'maildist_name', label: 'メール配信設定名' },
      { key: 'status', label: 'ステータス' },
      { key: 'last_count', label: '最終集計人数' },
      { key: 'last_errorexcept_count', label: '最終エラー除外人数' },
      { key: 'last_dist_date', label: '最終配信開始日時' },
      { key: 'target_id', label: 'ターゲットID' },
      { key: 'target_extract_flg', label: 'ターゲット抽出フラグ' },
      { key: 'target_id2', label: 'ターゲットID2' }
    ],
    searchColumns: ['dept_id', 'maildist_id'],
    pkColumns: ['dept_id', 'maildist_id'],
    csvHeaders: [
      'dept_id',
      'maildist_id',
      'maildist_name',
      'status',
      'last_count',
      'last_errorexcept_count',
      'last_dist_date',
      'target_id',
      'target_extract_flg',
      'target_id2',
      'target_extract_flg2',
      'target_id3',
      'target_extract_flg3',
      'target_id4',
      'target_extract_flg4',
      'target_id5',
      'target_extract_flg5',
      'except_error_point',
      'mailtext_id',
      'exec_timing',
      'schedule_kbn',
      'schedule_day_of_week',
      'schedule_year',
      'schedule_month',
      'schedule_day',
      'schedule_hour',
      'schedule_minute',
      'schedule_second',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['dept_id', 'maildist_id']
  },
  [MasterType.W2_MAIL_DIST_SENT_USER]: {
    masterType: MasterType.W2_MAIL_DIST_SENT_USER,
    title: 'メール配信送信済ユーザ',
    columns: [
      { key: 'maildist_id', label: 'メール配信設定ID', sortable: true },
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['maildist_id', 'user_id'],
    pkColumns: ['maildist_id', 'user_id'],
    csvHeaders: ['maildist_id', 'user_id', 'date_created', 'date_changed', 'last_changed'],
    requiredCsv: ['maildist_id', 'user_id']
  },
  [MasterType.W2_MAIL_SEND_LOG]: {
    masterType: MasterType.W2_MAIL_SEND_LOG,
    title: 'メール送信ログ',
    columns: [
      { key: 'log_no', label: 'ログNO', sortable: true },
      { key: 'user_id', label: 'ユーザーID' },
      { key: 'dept_id', label: '識別ID' },
      { key: 'mailtext_id', label: 'メール文章ID' },
      { key: 'mailtext_name', label: 'メール文章名' },
      { key: 'maildist_id', label: 'メール配信設定ID' },
      { key: 'maildist_name', label: 'メール配信設定名' },
      { key: 'shop_id', label: '店舗ID' },
      { key: 'mail_id', label: 'メールテンプレートID' },
      { key: 'mail_name', label: 'メールテンプレート名' }
    ],
    searchColumns: ['log_no'],
    pkColumns: ['log_no'],
    csvHeaders: [
      'log_no',
      'user_id',
      'dept_id',
      'mailtext_id',
      'mailtext_name',
      'maildist_id',
      'maildist_name',
      'shop_id',
      'mail_id',
      'mail_name',
      'mail_from_name',
      'mail_from',
      'mail_to',
      'mail_cc',
      'mail_bcc',
      'mail_subject',
      'mail_body',
      'mail_body_html',
      'error_message',
      'date_send_mail',
      'date_created',
      'read_flg',
      'date_read_mail',
      'mail_addr_kbn'
    ],
    requiredCsv: ['log_no']
  },
  [MasterType.W2_MAIL_CLICK]: {
    masterType: MasterType.W2_MAIL_CLICK,
    title: 'メールクリックマスター',
    columns: [
      { key: 'dept_id', label: '識別ID', sortable: true },
      { key: 'mailtext_id', label: 'メール文章ID', sortable: true },
      { key: 'maildist_id', label: 'メール配信設定ID', sortable: true },
      { key: 'action_no', label: '実行履歴NO', sortable: true },
      { key: 'mailclick_id', label: 'メールクリックID', sortable: true },
      { key: 'mailclick_url', label: 'メールクリックURL' },
      { key: 'mailclick_key', label: 'メールクリック識別キー' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日' }
    ],
    searchColumns: ['dept_id', 'mailtext_id', 'maildist_id', 'action_no', 'mailclick_id'],
    pkColumns: ['dept_id', 'mailtext_id', 'maildist_id', 'action_no', 'mailclick_id'],
    csvHeaders: [
      'dept_id',
      'mailtext_id',
      'maildist_id',
      'action_no',
      'mailclick_id',
      'mailclick_url',
      'mailclick_key',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'mail_body_type'
    ],
    requiredCsv: ['dept_id', 'mailtext_id', 'maildist_id', 'action_no', 'mailclick_id']
  },
  [MasterType.W2_MAIL_CLICK_LOG]: {
    masterType: MasterType.W2_MAIL_CLICK_LOG,
    title: 'メールクリックログ',
    columns: [
      { key: 'log_no', label: 'ログNO', sortable: true },
      { key: 'dept_id', label: '識別ID' },
      { key: 'mailtext_id', label: 'メール文章ID' },
      { key: 'maildist_id', label: 'メール配信設定ID' },
      { key: 'action_no', label: '実行履歴NO' },
      { key: 'mailclick_id', label: 'メールクリックID' },
      { key: 'user_id', label: 'ユーザーID' },
      { key: 'date_created', label: '作成日' }
    ],
    searchColumns: ['log_no'],
    pkColumns: ['log_no'],
    csvHeaders: [
      'log_no',
      'dept_id',
      'mailtext_id',
      'maildist_id',
      'action_no',
      'mailclick_id',
      'user_id',
      'date_created'
    ],
    requiredCsv: ['log_no']
  },
  [MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING]: {
    masterType: MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING,
    title: '受注ワークフローシナリオ設定',
    columns: [
      { key: 'scenario_setting_id', label: 'シナリオ設定ID', sortable: true },
      { key: 'scenario_name', label: 'シナリオ名' },
      { key: 'exec_timing', label: '実行タイミング' },
      { key: 'schedule_kbn', label: 'スケジュール区分' },
      { key: 'schedule_day_of_week', label: 'スケジュール曜日' },
      { key: 'schedule_year', label: 'スケジュール日程(年)' },
      { key: 'schedule_month', label: 'スケジュール日程(月)' },
      { key: 'schedule_day', label: 'スケジュール日程(日)' },
      { key: 'schedule_hour', label: 'スケジュール日程(時)' },
      { key: 'schedule_minute', label: 'スケジュール日程(分)' }
    ],
    searchColumns: ['scenario_setting_id'],
    pkColumns: ['scenario_setting_id'],
    csvHeaders: [
      'scenario_setting_id',
      'scenario_name',
      'exec_timing',
      'schedule_kbn',
      'schedule_day_of_week',
      'schedule_year',
      'schedule_month',
      'schedule_day',
      'schedule_hour',
      'schedule_minute',
      'schedule_second',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['scenario_setting_id']
  },
  [MasterType.W2_NOVELTY]: {
    masterType: MasterType.W2_NOVELTY,
    title: 'ノベルティ設定',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'novelty_id', label: 'ノベルティID', sortable: true },
      { key: 'novelty_disp_name', label: 'ノベルティ名（表示用）' },
      { key: 'novelty_name', label: 'ノベルティ名（管理用）' },
      { key: 'discription', label: '説明（管理用）' },
      { key: 'date_begin', label: '開始日時' },
      { key: 'date_end', label: '終了日時' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' }
    ],
    searchColumns: ['shop_id', 'novelty_id'],
    pkColumns: ['shop_id', 'novelty_id'],
    csvHeaders: [
      'shop_id',
      'novelty_id',
      'novelty_disp_name',
      'novelty_name',
      'discription',
      'date_begin',
      'date_end',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'novelty_id']
  },
  [MasterType.W2_NOVELTY_GRANT_CONDITIONS]: {
    masterType: MasterType.W2_NOVELTY_GRANT_CONDITIONS,
    title: 'ノベルティ付与条件',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'novelty_id', label: 'ノベルティID', sortable: true },
      { key: 'condition_no', label: 'ノベルティ付与条件枝番', sortable: true },
      { key: 'user_rank_id', label: '対象会員' },
      { key: 'amount_begin', label: '対象金額（以上）' },
      { key: 'amount_end', label: '対象金額（以下）' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['shop_id', 'novelty_id', 'condition_no'],
    pkColumns: ['shop_id', 'novelty_id', 'condition_no'],
    csvHeaders: [
      'shop_id',
      'novelty_id',
      'condition_no',
      'user_rank_id',
      'amount_begin',
      'amount_end',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'novelty_id', 'condition_no']
  },
  [MasterType.W2_NOVELTY_GRANT_ITEM]: {
    masterType: MasterType.W2_NOVELTY_GRANT_ITEM,
    title: 'ノベルティ付与アイテム',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'novelty_id', label: 'ノベルティID', sortable: true },
      { key: 'condition_no', label: 'ノベルティ付与条件枝番', sortable: true },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'sort_no', label: '並び順' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['shop_id', 'novelty_id', 'condition_no', 'product_id'],
    pkColumns: ['shop_id', 'novelty_id', 'condition_no', 'product_id'],
    csvHeaders: [
      'shop_id',
      'novelty_id',
      'condition_no',
      'product_id',
      'sort_no',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'novelty_id', 'condition_no', 'product_id']
  },
  [MasterType.W2_NOVELTY_TARGET_ITEM]: {
    masterType: MasterType.W2_NOVELTY_TARGET_ITEM,
    title: 'ノベルティ対象アイテム',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'novelty_id', label: 'ノベルティID', sortable: true },
      { key: 'novelty_target_item_no', label: 'ノベルティ対象アイテム枝番', sortable: true },
      { key: 'novelty_target_item_type', label: 'ノベルティ対象アイテム種別', sortable: true },
      { key: 'novelty_target_item_value', label: 'ノベルティ対象アイテム値', sortable: true },
      { key: 'novelty_target_item_type_sort_no', label: 'ノベルティ対象アイテム並び順' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: [
      'shop_id',
      'novelty_id',
      'novelty_target_item_no',
      'novelty_target_item_type',
      'novelty_target_item_value'
    ],
    pkColumns: [
      'shop_id',
      'novelty_id',
      'novelty_target_item_no',
      'novelty_target_item_type',
      'novelty_target_item_value'
    ],
    csvHeaders: [
      'shop_id',
      'novelty_id',
      'novelty_target_item_no',
      'novelty_target_item_type',
      'novelty_target_item_value',
      'novelty_target_item_type_sort_no',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: [
      'shop_id',
      'novelty_id',
      'novelty_target_item_no',
      'novelty_target_item_type',
      'novelty_target_item_value'
    ]
  },
  [MasterType.W2_ORDER_SET_PROMOTION]: {
    masterType: MasterType.W2_ORDER_SET_PROMOTION,
    title: '注文セットプロモーションテーブル',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_setpromotion_no', label: '注文セットプロモーション枝番', sortable: true },
      { key: 'setpromotion_id', label: 'セットプロモーションID' },
      { key: 'setpromotion_name', label: '管理用セットプロモーション名' },
      { key: 'setpromotion_disp_name', label: '表示用セットプロモーション名' },
      { key: 'promotion_type', label: 'プロモーション種別' },
      { key: 'discount_amount', label: '値引き額' }
    ],
    searchColumns: ['order_id', 'order_setpromotion_no'],
    pkColumns: ['order_id', 'order_setpromotion_no'],
    csvHeaders: [
      'order_id',
      'order_setpromotion_no',
      'setpromotion_id',
      'setpromotion_name',
      'setpromotion_disp_name',
      'promotion_type',
      'discount_amount'
    ],
    requiredCsv: ['order_id', 'order_setpromotion_no']
  },
  [MasterType.W2_ORDER_SET_PROMOTION_ITEM]: {
    masterType: MasterType.W2_ORDER_SET_PROMOTION_ITEM,
    title: '注文セットプロモーションアイテム',
    columns: [
      { key: 'order_id', label: '注文ID', sortable: true },
      { key: 'order_setpromotion_no', label: '注文セットプロモーション枝番', sortable: true },
      {
        key: 'order_setpromotion_item_no',
        label: '注文セットプロモーションアイテム枝番',
        sortable: true
      },
      { key: 'order_item_no', label: '注文商品枝番' },
      { key: 'order_item_quantity', label: '注文商品該当数' }
    ],
    searchColumns: ['order_id', 'order_setpromotion_no', 'order_setpromotion_item_no'],
    pkColumns: ['order_id', 'order_setpromotion_no', 'order_setpromotion_item_no'],
    csvHeaders: [
      'order_id',
      'order_setpromotion_no',
      'order_setpromotion_item_no',
      'order_item_no',
      'order_item_quantity'
    ],
    requiredCsv: ['order_id', 'order_setpromotion_no', 'order_setpromotion_item_no']
  },
  [MasterType.W2_SET_PROMOTION]: {
    masterType: MasterType.W2_SET_PROMOTION,
    title: 'セットプロモーションマスター',
    columns: [
      { key: 'setpromotion_id', label: 'セットプロモーションID', sortable: true },
      { key: 'setpromotion_name', label: '管理用セットプロモーション名' },
      { key: 'setpromotion_disp_name', label: '表示用セットプロモーション名' },
      { key: 'promotion_type', label: 'プロモーション種別' },
      { key: 'product_discount_kbn', label: '商品割引区分' },
      { key: 'product_discount_setting', label: '商品割引設定' },
      { key: 'multiple_apply_flg', label: '重複適用フラグ' },
      { key: 'apply_order', label: '適用優先順' },
      { key: 'description_kbn', label: '表示用文言HTML区分' },
      { key: 'description', label: '表示用文言' }
    ],
    searchColumns: ['setpromotion_id'],
    pkColumns: ['setpromotion_id'],
    csvHeaders: [
      'setpromotion_id',
      'setpromotion_name',
      'setpromotion_disp_name',
      'promotion_type',
      'product_discount_kbn',
      'product_discount_setting',
      'multiple_apply_flg',
      'apply_order',
      'description_kbn',
      'description',
      'begin_date',
      'end_date',
      'target_member_rank',
      'target_target_ids',
      'url',
      'display_order',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['setpromotion_id']
  },
  [MasterType.W2_SET_PROMOTION_ITEM]: {
    masterType: MasterType.W2_SET_PROMOTION_ITEM,
    title: 'セットプロモーション商品マスター',
    columns: [
      { key: 'setpromotion_id', label: 'セットプロモーションID', sortable: true },
      { key: 'setpromotion_item_no', label: 'セットプロモーションアイテム枝番', sortable: true },
      { key: 'setpromotion_item_kbn', label: 'セットプロモーションアイテム区分' },
      { key: 'setpromotion_items', label: '対象商品' },
      { key: 'setpromotion_item_quantity', label: '数量' },
      { key: 'and_over_quantity_flg', label: 'n個以上フラグ' }
    ],
    searchColumns: ['setpromotion_id', 'setpromotion_item_no'],
    pkColumns: ['setpromotion_id', 'setpromotion_item_no'],
    csvHeaders: [
      'setpromotion_id',
      'setpromotion_item_no',
      'setpromotion_item_kbn',
      'setpromotion_items',
      'setpromotion_item_quantity',
      'and_over_quantity_flg'
    ],
    requiredCsv: ['setpromotion_id', 'setpromotion_item_no']
  },
  [MasterType.W2_PRODUCT_BUNDLE]: {
    masterType: MasterType.W2_PRODUCT_BUNDLE,
    title: '商品同梱テーブル',
    columns: [
      { key: 'product_bundle_id', label: '商品同梱ID', sortable: true },
      { key: 'product_bundle_name', label: '商品同梱名' },
      { key: 'target_order_type', label: '対象注文種別' },
      { key: 'description', label: '説明文' },
      { key: 'start_datetime', label: '開始日時' },
      { key: 'end_datetime', label: '終了日時' },
      { key: 'target_product_kbn', label: '対象購入商品指定方法' },
      { key: 'target_product_ids', label: '対象購入商品ID' },
      { key: 'target_order_fixed_purchase_count_from', label: '対象定期注文回数_FROM' },
      { key: 'target_order_fixed_purchase_count_to', label: '対象定期注文回数_TO' }
    ],
    searchColumns: ['product_bundle_id'],
    pkColumns: ['product_bundle_id'],
    csvHeaders: [
      'product_bundle_id',
      'product_bundle_name',
      'target_order_type',
      'description',
      'start_datetime',
      'end_datetime',
      'target_product_kbn',
      'target_product_ids',
      'target_order_fixed_purchase_count_from',
      'target_order_fixed_purchase_count_to',
      'usable_times_kbn',
      'apply_type',
      'valid_flg',
      'multiple_apply_flg',
      'apply_order',
      'date_created',
      'date_changed',
      'last_changed',
      'usable_times',
      'target_product_category_ids',
      'except_product_ids',
      'except_product_category_ids',
      'target_id',
      'target_id_except_flg',
      'target_order_price_subtotal_min',
      'target_product_count_min',
      'target_advcodes_first',
      'target_advcodes_new',
      'target_payment_ids'
    ],
    requiredCsv: ['product_bundle_id']
  },
  [MasterType.W2_PRODUCT_BUNDLE_ITEM]: {
    masterType: MasterType.W2_PRODUCT_BUNDLE_ITEM,
    title: '商品同梱 同梱商品テーブル',
    columns: [
      { key: 'product_bundle_id', label: '商品同梱ID', sortable: true },
      { key: 'product_bundle_item_no', label: '同梱商品枝番', sortable: true },
      { key: 'grant_product_id', label: '同梱商品ID' },
      { key: 'grant_product_variation_id', label: '同梱商品バリエーションID' },
      { key: 'grant_product_count', label: '同梱個数' },
      { key: 'date_created', label: '作成日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['product_bundle_id', 'product_bundle_item_no'],
    pkColumns: ['product_bundle_id', 'product_bundle_item_no'],
    csvHeaders: [
      'product_bundle_id',
      'product_bundle_item_no',
      'grant_product_id',
      'grant_product_variation_id',
      'grant_product_count',
      'date_created',
      'last_changed'
    ],
    requiredCsv: ['product_bundle_id', 'product_bundle_item_no']
  },
  [MasterType.W2_PRODUCT_SET]: {
    masterType: MasterType.W2_PRODUCT_SET,
    title: '商品セットマスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'product_set_id', label: '商品セットID', sortable: true },
      { key: 'product_set_name', label: '商品セット名' },
      { key: 'parent_min', label: '親商品数(下限)' },
      { key: 'parent_max', label: '親商品数(上限)' },
      { key: 'child_min', label: '子商品数(下限)' },
      { key: 'child_max', label: '子商品数(上限)' },
      { key: 'priority', label: '適用優先順位' },
      { key: 'description_kbn', label: '表示用文言HTML区分' },
      { key: 'description', label: '表示用文言' }
    ],
    searchColumns: ['shop_id', 'product_set_id'],
    pkColumns: ['shop_id', 'product_set_id'],
    csvHeaders: [
      'shop_id',
      'product_set_id',
      'product_set_name',
      'parent_min',
      'parent_max',
      'child_min',
      'child_max',
      'priority',
      'description_kbn',
      'description',
      'max_sell_quantity',
      'shipping_size_kbn',
      'editable_flg',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_set_id']
  },
  [MasterType.W2_PRODUCT_SET_ITEM]: {
    masterType: MasterType.W2_PRODUCT_SET_ITEM,
    title: '商品セットアイテムマスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'product_set_id', label: '商品セットID', sortable: true },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: '商品バリエーションID', sortable: true },
      { key: 'setitem_price', label: 'セット価格' },
      { key: 'count_min', label: '個数（下限）' },
      { key: 'count_max', label: '個数（上限）' },
      { key: 'family_flg', label: '親子フラグ' },
      { key: 'display_order', label: '表示順' },
      { key: 'date_created', label: '作成日' }
    ],
    searchColumns: ['shop_id', 'product_set_id', 'product_id', 'variation_id'],
    pkColumns: ['shop_id', 'product_set_id', 'product_id', 'variation_id'],
    csvHeaders: [
      'shop_id',
      'product_set_id',
      'product_id',
      'variation_id',
      'setitem_price',
      'count_min',
      'count_max',
      'family_flg',
      'display_order',
      'date_created',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'product_set_id', 'product_id', 'variation_id']
  },
  [MasterType.W2_PRODUCT_SALE]: {
    masterType: MasterType.W2_PRODUCT_SALE,
    title: '商品セールマスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'productsale_id', label: '商品セールID', sortable: true },
      { key: 'productsale_kbn', label: '商品セール区分' },
      { key: 'productsale_name', label: '商品セール名' },
      { key: 'closedmarket_password', label: 'やみ市パスワード' },
      { key: 'date_bgn', label: '開始日時' },
      { key: 'date_end', label: '終了日時' },
      { key: 'valid_flg', label: '有効フラグ' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日' }
    ],
    searchColumns: ['shop_id', 'productsale_id'],
    pkColumns: ['shop_id', 'productsale_id'],
    csvHeaders: [
      'shop_id',
      'productsale_id',
      'productsale_kbn',
      'productsale_name',
      'closedmarket_password',
      'date_bgn',
      'date_end',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'promotion_stackable_flag'
    ],
    requiredCsv: ['shop_id', 'productsale_id']
  },
  [MasterType.W2_PRODUCT_SALE_PRICE]: {
    masterType: MasterType.W2_PRODUCT_SALE_PRICE,
    title: '商品セール価格マスター',
    columns: [
      { key: 'shop_id', label: '店舗ID', sortable: true },
      { key: 'productsale_id', label: '商品セールID', sortable: true },
      { key: 'product_id', label: '商品ID', sortable: true },
      { key: 'variation_id', label: '商品バリエーションID', sortable: true },
      { key: 'sale_price', label: '商品セール価格' },
      { key: 'display_order', label: '表示順' },
      { key: 'del_flg', label: '削除フラグ' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['shop_id', 'productsale_id', 'product_id', 'variation_id'],
    pkColumns: ['shop_id', 'productsale_id', 'product_id', 'variation_id'],
    csvHeaders: [
      'shop_id',
      'productsale_id',
      'product_id',
      'variation_id',
      'sale_price',
      'display_order',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['shop_id', 'productsale_id', 'product_id', 'variation_id']
  },
  [MasterType.W2_FIXED_PURCHASE]: {
    masterType: MasterType.W2_FIXED_PURCHASE,
    title: '定期購入情報',
    columns: [
      { key: 'fixed_purchase_id', label: '定期購入ID', sortable: true },
      { key: 'fixed_purchase_kbn', label: '定期購入区分' },
      { key: 'fixed_purchase_setting1', label: '定期購入設定１' },
      { key: 'base_tel_no', label: '元電話番号' },
      { key: 'fixed_purchase_status', label: '定期購入ステータス' },
      { key: 'payment_status', label: '決済ステータス' },
      { key: 'last_order_date', label: '最終購入日' },
      { key: 'order_count', label: '購入回数(注文基準)' },
      { key: 'user_id', label: 'ユーザID' },
      { key: 'shop_id', label: '店舗ID' }
    ],
    searchColumns: ['fixed_purchase_id'],
    pkColumns: ['fixed_purchase_id'],
    csvHeaders: [
      'fixed_purchase_id',
      'fixed_purchase_kbn',
      'fixed_purchase_setting1',
      'base_tel_no',
      'fixed_purchase_status',
      'payment_status',
      'last_order_date',
      'order_count',
      'user_id',
      'shop_id',
      'supplier_id',
      'order_kbn',
      'order_payment_kbn',
      'fixed_purchase_date_bgn',
      'card_kbn',
      'valid_flg',
      'del_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'credit_branch_no',
      'next_shipping_date',
      'next_next_shipping_date',
      'fixed_purchase_management_memo',
      'card_installments_code',
      'extend_status1',
      'extend_status2',
      'extend_status3',
      'extend_status4',
      'extend_status5',
      'extend_status6',
      'extend_status7',
      'extend_status8',
      'extend_status9',
      'extend_status10',
      'extend_status11',
      'extend_status12',
      'extend_status13',
      'extend_status14',
      'extend_status15',
      'extend_status16',
      'extend_status17',
      'extend_status18',
      'extend_status19',
      'extend_status20',
      'extend_status21',
      'extend_status22',
      'extend_status23',
      'extend_status24',
      'extend_status25',
      'extend_status26',
      'extend_status27',
      'extend_status28',
      'extend_status29',
      'extend_status30',
      'cancel_reason_id',
      'cancel_memo',
      'shipped_count',
      'extend_status31',
      'extend_status32',
      'extend_status33',
      'extend_status34',
      'extend_status35',
      'extend_status36',
      'extend_status37',
      'extend_status38',
      'extend_status39',
      'extend_status40',
      'combined_org_fixedpurchase_ids',
      'access_country_iso_code',
      'disp_language_code',
      'disp_language_locale_id',
      'disp_currency_code',
      'disp_currency_locale_id',
      'external_payment_agreement_id',
      'resume_date',
      'suspend_reason',
      'shipping_memo',
      'extend_status_date1',
      'extend_status_date2',
      'extend_status_date3',
      'extend_status_date4',
      'extend_status_date5',
      'extend_status_date6',
      'extend_status_date7',
      'extend_status_date8',
      'extend_status_date9',
      'extend_status_date10',
      'extend_status_date11',
      'extend_status_date12',
      'extend_status_date13',
      'extend_status_date14',
      'extend_status_date15',
      'extend_status_date16',
      'extend_status_date17',
      'extend_status_date18',
      'extend_status_date19',
      'extend_status_date20',
      'extend_status_date21',
      'extend_status_date22',
      'extend_status_date23',
      'extend_status_date24',
      'extend_status_date25',
      'extend_status_date26',
      'extend_status_date27',
      'extend_status_date28',
      'extend_status_date29',
      'extend_status_date30',
      'extend_status_date31',
      'extend_status_date32',
      'extend_status_date33',
      'extend_status_date34',
      'extend_status_date35',
      'extend_status_date36',
      'extend_status_date37',
      'extend_status_date38',
      'extend_status_date39',
      'extend_status_date40',
      'cancel_date',
      'restart_date',
      'memo',
      'next_shipping_use_coupon_id',
      'next_shipping_use_coupon_no',
      'receipt_flg',
      'receipt_address',
      'receipt_proviso',
      'skipped_count',
      'extend_status41',
      'extend_status42',
      'extend_status43',
      'extend_status44',
      'extend_status45',
      'extend_status46',
      'extend_status47',
      'extend_status48',
      'extend_status49',
      'extend_status50',
      'extend_status_date41',
      'extend_status_date42',
      'extend_status_date43',
      'extend_status_date44',
      'extend_status_date45',
      'extend_status_date46',
      'extend_status_date47',
      'extend_status_date48',
      'extend_status_date49',
      'extend_status_date50',
      'attribute1',
      'attribute2',
      'attribute3',
      'attribute4',
      'attribute5',
      'attribute6',
      'attribute7',
      'attribute8',
      'attribute9',
      'attribute10',
      'use_all_point_flg',
      'next_use_point_amount'
    ],
    requiredCsv: ['fixed_purchase_id']
  },
  [MasterType.W2_FIXED_PURCHASE_ITEM]: {
    masterType: MasterType.W2_FIXED_PURCHASE_ITEM,
    title: '定期購入商品情報',
    columns: [
      { key: 'fixed_purchase_id', label: '定期購入ID', sortable: true },
      { key: 'fixed_purchase_item_no', label: '定期購入注文商品枝番', sortable: true },
      { key: 'fixed_purchase_shipping_no', label: '定期購入配送先枝番' },
      { key: 'shop_id', label: '店舗ID' },
      { key: 'product_id', label: '商品ID' },
      { key: 'variation_id', label: '商品バリエーションID' },
      { key: 'supplier_id', label: 'サプライヤID' },
      { key: 'item_quantity', label: '注文数' },
      { key: 'item_quantity_single', label: '注文数（セット未考慮）' },
      { key: 'product_set_id', label: '商品セットID' }
    ],
    searchColumns: ['fixed_purchase_id', 'fixed_purchase_item_no'],
    pkColumns: ['fixed_purchase_id', 'fixed_purchase_item_no'],
    csvHeaders: [
      'fixed_purchase_id',
      'fixed_purchase_item_no',
      'fixed_purchase_shipping_no',
      'shop_id',
      'product_id',
      'variation_id',
      'supplier_id',
      'item_quantity',
      'item_quantity_single',
      'product_set_id',
      'product_set_no',
      'product_set_count',
      'date_created',
      'date_changed',
      'product_option_texts',
      'item_order_count',
      'item_shipped_count',
      'next_time_delivery_status',
      'conditional_item_quantity',
      'composite_type'
    ],
    requiredCsv: ['fixed_purchase_id', 'fixed_purchase_item_no']
  },
  [MasterType.W2_FIXED_PURCHASE_HISTORY]: {
    masterType: MasterType.W2_FIXED_PURCHASE_HISTORY,
    title: '定期購入履歴情報',
    columns: [
      { key: 'fixed_purchase_id', label: '定期購入ID', sortable: true },
      { key: 'fixed_purchase_history_no', label: '定期購入注文履歴NO', sortable: true },
      { key: 'fixed_purchase_history_kbn', label: '定期購入履歴区分' },
      { key: 'base_tel_no', label: '元電話番号' },
      { key: 'user_id', label: 'ユーザID' },
      { key: 'order_id', label: '注文ID' },
      { key: 'date_created', label: '作成日' },
      { key: 'last_changed', label: '最終更新者' },
      { key: 'update_order_count', label: '購入回数(注文基準)更新' },
      { key: 'update_shipped_count', label: '購入回数(出荷基準)更新' }
    ],
    searchColumns: ['fixed_purchase_id', 'fixed_purchase_history_no'],
    pkColumns: ['fixed_purchase_id', 'fixed_purchase_history_no'],
    csvHeaders: [
      'fixed_purchase_id',
      'fixed_purchase_history_no',
      'fixed_purchase_history_kbn',
      'base_tel_no',
      'user_id',
      'order_id',
      'date_created',
      'last_changed',
      'update_order_count',
      'update_shipped_count',
      'update_order_count_result',
      'update_shipped_count_result',
      'external_payment_cooperation_log'
    ],
    requiredCsv: ['fixed_purchase_id', 'fixed_purchase_history_no']
  },
  [MasterType.W2_FIXED_PURCHASE_CANCEL_REASON]: {
    masterType: MasterType.W2_FIXED_PURCHASE_CANCEL_REASON,
    title: '定期解約理由区分設定',
    columns: [
      { key: 'cancel_reason_id', label: '解約理由区分ID', sortable: true },
      { key: 'cancel_reason_name', label: '解約理由区分名' },
      { key: 'display_order', label: '表示順' },
      { key: 'display_kbn', label: '表示区分' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '更新者' }
    ],
    searchColumns: ['cancel_reason_id'],
    pkColumns: ['cancel_reason_id'],
    csvHeaders: [
      'cancel_reason_id',
      'cancel_reason_name',
      'display_order',
      'display_kbn',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['cancel_reason_id']
  },
  [MasterType.W2_USER_COUPON]: {
    masterType: MasterType.W2_USER_COUPON,
    title: 'ユーザクーポンテーブル',
    columns: [
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'dept_id', label: '識別ID', sortable: true },
      { key: 'coupon_id', label: 'クーポンID', sortable: true },
      { key: 'coupon_no', label: '枝番', sortable: true },
      { key: 'order_id', label: '注文ID' },
      { key: 'use_flg', label: '利用フラグ' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' },
      { key: 'user_coupon_count', label: 'ユーザークーポン利用可能回数' }
    ],
    searchColumns: ['user_id', 'dept_id', 'coupon_id', 'coupon_no'],
    pkColumns: ['user_id', 'dept_id', 'coupon_id', 'coupon_no'],
    csvHeaders: [
      'user_id',
      'dept_id',
      'coupon_id',
      'coupon_no',
      'order_id',
      'use_flg',
      'date_created',
      'date_changed',
      'last_changed',
      'user_coupon_count',
      'cooperation_id',
      'cooperation_type',
      'temp_coupon_flg',
      'source_popup_id'
    ],
    requiredCsv: ['user_id', 'dept_id', 'coupon_id', 'coupon_no']
  },
  [MasterType.W2_USER_COUPON_HISTORY]: {
    masterType: MasterType.W2_USER_COUPON_HISTORY,
    title: 'ユーザクーポン履歴テーブル',
    columns: [
      { key: 'user_id', label: 'ユーザID', sortable: true },
      { key: 'history_no', label: '枝番', sortable: true },
      { key: 'dept_id', label: '識別ID' },
      { key: 'coupon_id', label: 'クーポンID' },
      { key: 'coupon_code', label: 'クーポンコード' },
      { key: 'order_id', label: '注文ID' },
      { key: 'history_kbn', label: 'クーポン履歴区分' },
      { key: 'action_kbn', label: '操作区分' },
      { key: 'coupon_inc', label: '加算数' },
      { key: 'coupon_price', label: 'クーポン金額' }
    ],
    searchColumns: ['user_id', 'history_no'],
    pkColumns: ['user_id', 'history_no'],
    csvHeaders: [
      'user_id',
      'history_no',
      'dept_id',
      'coupon_id',
      'coupon_code',
      'order_id',
      'history_kbn',
      'action_kbn',
      'coupon_inc',
      'coupon_price',
      'memo',
      'date_created',
      'last_changed',
      'user_coupon_count',
      'fixed_purchase_id'
    ],
    requiredCsv: ['user_id', 'history_no']
  },
  [MasterType.W2_COUPON_USE_USER]: {
    masterType: MasterType.W2_COUPON_USE_USER,
    title: 'クーポン利用ユーザーテーブル',
    columns: [
      { key: 'coupon_id', label: 'クーポンID', sortable: true },
      { key: 'coupon_use_user', label: 'クーポン利用ユーザー', sortable: true },
      { key: 'branch_no', label: 'クーポン利用枝番', sortable: true },
      { key: 'order_id', label: '注文ID' },
      { key: 'date_created', label: '作成日' },
      { key: 'last_changed', label: '最終更新者' },
      { key: 'fixed_purchase_id', label: '定期購入ID' }
    ],
    searchColumns: ['coupon_id', 'coupon_use_user', 'branch_no'],
    pkColumns: ['coupon_id', 'coupon_use_user', 'branch_no'],
    csvHeaders: [
      'coupon_id',
      'coupon_use_user',
      'order_id',
      'date_created',
      'last_changed',
      'fixed_purchase_id',
      'branch_no'
    ],
    requiredCsv: ['coupon_id', 'coupon_use_user', 'branch_no']
  },
  [MasterType.W2_COUPON_SCHEDULE]: {
    masterType: MasterType.W2_COUPON_SCHEDULE,
    title: 'クーポン発行スケジュールテーブル',
    columns: [
      { key: 'coupon_schedule_id', label: 'クーポン発行スケジュールID', sortable: true },
      { key: 'coupon_schedule_name', label: 'クーポン発行スケジュール名' },
      { key: 'status', label: 'ステータス' },
      { key: 'last_count', label: '最終付与人数' },
      { key: 'last_exec_date', label: '最終付与日時' },
      { key: 'target_id', label: 'ターゲットID' },
      { key: 'target_extract_flg', label: 'ターゲット抽出フラグ' },
      { key: 'coupon_id', label: 'クーポン発行ID' },
      { key: 'publish_quantity', label: 'クーポン発行枚数' },
      { key: 'mail_id', label: 'メールテンプレートID' }
    ],
    searchColumns: ['coupon_schedule_id'],
    pkColumns: ['coupon_schedule_id'],
    csvHeaders: [
      'coupon_schedule_id',
      'coupon_schedule_name',
      'status',
      'last_count',
      'last_exec_date',
      'target_id',
      'target_extract_flg',
      'coupon_id',
      'publish_quantity',
      'mail_id',
      'exec_timing',
      'schedule_kbn',
      'schedule_day_of_week',
      'schedule_year',
      'schedule_month',
      'schedule_day',
      'schedule_hour',
      'schedule_minute',
      'schedule_second',
      'valid_flg',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['coupon_schedule_id']
  },
  [MasterType.W2_ADV_CODE_LOG]: {
    masterType: MasterType.W2_ADV_CODE_LOG,
    title: '広告コード流入ログ',
    columns: [
      { key: 'advcodelog_no', label: '広告コードログNO', sortable: true },
      { key: 'access_date', label: '日付' },
      { key: 'access_time', label: '時間' },
      { key: 'advertisement_code', label: '広告コード' },
      { key: 'access_user_id', label: 'アクセスユーザID' }
    ],
    searchColumns: ['advcodelog_no'],
    pkColumns: ['advcodelog_no'],
    csvHeaders: [
      'advcodelog_no',
      'access_date',
      'access_time',
      'advertisement_code',
      'access_user_id'
    ],
    requiredCsv: ['advcodelog_no']
  },
  [MasterType.W2_ADV_CODE_MEDIA_TYPE]: {
    masterType: MasterType.W2_ADV_CODE_MEDIA_TYPE,
    title: '広告媒体区分マスター',
    columns: [
      { key: 'advcode_media_type_id', label: '広告媒体区分', sortable: true },
      { key: 'advcode_media_type_name', label: '媒体区分名' },
      { key: 'display_order', label: '表示順' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['advcode_media_type_id'],
    pkColumns: ['advcode_media_type_id'],
    csvHeaders: [
      'advcode_media_type_id',
      'advcode_media_type_name',
      'display_order',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['advcode_media_type_id']
  },
  [MasterType.W2_USER_ACTIVITY]: {
    masterType: MasterType.W2_USER_ACTIVITY,
    title: 'ユーザーアクティビティ',
    columns: [
      { key: 'user_id', label: 'ユーザーID', sortable: true },
      { key: 'master_kbn', label: 'マスターー区分', sortable: true },
      { key: 'master_id', label: 'マスターーID', sortable: true },
      { key: 'date', label: '日付' },
      { key: 'tgt_year', label: '対象年' },
      { key: 'tgt_month', label: '対象月' },
      { key: 'tgt_day', label: '対象日' }
    ],
    searchColumns: ['user_id', 'master_kbn', 'master_id'],
    pkColumns: ['user_id', 'master_kbn', 'master_id'],
    csvHeaders: ['user_id', 'master_kbn', 'master_id', 'date', 'tgt_year', 'tgt_month', 'tgt_day'],
    requiredCsv: ['user_id', 'master_kbn', 'master_id']
  },
  [MasterType.W2_AB_TEST]: {
    masterType: MasterType.W2_AB_TEST,
    title: 'A/Bテスト',
    columns: [
      { key: 'ab_test_id', label: 'ABテストID', sortable: true },
      { key: 'ab_test_title', label: 'ABテストタイトル' },
      { key: 'public_status', label: '公開ステータス' },
      { key: 'public_start_datetime', label: '公開開始日時' },
      { key: 'public_end_datetime', label: '公開終了日時' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['ab_test_id'],
    pkColumns: ['ab_test_id'],
    csvHeaders: [
      'ab_test_id',
      'ab_test_title',
      'public_status',
      'public_start_datetime',
      'public_end_datetime',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['ab_test_id']
  },
  [MasterType.W2_AB_TEST_ITEM]: {
    masterType: MasterType.W2_AB_TEST_ITEM,
    title: 'A/Bテストアイテム',
    columns: [
      { key: 'ab_test_id', label: 'ABテストID', sortable: true },
      { key: 'item_no', label: 'アイテム番号', sortable: true },
      { key: 'page_id', label: 'ページID' },
      { key: 'distribution_rate', label: '出し分け比率' }
    ],
    searchColumns: ['ab_test_id', 'item_no'],
    pkColumns: ['ab_test_id', 'item_no'],
    csvHeaders: ['ab_test_id', 'item_no', 'page_id', 'distribution_rate'],
    requiredCsv: ['ab_test_id', 'item_no']
  },
  [MasterType.W2_PAGE_DESIGN]: {
    masterType: MasterType.W2_PAGE_DESIGN,
    title: 'ページデザイン ページ管理',
    columns: [
      { key: 'page_id', label: '識別ID', sortable: true },
      { key: 'management_title', label: '管理用タイトル' },
      { key: 'file_name', label: 'ファイル名' },
      { key: 'pc_file_dir_path', label: 'PCディレクトリパス' },
      { key: 'page_type', label: 'タイプ' },
      { key: 'group_id', label: 'グループ識別ID' },
      { key: 'use_type', label: 'ページの利用状態' },
      { key: 'publish', label: 'ページの公開状態' },
      { key: 'condition_publish_date_from', label: '公開開始日' },
      { key: 'condition_publish_date_to', label: '公開終了日' },
      { key: 'date_changed', label: '更新日' }
    ],
    searchColumns: ['page_id', 'management_title', 'file_name', 'pc_file_dir_path', 'group_id'],
    pkColumns: ['page_id'],
    csvHeaders: [
      'page_id',
      'management_title',
      'page_type',
      'file_name',
      'pc_file_dir_path',
      'group_id',
      'page_sort_number',
      'use_type',
      'publish',
      'condition_publish_date_from',
      'condition_publish_date_to',
      'condition_member_only_type',
      'condition_member_rank_id',
      'condition_target_list_type',
      'condition_target_list_ids',
      'date_created',
      'date_changed',
      'last_changed',
      'metadata_desc',
      'file_time_stamp',
      'sitemap_include',
      'sitemap_changefreq',
      'sitemap_priority'
    ],
    requiredCsv: ['page_id']
  },
  [MasterType.W2_PAGE_DESIGN_GROUP]: {
    masterType: MasterType.W2_PAGE_DESIGN_GROUP,
    title: 'ページデザイン グループマスター',
    columns: [
      { key: 'group_id', label: '識別ID', sortable: true },
      { key: 'group_name', label: 'グループ名' },
      { key: 'group_sort_number', label: 'グループ順序' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['group_id', 'group_name'],
    pkColumns: ['group_id'],
    csvHeaders: [
      'group_id',
      'group_name',
      'group_sort_number',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['group_id']
  },
  [MasterType.W2_PARTS_DESIGN]: {
    masterType: MasterType.W2_PARTS_DESIGN,
    title: 'パーツデザイン パーツ管理',
    columns: [
      { key: 'parts_id', label: '識別ID', sortable: true },
      { key: 'management_title', label: '管理用タイトル' },
      { key: 'file_name', label: 'ファイル名' },
      { key: 'pc_file_dir_path', label: 'PCディレクトリパス' },
      { key: 'parts_type', label: 'タイプ' },
      { key: 'group_id', label: 'グループ識別ID' },
      { key: 'area_id', label: '特集エリアID' },
      { key: 'use_type', label: 'パーツの利用状態' },
      { key: 'publish', label: 'パーツの公開状態' },
      { key: 'date_changed', label: '更新日' }
    ],
    searchColumns: [
      'parts_id',
      'management_title',
      'file_name',
      'pc_file_dir_path',
      'group_id',
      'area_id'
    ],
    pkColumns: ['parts_id'],
    csvHeaders: [
      'parts_id',
      'management_title',
      'parts_type',
      'file_name',
      'pc_file_dir_path',
      'group_id',
      'parts_sort_number',
      'use_type',
      'publish',
      'condition_publish_date_from',
      'condition_publish_date_to',
      'condition_member_only_type',
      'condition_member_rank_id',
      'condition_target_list_type',
      'condition_target_list_ids',
      'date_created',
      'date_changed',
      'last_changed',
      'area_id',
      'file_time_stamp',
      'vue_component_id'
    ],
    requiredCsv: ['parts_id']
  },
  [MasterType.W2_PARTS_DESIGN_GROUP]: {
    masterType: MasterType.W2_PARTS_DESIGN_GROUP,
    title: 'パーツデザイン グループマスター',
    columns: [
      { key: 'group_id', label: '識別ID', sortable: true },
      { key: 'group_name', label: 'グループ名' },
      { key: 'group_sort_number', label: 'グループ順序' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' },
      { key: 'last_changed', label: '最終更新者' }
    ],
    searchColumns: ['group_id', 'group_name'],
    pkColumns: ['group_id'],
    csvHeaders: [
      'group_id',
      'group_name',
      'group_sort_number',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['group_id']
  },
  [MasterType.W2_FEATURE_AREA]: {
    masterType: MasterType.W2_FEATURE_AREA,
    title: '特集エリアマスター',
    columns: [
      { key: 'area_id', label: '特集エリアID', sortable: true },
      { key: 'area_name', label: '特集エリア名' },
      { key: 'area_type_id', label: '特集エリアタイプ' },
      { key: 'internal_memo', label: '内部用メモ' },
      { key: 'side_max_count', label: '横並び最大数' },
      { key: 'slider_count', label: 'スライド数' },
      { key: 'date_created', label: '作成日' },
      { key: 'date_changed', label: '更新日' }
    ],
    searchColumns: ['area_id', 'area_name', 'area_type_id', 'internal_memo'],
    pkColumns: ['area_id'],
    csvHeaders: [
      'area_id',
      'area_name',
      'area_type_id',
      'internal_memo',
      'side_max_count',
      'side_turn',
      'slider_count',
      'slider_scroll_count',
      'slider_scroll_auto',
      'slider_scroll_interval',
      'slider_arrow',
      'slider_dot',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['area_id']
  },
  [MasterType.W2_FEATURE_AREA_BANNER]: {
    masterType: MasterType.W2_FEATURE_AREA_BANNER,
    title: '特集エリアバナー',
    columns: [
      { key: 'area_id', label: '特集エリアID', sortable: true },
      { key: 'banner_no', label: '特集エリアバナーNo', sortable: true },
      { key: 'file_name', label: 'ファイル名' },
      { key: 'file_dir_path', label: 'ディレクトリパス' },
      { key: 'alt_text', label: '代替テキスト' },
      { key: 'text', label: 'テキスト' },
      { key: 'link_url', label: 'リンク' },
      { key: 'publish', label: '公開状態' },
      { key: 'condition_publish_date_from', label: '公開開始日' },
      { key: 'condition_publish_date_to', label: '公開終了日' }
    ],
    searchColumns: ['area_id', 'banner_no', 'file_name', 'alt_text', 'text', 'link_url'],
    pkColumns: ['area_id', 'banner_no'],
    csvHeaders: [
      'area_id',
      'banner_no',
      'file_name',
      'file_dir_path',
      'alt_text',
      'text',
      'link_url',
      'window_type',
      'publish',
      'condition_publish_date_from',
      'condition_publish_date_to',
      'condition_member_only_type',
      'condition_member_rank_id',
      'condition_target_list_type',
      'condition_target_list_ids',
      'date_created'
    ],
    requiredCsv: ['area_id', 'banner_no']
  },
  [MasterType.W2_POPUP]: {
    masterType: MasterType.W2_POPUP,
    title: 'ポップアップ',
    columns: [
      { key: 'popup_id', label: 'ポップアップID', sortable: true },
      { key: 'popup_name', label: 'ポップアップ名' },
      { key: 'popup_type', label: 'ポップアップタイプ' },
      { key: 'public_status', label: '公開状態' },
      { key: 'public_start_datetime', label: '公開開始日時' },
      { key: 'public_end_datetime', label: '公開終了日時' },
      { key: 'condition_member_only_type', label: '会員限定コンテンツ' },
      { key: 'condition_available_device', label: '利用デバイス' },
      { key: 'display_trigger_setting_type', label: '表示トリガータイプ' },
      { key: 'display_priority', label: '表示優先順' },
      { key: 'date_changed', label: '更新日' }
    ],
    searchColumns: ['popup_id', 'popup_name', 'popup_type', 'public_status'],
    pkColumns: ['popup_id'],
    csvHeaders: [
      'popup_id',
      'popup_name',
      'popup_type',
      'public_status',
      'public_start_datetime',
      'public_end_datetime',
      'condition_member_only_type',
      'condition_member_rank_id',
      'condition_target_list_type',
      'condition_target_list_ids',
      'condition_advertisement_codes',
      'condition_available_device',
      'display_trigger_setting_type',
      'display_trigger_setting_value',
      'display_priority',
      'design_setting',
      'contents_setting',
      'date_created',
      'date_changed',
      'last_changed'
    ],
    requiredCsv: ['popup_id']
  },
  [MasterType.W2_POPUP_DISPLAY_PAGE_SETTING]: {
    masterType: MasterType.W2_POPUP_DISPLAY_PAGE_SETTING,
    title: 'ポップアップ表示ページ設定',
    columns: [
      { key: 'popup_id', label: 'ポップアップID', sortable: true },
      { key: 'type', label: 'タイプ', sortable: true },
      { key: 'data_no', label: 'データNo', sortable: true },
      { key: 'target_page', label: '任意指定のページ' },
      { key: 'product_id', label: '商品ID' },
      { key: 'category_id', label: 'カテゴリID' },
      { key: 'page_id', label: 'LPページID' },
      { key: 'brand_id', label: 'ブランドID' },
      { key: 'target_url', label: 'URL' }
    ],
    searchColumns: ['popup_id', 'type', 'product_id', 'category_id', 'brand_id', 'target_url'],
    pkColumns: ['popup_id', 'type', 'data_no'],
    csvHeaders: [
      'popup_id',
      'type',
      'data_no',
      'target_page',
      'product_id',
      'category_id',
      'page_id',
      'brand_id',
      'target_url'
    ],
    requiredCsv: ['popup_id', 'type', 'data_no']
  },
  [MasterType.W2_POPUP_REPORT]: {
    masterType: MasterType.W2_POPUP_REPORT,
    title: 'ポップアップレポート',
    columns: [
      { key: 'data_no', label: 'データNO', sortable: true },
      { key: 'date', label: '日付' },
      { key: 'tgt_year', label: '対象年' },
      { key: 'tgt_month', label: '対象月' },
      { key: 'tgt_day', label: '対象日' },
      { key: 'report_type', label: 'レポートタイプ' },
      { key: 'access_kbn', label: 'アクセス区分' },
      { key: 'popup_id', label: 'ポップアップID' },
      { key: 'count', label: 'カウント' }
    ],
    searchColumns: ['popup_id', 'report_type', 'access_kbn'],
    pkColumns: ['data_no'],
    csvHeaders: [
      'data_no',
      'date',
      'tgt_year',
      'tgt_month',
      'tgt_day',
      'report_type',
      'access_kbn',
      'popup_id',
      'count'
    ],
    requiredCsv: ['data_no']
  }
}
